import { $c as storyLocatorToKey, Ac as TrackDeleteMarkName, Ao as DecorationSet, At as applyTrackedMutationMeta, Ba as undoDepth, Bc as buildStructuralReceipt, Bo as findParentNodeClosestToPos, Ca as getRevision, Ci as groupIdentityEntriesByValue, Cr as mapBlockNodeType, Dr as buildFallbackBlockNodeId, Dt as rejectTrackedMode, Ei as kebabCase, Er as toBlockAddress, Et as ensureTrackedCapability, Fa as closeHistory, Fr as findInlineByAnchor, Ga as getActiveFormatting, Gc as isPublicMutationStepOp, Gn as addDiagnostic, Ha as isInTable, Jn as insertParagraphAtEnd, Jo as AllSelection, Lr as isInlineQueryType, Mc as TrackInsertMarkName, Mr as toId, Oa as planError, Or as resolvePublicTocNodeId, Ot as requireEditorCommand, Pa as yUndoPluginKey, Pc as generateDocxRandomId, Pt as resolveHeaderFooterRelsPartIdFromRefId, Qo as PluginKey, Qr as parseStoryKey, Ra as redoDepth, Rc as isStructuralReplaceInput, Ri as isStructuredContentNodeType, Sa as checkRevision, Si as getExplicitIdentityEntries, Sl as getExtensionConfigField, Sr as isTextBlockCandidate, Ui as markdownToPmFragment, Vc as textReceiptToSDReceipt, Xo as NodeSelection, Yc as INLINE_PROPERTY_BY_KEY, Yn as paginate, Yr as DocumentApiAdapterError, Zn as resolveDefaultInsertTarget, Zo as Plugin, _a as findOrCreateRelationship, _l as Fragment, _r as findBlockById, ar as readTextAtResolvedRange, as as ReplaceStep, bn as resolveSectionProjections, br as findBlockByPos, cl as MAX_PLAN_STEPS, cr as textBetweenWithTabs, ct as resolveStoryRuntime, dr as resolveTextRangeInBlock, el as DEFAULT_NESTING_POLICY, er as resolveWithinScope, es as TextSelection, fl as DocumentApiValidationError, fr as textContentInBlock, gn as compoundMutation, hr as getInlineIndex, il as buildResolvedHandle, io as getResolvedParagraphProperties, ir as buildTextMutationResolution, is as ReplaceAroundStep, jc as TrackFormatMarkName, kc as getUnderlineCssString, ko as Decoration, kt as applyDirectMutationMeta, ll as MARK_KEYS, ma as isList, ml as simpleStringHash, mr as getBlockIndex, nl as buildDiscoveryItem, nr as scopeByRange, nt as getTrackChanges, or as buildTextWithTabs, pr as clearIndexCache, qa as getFormattingStateAtPos, qn as findCandidateByPos, qr as process$1, rl as buildDiscoveryResult, ro as calculateResolvedParagraphProperties, sa as numberingInfoToOrderedStyle, sl as MAX_PLAN_RESOLVED_TARGETS, sr as parentAllowsNodeAt, tl as DEFAULT_PLACEMENT, tr as resolveWriteTarget, ur as pmPositionToTextOffset, vr as findBlockByIdStrict, wr as resolveBlockAlias, xi as createDeterministicDocxIdAllocator, xl as callOrGet, xr as getHeadingLevel, yl as Slice, yr as findBlockByNodeIdOnly, zc as isStructuralInsertInput, zo as findParentNode } from "./SuperConverter-BBOL1zJ-.es.js";
import { n as v4_default } from "./uuid-B2wVPhPi.es.js";
import { J as isRelativeUrl, R as twipsToLines, Y as isValidImageDataUrl, Z as tryDecodeDataUriText, q as getDataUriMetadata } from "./constants-D9qj59G2.es.js";
import { t as Buffer } from "./dist-B8HfvhaK.es.js";
var CSS_DIMENSION_REGEX = /[\d-.]+(\w+)$/;
var DOM_SIZE_UNITS = [
	"px",
	"rem",
	"em",
	"in",
	"q",
	"mm",
	"cm",
	"pt",
	"pc",
	"vh",
	"vw",
	"vmin",
	"vmax"
];
function parseSizeUnit(val = "0") {
	const length = val.toString() || "0";
	const value = Number.parseFloat(length);
	const unit = (length.match(CSS_DIMENSION_REGEX)?.[1] ?? "").toLowerCase();
	return [value, DOM_SIZE_UNITS.includes(unit) ? unit : null];
}
const normalizeActorId = (value) => {
	if (typeof value !== "string") return "";
	return value.trim();
};
const normalizeActorEmail = (value) => {
	if (typeof value !== "string") return "";
	const trimmed = value.trim();
	if (!trimmed) return "";
	return trimmed.toLowerCase();
};
const normalizeActorName = (value) => {
	if (typeof value !== "string") return "";
	const trimmed = value.trim();
	if (!trimmed) return "";
	return trimmed.toLowerCase();
};
const getActorIdentity = (value) => {
	const record = value ?? {};
	const id = normalizeActorId(record.id);
	const email = normalizeActorEmail(record.email);
	return {
		id,
		email,
		name: typeof record.name === "string" ? record.name : "",
		hasId: id.length > 0,
		hasEmail: email.length > 0
	};
};
const actorIdentitiesMatch = ({ current, other }) => {
	const currentIdentity = getActorIdentity(current);
	const otherIdentity = getActorIdentity(other);
	if (currentIdentity.hasId && otherIdentity.hasId) return currentIdentity.id === otherIdentity.id;
	if (currentIdentity.hasEmail && otherIdentity.hasEmail) return currentIdentity.email === otherIdentity.email;
	return false;
};
const getActorIdentityKey = ({ actor, fallbackKey = "" }) => {
	const identity = getActorIdentity(actor);
	if (identity.hasId) return `id:${identity.id}`;
	if (identity.hasEmail) return `email:${identity.email}`;
	const fallback = typeof fallbackKey === "number" ? String(fallbackKey) : typeof fallbackKey === "string" ? fallbackKey.trim() : "";
	if (fallback) return `fallback:${fallback}`;
	return "";
};
var Extension = class Extension {
	constructor(config) {
		this.type = "extension";
		this.name = "extension";
		this.config = {
			...config,
			name: config.name || this.name
		};
		this.name = this.config.name;
		if (this.config.addOptions) this.options = callOrGet(getExtensionConfigField(this, "addOptions", { name: this.name })) || {};
		else this.options = {};
		this.storage = callOrGet(getExtensionConfigField(this, "addStorage", {
			name: this.name,
			options: this.options
		})) || {};
	}
	static create(config) {
		return new Extension(config);
	}
};
const CustomSelectionPluginKey = new PluginKey("CustomSelection");
const DEFAULT_CUSTOM_SELECTION_STATE = Object.freeze({
	focused: false,
	preservedSelection: null,
	showVisualSelection: false,
	skipFocusReset: false
});
function getPreservedSelection(state) {
	return CustomSelectionPluginKey.getState(state)?.preservedSelection ?? null;
}
function getSelectedTextRange(state) {
	const { selection } = state;
	let from = null;
	let to = null;
	state.doc.nodesBetween(selection.from, selection.to, (node, pos) => {
		if (!node.isText || !node.text) return;
		const start = pos;
		const end = pos + node.nodeSize;
		from = from == null ? start : Math.min(from, start);
		to = to == null ? end : Math.max(to, end);
	});
	return from == null || to == null ? null : {
		from,
		to
	};
}
function prepareSelectionForTextInputHandoff(editor) {
	const state = editor?.view?.state ?? editor?.state;
	const dispatch = typeof editor?.view?.dispatch === "function" ? editor.view.dispatch.bind(editor.view) : typeof editor?.dispatch === "function" ? editor.dispatch.bind(editor) : null;
	if (!state || !dispatch) return false;
	let tr = state.tr.setMeta(CustomSelectionPluginKey, DEFAULT_CUSTOM_SELECTION_STATE);
	if (state.selection instanceof AllSelection) {
		const range = getSelectedTextRange(state);
		if (range) try {
			tr = tr.setSelection(TextSelection.create(tr.doc, range.from, range.to));
		} catch {}
	}
	dispatch(tr);
	editor?.setOptions?.({
		preservedSelection: null,
		lastSelection: null
	});
	return true;
}
var InclusiveTextSelectionBookmark = class InclusiveTextSelectionBookmark {
	constructor(anchor, head) {
		this.anchor = anchor;
		this.head = head;
	}
	map(mapping) {
		const isForward = this.anchor <= this.head;
		return new InclusiveTextSelectionBookmark(mapping.map(this.anchor, isForward ? -1 : 1), mapping.map(this.head, isForward ? 1 : -1));
	}
	resolve(doc) {
		return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head));
	}
};
function createSelectionTrackingBookmark(selection) {
	if (selection instanceof TextSelection && !selection.empty) return new InclusiveTextSelectionBookmark(selection.anchor, selection.head);
	return selection.getBookmark();
}
var nextHandleId = 1;
const SelectionHandlePluginKey = new PluginKey("selectionHandle");
function createSelectionHandlePlugin() {
	return new Plugin({
		key: SelectionHandlePluginKey,
		state: {
			init() {
				return { entries: /* @__PURE__ */ new Map() };
			},
			apply(tr, prev) {
				const meta = tr.getMeta(SelectionHandlePluginKey);
				let entries = prev.entries;
				if (tr.docChanged && entries.size > 0) {
					const next = /* @__PURE__ */ new Map();
					for (const [id, entry] of entries) next.set(id, {
						...entry,
						bookmark: entry.bookmark.map(tr.mapping)
					});
					entries = next;
				}
				if (meta?.action === "capture") {
					if (entries === prev.entries) entries = new Map(entries);
					entries.set(meta.entry.id, meta.entry);
				} else if (meta?.action === "release") {
					if (entries.has(meta.id)) {
						if (entries === prev.entries) entries = new Map(entries);
						entries.delete(meta.id);
					}
				}
				return entries === prev.entries ? prev : { entries };
			}
		}
	});
}
function captureSelectionHandle(owner, selection, surface) {
	const id = nextHandleId++;
	const bookmark = createSelectionTrackingBookmark(selection);
	const wasNonEmpty = !selection.empty;
	const entry = {
		id,
		bookmark,
		wasNonEmpty
	};
	const tr = owner.state.tr.setMeta(SelectionHandlePluginKey, {
		action: "capture",
		entry
	});
	owner.dispatch(tr);
	return {
		id,
		surface,
		wasNonEmpty,
		_owner: owner
	};
}
function resolveHandleToSelection(handle) {
	const { state } = handle._owner;
	const pluginState = SelectionHandlePluginKey.getState(state);
	if (!pluginState) return null;
	const entry = pluginState.entries.get(handle.id);
	if (!entry) return null;
	const resolved = entry.bookmark.resolve(state.doc);
	if (entry.wasNonEmpty && resolved.empty) return null;
	return resolved;
}
function releaseSelectionHandle(handle) {
	const { state, dispatch } = handle._owner;
	dispatch(state.tr.setMeta(SelectionHandlePluginKey, {
		action: "release",
		id: handle.id
	}));
}
function mapDisplayAlignmentToStoredJustification(alignment, isRtl) {
	if (alignment === "justify") return "both";
	if (!isRtl) return alignment;
	if (alignment === "left") return "right";
	if (alignment === "right") return "left";
	return alignment;
}
function mapStoredJustificationToDisplayAlignment(justification, isRtl) {
	if (!justification) return isRtl ? "right" : "left";
	if (justification === "both") return "justify";
	if (!isRtl) return justification;
	if (justification === "left") return "right";
	if (justification === "right") return "left";
	return justification;
}
function isContentLockedMode(lockMode) {
	return lockMode === "contentLocked" || lockMode === "sdtContentLocked";
}
function isSdtLockedMode(lockMode) {
	return lockMode === "sdtLocked" || lockMode === "sdtContentLocked";
}
var DEFAULT_MIME_TYPE = "application/octet-stream";
var MIME_TYPE_TO_EXTENSION = {
	"image/svg+xml": "svg",
	"image/jpeg": "jpg",
	"image/jpg": "jpg",
	"image/tiff": "tif",
	"image/tif": "tif",
	"image/x-icon": "ico",
	"image/vnd.microsoft.icon": "ico",
	"image/ico": "ico"
};
var getImageExtensionFromMimeType = (mimeType) => {
	const normalizedMimeType = String(mimeType || "").toLowerCase();
	if (MIME_TYPE_TO_EXTENSION[normalizedMimeType]) return MIME_TYPE_TO_EXTENSION[normalizedMimeType];
	const [type, subtype] = normalizedMimeType.split("/");
	if (type !== "image" || !subtype) return null;
	return subtype;
};
var decodeBase64ToBinaryString = (data) => {
	if (!data) return "";
	if (typeof atob === "function") return atob(data);
	if (typeof Buffer !== "undefined" && typeof Buffer.from === "function") return Buffer.from(data, "base64").toString("binary");
	throw new Error("Unable to decode base64 payload in the current environment.");
};
var binaryStringToBytes = (binaryString) => {
	const bytes = new Uint8Array(binaryString.length);
	for (let i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
	return bytes;
};
var extractBase64Meta = (dataUri) => {
	const metadata = getDataUriMetadata(dataUri);
	if (!metadata?.hasPayloadSeparator) return null;
	const mimeType = metadata?.rawMimeType || DEFAULT_MIME_TYPE;
	const isBase64 = Boolean(metadata?.isBase64);
	const payload = metadata?.payload || "";
	const binaryString = isBase64 ? decodeBase64ToBinaryString(payload) : tryDecodeDataUriText(payload);
	if (binaryString == null) return null;
	return {
		mimeType,
		binaryString,
		filename: `image-${simpleStringHash(binaryString)}.${getImageExtensionFromMimeType(metadata?.mimeType) || "bin"}`,
		isBase64
	};
};
const getBase64FileMeta = (dataUri) => {
	const meta = extractBase64Meta(dataUri);
	if (!meta) return {
		mimeType: DEFAULT_MIME_TYPE,
		filename: "image-0.bin"
	};
	const { mimeType, filename } = meta;
	return {
		mimeType,
		filename
	};
};
const base64ToFile = (dataUri) => {
	const meta = extractBase64Meta(dataUri);
	if (!meta) return null;
	const { mimeType, binaryString, filename, isBase64 } = meta;
	const fileType = mimeType || DEFAULT_MIME_TYPE;
	const data = isBase64 ? binaryStringToBytes(binaryString) : binaryString;
	const blob = new Blob([data], { type: fileType });
	return new File([blob], filename, { type: fileType });
};
const urlToFile = async (url, filename, mimeType) => {
	try {
		const response = await fetch(url, {
			mode: "cors",
			credentials: "omit",
			headers: { Accept: "image/*,*/*;q=0.8" }
		});
		if (!response.ok) {
			console.warn(`Failed to fetch image from ${url}: ${response.status} ${response.statusText}`);
			return null;
		}
		const blob = await response.blob();
		const finalFilename = filename || extractFilenameFromUrl(url);
		const finalMimeType = mimeType || response.headers.get("content-type") || blob.type || "image/jpeg";
		return new File([blob], finalFilename, { type: finalMimeType });
	} catch (error) {
		if (isCorsError(error)) {
			console.warn(`CORS policy prevents accessing image from ${url}:`, error.message);
			return null;
		}
		console.error(`Error fetching image from ${url}:`, error);
		return null;
	}
};
var isCorsError = (error) => {
	const errorMessage = error.message.toLowerCase();
	return error.name.toLowerCase().includes("cors") || errorMessage.includes("cors") || errorMessage.includes("cross-origin") || errorMessage.includes("access-control") || errorMessage.includes("network error") || errorMessage.includes("failed to fetch");
};
var extractFilenameFromUrl = (url) => {
	try {
		const filename = new URL(url).pathname.split("/").pop();
		if (filename && !filename.includes(".")) return `${filename}.jpg`;
		return filename || "image.jpg";
	} catch {
		return "image.jpg";
	}
};
const validateUrlAccessibility = async (url) => {
	try {
		return (await fetch(url, {
			method: "HEAD",
			mode: "cors",
			credentials: "omit"
		})).ok;
	} catch {
		return false;
	}
};
const handleImageUpload = (file) => {
	return new Promise((resolve, reject) => {
		let reader = new FileReader();
		reader.onload = (event) => {
			resolve(event.target.result);
		};
		reader.onerror = reject;
		setTimeout(() => reader.readAsDataURL(file), 250);
	});
};
const processUploadedImage = (fileData, getMaxContentSize) => {
	return new Promise((resolve, reject) => {
		const img = new window.Image();
		img.onload = () => {
			const canvas = document.createElement("canvas");
			const { width: logicalWidth, height: logicalHeight } = getAllowedImageDimensions(img.width, img.height, getMaxContentSize);
			canvas.width = img.width;
			canvas.height = img.height;
			const ctx = canvas.getContext("2d");
			if (ctx) {
				ctx.imageSmoothingEnabled = true;
				try {
					ctx.imageSmoothingQuality = "high";
				} catch {}
			}
			ctx.drawImage(img, 0, 0, img.width, img.height);
			const dpr = typeof window !== "undefined" && window.devicePixelRatio ? window.devicePixelRatio : 1;
			const targetPixelWidth = Math.round(logicalWidth * dpr);
			const targetPixelHeight = Math.round(logicalHeight * dpr);
			const finalTargetWidth = Math.min(targetPixelWidth, img.width);
			const finalTargetHeight = Math.min(targetPixelHeight, img.height);
			if (finalTargetWidth !== img.width || finalTargetHeight !== img.height) multiStepResize(canvas, finalTargetWidth, finalTargetHeight);
			if (typeof fileData === "string") resolve(canvas.toDataURL());
			else canvas.toBlob((blob) => {
				resolve({
					file: new File([blob], fileData.name, {
						type: fileData.type,
						lastModified: Date.now()
					}),
					width: logicalWidth,
					height: logicalHeight
				});
			});
		};
		img.onerror = (error) => reject(error);
		img.src = typeof fileData === "string" ? fileData : URL.createObjectURL(fileData);
	});
};
const getAllowedImageDimensions = (width, height, getMaxContentSize) => {
	const { width: maxWidth, height: maxHeight } = getMaxContentSize();
	if (!maxWidth || !maxHeight) return {
		width,
		height
	};
	let adjustedWidth = width;
	let adjustedHeight = height;
	const aspectRatio = width / height;
	if (height > maxHeight) {
		adjustedHeight = maxHeight;
		adjustedWidth = Math.round(maxHeight * aspectRatio);
	}
	if (adjustedWidth > maxWidth) {
		adjustedWidth = maxWidth;
		adjustedHeight = Math.round(maxWidth / aspectRatio);
	}
	return {
		width: adjustedWidth,
		height: adjustedHeight
	};
};
function resample_high_quality(canvas, width, height, resize_canvas) {
	var width_source = canvas.width;
	var height_source = canvas.height;
	width = Math.round(width);
	height = Math.round(height);
	var ratio_w = width_source / width;
	var ratio_h = height_source / height;
	var ratio_w_half = Math.ceil(ratio_w / 2);
	var ratio_h_half = Math.ceil(ratio_h / 2);
	var ctx = canvas.getContext("2d");
	var img = ctx.getImageData(0, 0, width_source, height_source);
	var img2 = ctx.createImageData(width, height);
	var data = img.data;
	var data2 = img2.data;
	for (var j = 0; j < height; j++) for (var i = 0; i < width; i++) {
		var x2 = (i + j * width) * 4;
		var weight = 0;
		var weights = 0;
		var weights_alpha = 0;
		var gx_r = 0;
		var gx_g = 0;
		var gx_b = 0;
		var gx_a = 0;
		var center_y = (j + .5) * ratio_h;
		var yy_start = Math.floor(j * ratio_h);
		var yy_stop = Math.ceil((j + 1) * ratio_h);
		for (var yy = yy_start; yy < yy_stop; yy++) {
			var dy = Math.abs(center_y - (yy + .5)) / ratio_h_half;
			var center_x = (i + .5) * ratio_w;
			var w0 = dy * dy;
			var xx_start = Math.floor(i * ratio_w);
			var xx_stop = Math.ceil((i + 1) * ratio_w);
			for (var xx = xx_start; xx < xx_stop; xx++) {
				var dx = Math.abs(center_x - (xx + .5)) / ratio_w_half;
				var w = Math.sqrt(w0 + dx * dx);
				if (w >= 1) continue;
				weight = 2 * w * w * w - 3 * w * w + 1;
				var pos_x = 4 * (xx + yy * width_source);
				gx_a += weight * data[pos_x + 3];
				weights_alpha += weight;
				if (data[pos_x + 3] < 255) weight = weight * data[pos_x + 3] / 250;
				gx_r += weight * data[pos_x];
				gx_g += weight * data[pos_x + 1];
				gx_b += weight * data[pos_x + 2];
				weights += weight;
			}
		}
		data2[x2] = gx_r / weights;
		data2[x2 + 1] = gx_g / weights;
		data2[x2 + 2] = gx_b / weights;
		data2[x2 + 3] = gx_a / weights_alpha;
	}
	if (resize_canvas === true) {
		canvas.width = width;
		canvas.height = height;
	} else ctx.clearRect(0, 0, width_source, height_source);
	ctx.putImageData(img2, 0, 0);
}
function multiStepResize(canvas, width, height) {
	let oc = document.createElement("canvas");
	let octx = oc.getContext("2d");
	let ctx = canvas.getContext("2d");
	let steps = Math.ceil(Math.log(canvas.width / width) / Math.log(2));
	steps = Math.max(steps, 1);
	let stepWidth = width * Math.pow(2, steps - 1);
	let stepHeight = height * Math.pow(2, steps - 1);
	let currentWidth = canvas.width;
	let currentHeight = canvas.height;
	oc.width = currentWidth;
	oc.height = currentHeight;
	octx.drawImage(canvas, 0, 0);
	while (steps > 0) {
		stepWidth = Math.max(stepWidth, width);
		stepHeight = Math.max(stepHeight, height);
		canvas.width = stepWidth;
		canvas.height = stepHeight;
		ctx.drawImage(oc, 0, 0, currentWidth, currentHeight, 0, 0, stepWidth, stepHeight);
		currentWidth = stepWidth;
		currentHeight = stepHeight;
		oc.width = currentWidth;
		oc.height = currentHeight;
		octx.drawImage(canvas, 0, 0);
		stepWidth = Math.round(stepWidth / 2);
		stepHeight = Math.round(stepHeight / 2);
		steps--;
	}
	resample_high_quality(canvas, width, height, true);
}
var FALLBACK_NAME = "image";
var stripDiacritics = (value) => value.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
var sanitizeSegment = (segment, { allowDots = false } = {}) => {
	if (!segment) return "";
	const normalized = stripDiacritics(segment).replace(/[\s\u2000-\u206f]+/g, "_").replace(/[\\/]+/g, "_");
	const allowedPattern = allowDots ? /[^0-9A-Za-z._-]+/g : /[^0-9A-Za-z_-]+/g;
	let sanitized = normalized.replace(allowedPattern, "_");
	sanitized = sanitized.replace(/_+/g, "_");
	sanitized = sanitized.replace(/^[_.-]+/, "");
	sanitized = sanitized.replace(/[_-]+$/, "");
	return sanitized;
};
var splitFileName = (name) => {
	const trimmed = name?.trim?.() ?? "";
	const lastDot = trimmed.lastIndexOf(".");
	if (lastDot <= 0 || lastDot === trimmed.length - 1) return {
		base: trimmed,
		ext: ""
	};
	return {
		base: trimmed.slice(0, lastDot),
		ext: trimmed.slice(lastDot + 1)
	};
};
const sanitizeImageFileName = (inputName) => {
	const { base, ext } = splitFileName(inputName || "");
	const sanitizedBase = sanitizeSegment(base, { allowDots: true }) || FALLBACK_NAME;
	const sanitizedExt = sanitizeSegment(ext, { allowDots: false }).toLowerCase();
	if (!sanitizedExt) return sanitizedBase;
	return `${sanitizedBase}.${sanitizedExt}`;
};
const ensureUniqueFileName = (preferredName, existingNames = /* @__PURE__ */ new Set()) => {
	const sanitized = sanitizeImageFileName(preferredName);
	if (!existingNames || typeof existingNames.has !== "function") return sanitized;
	const existingSet = /* @__PURE__ */ new Set();
	existingNames.forEach((name) => existingSet.add(sanitizeImageFileName(name)));
	if (!existingSet.has(sanitized)) return sanitized;
	const { base, ext } = splitFileName(sanitized);
	let counter = 1;
	let candidate = sanitized;
	const suffix = () => `${base}-${counter}${ext ? `.${ext}` : ""}`;
	while (existingSet.has(candidate)) {
		candidate = suffix();
		counter += 1;
	}
	return candidate;
};
const buildMediaPath = (fileName) => `word/media/${fileName}`;
var fileTooLarge = (file) => {
	if (file.size > 5242880) {
		window.alert("Image size must be less than 5MB");
		return true;
	}
	return false;
};
const checkAndProcessImage = async ({ getMaxContentSize, file }) => {
	if (fileTooLarge(file)) return {
		file: null,
		size: {
			width: 0,
			height: 0
		}
	};
	try {
		const process = await processUploadedImage(file, getMaxContentSize);
		return {
			file: process.file,
			size: {
				width: process.width,
				height: process.height
			}
		};
	} catch (err) {
		console.warn("Error processing image:", err);
		return {
			file: null,
			size: {
				width: 0,
				height: 0
			}
		};
	}
};
function replaceSelectionWithImagePlaceholder({ editorOptions, view, id }) {
	let { tr } = view.state;
	let { selection } = tr;
	if (editorOptions.isHeaderOrFooter) selection = editorOptions.lastSelection;
	if (!selection.empty && !editorOptions.isHeaderOrFooter) tr.deleteSelection();
	tr = addImagePlaceholder(view.state, tr, id, selection.from);
	view.dispatch(tr);
}
const generateUniqueDocPrId = (editor) => {
	const existingIds = /* @__PURE__ */ new Set();
	editor?.state?.doc?.descendants((node) => {
		if (node.type.name === "image" && node.attrs.id !== void 0 && node.attrs.id !== null) existingIds.add(String(node.attrs.id));
	});
	let candidate;
	do {
		const hex = generateDocxRandomId();
		candidate = String(parseInt(hex, 16));
	} while (!candidate || existingIds.has(candidate));
	return candidate;
};
function getImageMediaStores(editor) {
	const own = editor?.storage?.image?.media;
	const parent = editor?.options?.parentEditor?.storage?.image?.media;
	const stores = [];
	if (own) stores.push(own);
	if (parent && parent !== own) stores.push(parent);
	return stores;
}
function getExistingImageFileNames(editor) {
	const names = /* @__PURE__ */ new Set();
	for (const media of getImageMediaStores(editor)) Object.keys(media).forEach((key$1) => names.add(key$1.split("/").pop()));
	return names;
}
function registerImageMedia(editor, mediaPath, url) {
	const stores = getImageMediaStores(editor);
	if (!stores.length) {
		editor.storage.image.media = { [mediaPath]: url };
		return;
	}
	for (const media of stores) media[mediaPath] = url;
}
async function uploadAndInsertImage({ editor, view, file, size, id }) {
	const imageUploadHandler = typeof editor.options.handleImageUpload === "function" ? editor.options.handleImageUpload : handleImageUpload;
	const placeholderId = id;
	try {
		const existingFileNames = getExistingImageFileNames(editor);
		const uniqueFileName = ensureUniqueFileName(file.name, existingFileNames);
		let url = await imageUploadHandler(uniqueFileName === file.name ? file : new File([file], uniqueFileName, {
			type: file.type,
			lastModified: file.lastModified ?? Date.now()
		}));
		let placeholderPos = findPlaceholder(view.state, placeholderId);
		if (placeholderPos == null) return;
		const mediaPath = buildMediaPath(uniqueFileName);
		const docPrId = generateUniqueDocPrId(editor);
		let rId = null;
		if (editor.options.mode === "docx") {
			const [, path] = mediaPath.split("word/");
			const id$1 = addImageRelationship({
				editor,
				path
			});
			if (id$1) rId = id$1;
		}
		let imageNode = view.state.schema.nodes.image.create({
			src: mediaPath,
			size,
			id: docPrId,
			rId
		});
		registerImageMedia(editor, mediaPath, url);
		if (editor.options.ydoc && typeof editor.commands.addImageToCollaboration === "function") editor.commands.addImageToCollaboration({
			mediaPath,
			fileData: url
		});
		let tr = view.state.tr;
		tr.replaceWith(placeholderPos, placeholderPos, imageNode);
		tr = removeImagePlaceholder(view.state, tr, placeholderId);
		view.dispatch(tr);
	} catch {
		const tr = removeImagePlaceholder(view.state, view.state.tr, placeholderId);
		view.dispatch(tr);
	}
}
function addImageRelationship({ editor, path }) {
	if (editor.options.isHeaderOrFooter) {
		const parentEditor = editor.options.parentEditor;
		const headerFooterRefId = editor.options.headerFooterRefId;
		if (!parentEditor || !headerFooterRefId) return null;
		const relsPartId = resolveHeaderFooterRelsPartIdFromRefId(parentEditor, headerFooterRefId);
		if (!relsPartId) return null;
		return findOrCreateRelationship(parentEditor, "startImageUpload:addHeaderFooterImageRelationship", {
			target: path,
			type: "image",
			partId: relsPartId
		});
	}
	return findOrCreateRelationship(editor, "startImageUpload:addImageRelationship", {
		target: path,
		type: "image"
	});
}
var key = new PluginKey("ImageRegistration");
const needsImageRegistration = (node) => {
	if (!node || node.type?.name !== "image") return false;
	const src = node.attrs?.src;
	if (typeof src !== "string" || src.length === 0) return false;
	if (node.attrs?.vmlTextWatermark) return false;
	if (src.startsWith("word/media")) return false;
	if (src.startsWith("data:") && node.attrs?.rId) return false;
	if (isRelativeUrl(src) && node.attrs?.rId) return false;
	return true;
};
const ImageRegistrationPlugin = ({ editor }) => {
	const { view } = editor;
	return new Plugin({
		key,
		state: {
			init() {
				return { set: DecorationSet.empty };
			},
			apply(tr, { set }) {
				const meta = tr.getMeta(key);
				if (meta) {
					set = meta.set;
					return { set };
				}
				set = set.map(tr.mapping, tr.doc);
				return { set };
			}
		},
		appendTransaction: (trs, _oldState, state) => {
			let foundImages = [];
			if (!trs.some((tr) => tr.docChanged)) return null;
			trs.forEach((tr) => {
				if (tr.docChanged) tr.steps.forEach((step, index) => {
					const stepMap = step.getMap();
					foundImages = foundImages.map(({ node, pos, id }) => {
						return {
							node,
							pos: stepMap.map(pos, -1),
							id
						};
					});
					if (step instanceof ReplaceStep || step instanceof ReplaceAroundStep) (tr.docs[index + 1] || tr.doc).nodesBetween(stepMap.map(step.from, -1), stepMap.map(step.to, 1), (node, pos) => {
						if (node.type.name === "image" && needsImageRegistration(node)) foundImages.push({
							node,
							pos,
							id: {}
						});
						else return true;
					});
				});
			});
			if (!foundImages || foundImages.length === 0) return null;
			if (editor.options.isHeadless) return handleNodePath(foundImages, editor, state);
			return handleBrowserPath(foundImages, editor, view, state);
		},
		props: { decorations(state) {
			let { set } = key.getState(state);
			return set;
		} }
	});
};
var derivePreferredFileName = (src) => {
	if (typeof src !== "string" || src.length === 0) return "image.jpg";
	if (src.startsWith("data:")) return getBase64FileMeta(src).filename;
	const trimmed = (src.split("/").pop() ?? "").split(/[?#]/)[0];
	if (!trimmed) return "image.jpg";
	if (!trimmed.includes(".")) return `${trimmed}.jpg`;
	return trimmed;
};
var parsePositiveInt = (value) => {
	const parsed = Number.parseInt(String(value), 10);
	return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
var parseSizeFromImageUrl = (src) => {
	if (typeof src !== "string" || src.length === 0 || !src.startsWith("http")) return null;
	try {
		const url = new URL(src);
		const width = parsePositiveInt(url.searchParams.get("width")) ?? parsePositiveInt(url.searchParams.get("w")) ?? parsePositiveInt(url.searchParams.get("imgw"));
		const height = parsePositiveInt(url.searchParams.get("height")) ?? parsePositiveInt(url.searchParams.get("h")) ?? parsePositiveInt(url.searchParams.get("imgh"));
		if (width && height) return {
			width,
			height
		};
		const segments = url.pathname.split("/").filter(Boolean);
		const last = parsePositiveInt(segments.at(-1));
		const secondLast = parsePositiveInt(segments.at(-2));
		if (secondLast && last) return {
			width: secondLast,
			height: last
		};
		const compact = segments.at(-1)?.match(/^(\d{1,5})x(\d{1,5})$/i);
		if (compact) {
			const compactWidth = parsePositiveInt(compact[1]);
			const compactHeight = parsePositiveInt(compact[2]);
			if (compactWidth && compactHeight) return {
				width: compactWidth,
				height: compactHeight
			};
		}
	} catch {
		return null;
	}
	return null;
};
var hasFinitePositiveSize = (size) => Number.isFinite(size?.width) && size.width > 0 && Number.isFinite(size?.height) && size.height > 0;
var isSvgFile = (file) => file?.type === "image/svg+xml";
var getBase64PayloadByteLength = (payload = "") => {
	const normalized = payload.replace(/\s/g, "");
	if (!normalized) return 0;
	const padding = normalized.endsWith("==") ? 2 : normalized.endsWith("=") ? 1 : 0;
	return Math.floor(normalized.length * 3 / 4) - padding;
};
var getDataUriDecodedByteLength = (src) => {
	const metadata = getDataUriMetadata(src);
	if (!metadata?.hasPayloadSeparator) return null;
	if (metadata.isBase64) return getBase64PayloadByteLength(metadata.payload);
	const decoded = tryDecodeDataUriText(metadata.payload);
	if (decoded == null) return null;
	return new globalThis.TextEncoder().encode(decoded).byteLength;
};
var shouldRegisterInPlace = (node) => isValidImageDataUrl(node.attrs?.src) && hasFinitePositiveSize(node.attrs?.size) && getDataUriDecodedByteLength(node.attrs.src) <= 5242880;
var getOrInitMediaStore = (editor) => {
	if (!editor?.storage?.image?.media) editor.storage.image.media = {};
	const mediaStore = editor.storage.image.media;
	const parentMediaStore = editor?.options?.parentEditor?.storage?.image?.media;
	const mediaStores = [mediaStore];
	if (parentMediaStore && parentMediaStore !== mediaStore) mediaStores.push(parentMediaStore);
	const existingFileNames = /* @__PURE__ */ new Set();
	mediaStores.forEach((store) => {
		Object.keys(store).forEach((k) => existingFileNames.add(k.split("/").pop()));
	});
	return {
		mediaStore,
		mediaStores,
		existingFileNames
	};
};
const handleNodePath = (foundImages, editor, state) => {
	const { tr } = state;
	registerImagesInTransaction(foundImages, editor, tr);
	return tr;
};
var registerImagesInTransaction = (foundImages, editor, tr) => {
	const { mediaStores, existingFileNames } = getOrInitMediaStore(editor);
	foundImages.forEach(({ node, pos }) => {
		const { src } = node.attrs;
		const uniqueFileName = ensureUniqueFileName(derivePreferredFileName(src), existingFileNames);
		existingFileNames.add(uniqueFileName);
		const mediaPath = buildMediaPath(uniqueFileName);
		mediaStores.forEach((store) => {
			store[mediaPath] = src;
		});
		if (editor.options.ydoc) editor.options.ydoc.getMap("media").set(mediaPath, src);
		const rId = addImageRelationship({
			editor,
			path: mediaPath.startsWith("word/") ? mediaPath.slice(5) : mediaPath
		});
		const inferredSize = hasFinitePositiveSize(node.attrs?.size) ? null : parseSizeFromImageUrl(src);
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			...inferredSize ? { size: inferredSize } : {},
			src: mediaPath,
			rId
		});
	});
};
const handleBrowserPath = (foundImages, editor, view, state) => {
	if (foundImages.length === 0) return null;
	const relativeImages = foundImages.filter(({ node }) => isRelativeUrl(node.attrs?.src));
	const inPlaceImages = foundImages.filter(({ node }) => !isRelativeUrl(node.attrs?.src) && shouldRegisterInPlace(node));
	const imagesToProcess = foundImages.filter(({ node }) => !isRelativeUrl(node.attrs?.src) && !shouldRegisterInPlace(node));
	if (relativeImages.length > 0) registerRelativeImages(relativeImages, editor, view);
	const tr = state.tr;
	if (inPlaceImages.length > 0) registerImagesInTransaction(inPlaceImages, editor, tr);
	if (imagesToProcess.length === 0) return tr.docChanged ? tr : null;
	registerImages(imagesToProcess, editor, view);
	let { set } = key.getState(state);
	imagesToProcess.slice().sort((a, b) => a.pos - b.pos).forEach(({ pos, id }) => {
		let deco = Decoration.widget(pos, () => document.createElement("placeholder"), {
			side: -1,
			id
		});
		set = set.add(tr.doc, [deco]);
	});
	imagesToProcess.slice().sort((a, b) => b.pos - a.pos).forEach(({ node, pos }) => {
		tr.delete(pos, pos + node.nodeSize);
	});
	set = set.map(tr.mapping, tr.doc);
	tr.setMeta(key, { set });
	return tr;
};
const findPlaceholder = (state, id) => {
	let { set } = key.getState(state);
	let found = set?.find(null, null, (spec) => spec.id === id);
	return found?.length ? found[0].from : null;
};
const removeImagePlaceholder = (state, tr, id) => {
	let { set } = key.getState(state);
	set = set.map(tr.mapping, tr.doc);
	set = set.remove(set.find(null, null, (spec) => spec.id == id));
	return tr.setMeta(key, {
		set,
		type: "remove"
	});
};
const addImagePlaceholder = (state, tr, id, pos) => {
	let { set } = key.getState(state);
	set = set.map(tr.mapping, tr.doc);
	let deco = Decoration.widget(pos, () => document.createElement("placeholder"), { id });
	set = set.add(tr.doc, [deco]);
	return tr.setMeta(key, {
		set,
		type: "add"
	});
};
var registerRelativeImages = async (images, editor, view) => {
	const { mediaStore, existingFileNames } = getOrInitMediaStore(editor);
	const { pendingRelativeRegistrations } = editor.storage.image;
	for (const { node } of images) {
		const src = node.attrs.src;
		if (pendingRelativeRegistrations.has(src)) continue;
		pendingRelativeRegistrations.add(src);
		try {
			const filename = derivePreferredFileName(src);
			const file = await urlToFile(src, filename);
			if (!file) continue;
			const dataUrl = await new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => resolve(reader.result);
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
			const uniqueFileName = ensureUniqueFileName(filename, existingFileNames);
			existingFileNames.add(uniqueFileName);
			const mediaPath = buildMediaPath(uniqueFileName);
			mediaStore[mediaPath] = dataUrl;
			if (editor.options.ydoc) editor.options.ydoc.getMap("media").set(mediaPath, dataUrl);
			const rId = addImageRelationship({
				editor,
				path: mediaPath.startsWith("word/") ? mediaPath.slice(5) : mediaPath
			});
			let nodePos = null;
			view.state.doc.descendants((n, pos) => {
				if (nodePos !== null) return false;
				if (n.type.name === "image" && n.attrs.src === src && !n.attrs.rId) nodePos = pos;
			});
			if (nodePos !== null) {
				const tr = view.state.tr;
				const currentNode = tr.doc.nodeAt(nodePos);
				if (currentNode?.type.name === "image") {
					tr.setNodeMarkup(nodePos, void 0, {
						...currentNode.attrs,
						rId,
						originalSrc: mediaPath
					});
					view.dispatch(tr);
					if (!currentNode.attrs.size?.width || !currentNode.attrs.size?.height) try {
						const size = await new Promise((resolve, reject) => {
							const img = new globalThis.Image();
							img.onload = () => resolve({
								width: img.naturalWidth,
								height: img.naturalHeight
							});
							img.onerror = () => resolve(null);
							setTimeout(() => reject(/* @__PURE__ */ new Error("timeout")), 5e3);
							img.src = dataUrl;
						});
						if (size) {
							let sizePos = null;
							view.state.doc.descendants((n, p) => {
								if (sizePos !== null) return false;
								if (n.type.name === "image" && n.attrs.rId === rId) sizePos = p;
							});
							if (sizePos !== null) {
								const sizeTr = view.state.tr;
								const sizeNode = sizeTr.doc.nodeAt(sizePos);
								if (sizeNode?.type.name === "image") {
									sizeTr.setNodeMarkup(sizePos, void 0, {
										...sizeNode.attrs,
										size
									});
									view.dispatch(sizeTr);
								}
							}
						}
					} catch {}
				}
			}
		} catch (error) {
			console.error(`Error registering relative image ${src}:`, error);
		} finally {
			pendingRelativeRegistrations.delete(src);
		}
	}
};
var registerImages = async (foundImages, editor, view) => {
	foundImages.forEach(async (image) => {
		const src = image.node.attrs.src;
		const id = image.id;
		let file = null;
		if (src.startsWith("http")) if (await validateUrlAccessibility(src)) file = await urlToFile(src);
		else {
			console.warn(`Image URL ${src} is not accessible due to CORS or other restrictions. Using original URL.`);
			const tr = view.state.tr;
			removeImagePlaceholder(view.state, tr, id);
			view.dispatch(tr);
			return;
		}
		else if (src.startsWith("data:")) file = base64ToFile(src);
		else console.error(`Unsupported image source: ${src}`);
		if (!file) {
			const tr = view.state.tr;
			removeImagePlaceholder(view.state, tr, id);
			view.dispatch(tr);
			return;
		}
		try {
			if (isSvgFile(file) && hasFinitePositiveSize(image.node.attrs?.size) && file.size <= 5242880) await uploadAndInsertImage({
				editor,
				view,
				file,
				size: image.node.attrs.size,
				id
			});
			else {
				const process = await checkAndProcessImage({
					getMaxContentSize: () => editor.getMaxContentSize(),
					file
				});
				if (!process.file) {
					const tr = view.state.tr;
					removeImagePlaceholder(view.state, tr, id);
					view.dispatch(tr);
					return;
				}
				await uploadAndInsertImage({
					editor,
					view,
					file: process.file,
					size: process.size,
					id
				});
			}
		} catch (error) {
			console.error(`Error processing image from ${src}:`, error);
			const tr = view.state.tr;
			removeImagePlaceholder(view.state, tr, id);
			view.dispatch(tr);
		}
	});
};
var stepHasSlice = (step) => "slice" in step && Boolean(step.slice);
var ImagePositionPluginKey = new PluginKey("ImagePosition");
var pageBreakPositionCache = /* @__PURE__ */ new WeakMap();
const ImagePositionPlugin = ({ editor }) => {
	const { view } = editor;
	let shouldUpdate = true;
	return new Plugin({
		name: "ImagePositionPlugin",
		key: ImagePositionPluginKey,
		state: {
			init() {
				return DecorationSet.empty;
			},
			apply(tr, oldDecorationSet, oldState, newState) {
				if (!tr.docChanged && !shouldUpdate) return oldDecorationSet;
				if (!(typeof document !== "undefined" && !!(document && document.createElement)) || !view || typeof view.domAtPos !== "function") return oldDecorationSet.map(tr.mapping, tr.doc);
				let affectsImages = false;
				tr.steps.forEach((step) => {
					if (stepHasSlice(step)) step.slice.content.descendants((node) => {
						if (node.type.name === "image" || node.attrs?.anchorData) {
							affectsImages = true;
							return false;
						}
					});
				});
				if (!affectsImages && !shouldUpdate) return oldDecorationSet.map(tr.mapping, tr.doc);
				const decorations = getImagePositionDecorations(newState, view);
				shouldUpdate = false;
				return DecorationSet.create(newState.doc, decorations);
			}
		},
		view: () => {
			return { update: (view$1, lastState) => {
				if (!(typeof document !== "undefined" && !!(document && document.createElement)) || !view$1 || typeof view$1.domAtPos !== "function") return;
				if (shouldUpdate) {
					const decorations = getImagePositionDecorations(lastState, view$1);
					const updateTransaction = view$1.state.tr.setMeta(ImagePositionPluginKey, { decorations });
					view$1.dispatch(updateTransaction);
				}
			} };
		},
		props: { decorations(state) {
			return this.getState(state);
		} }
	});
};
var getImagePositionDecorations = (state, view) => {
	let decorations = [];
	if (!(typeof document !== "undefined" && !!(document && document.createElement)) || !view || typeof view.domAtPos !== "function") return decorations;
	let hasAnchoredImages = false;
	state.doc.descendants((node) => {
		if (node.attrs?.anchorData) {
			hasAnchoredImages = true;
			return false;
		}
	});
	if (!hasAnchoredImages) return decorations;
	state.doc.descendants((node, pos) => {
		if (node.attrs.anchorData) {
			let style = "";
			let className = "";
			const { vRelativeFrom, alignH } = node.attrs.anchorData;
			const { size, padding } = node.attrs;
			const pageBreak = findPreviousDomNodeWithClass(view, pos, "pagination-break-wrapper");
			if (pageBreak && vRelativeFrom === "margin" && alignH) {
				let pageBreakPos = pageBreakPositionCache.get(pageBreak);
				if (!pageBreakPos) {
					pageBreakPos = {
						top: pageBreak.offsetTop,
						height: pageBreak.offsetHeight
					};
					pageBreakPositionCache.set(pageBreak, pageBreakPos);
				}
				const topPos = pageBreakPos.top + pageBreakPos.height;
				let horizontalAlignment = `${alignH}: 0;`;
				if (alignH === "center") horizontalAlignment = "left: 50%; transform: translateX(-50%);";
				style += vRelativeFrom === "margin" ? `position: absolute; top: ${topPos}px; ${horizontalAlignment}` : "";
				const nextPos = view.posAtDOM(pageBreak, 1);
				if (nextPos < 0) {
					const $pos = view.state.doc.resolve(pos);
					decorations.push(Decoration.node(pos - 1, pos + $pos.parent.nodeSize - 1, { style: `height: ${size.height + parseInt(padding.top) + parseInt(padding.bottom)}px` }));
				}
				const imageBlock = document.createElement("div");
				imageBlock.className = "anchor-image-placeholder";
				imageBlock.style.float = alignH === "left" || alignH === "right" ? alignH : "none";
				let paddingHorizontal;
				if (alignH === "center") paddingHorizontal = (parseInt(padding.left) || 0) + (parseInt(padding.right) || 0);
				else paddingHorizontal = parseInt(padding[alignH]) || 0;
				imageBlock.style.width = size.width + paddingHorizontal + "px";
				imageBlock.style.height = size.height + parseInt(padding.top) + parseInt(padding.bottom) + "px";
				decorations.push(Decoration.widget(nextPos, imageBlock, { key: "stable-key" }));
				decorations.push(Decoration.inline(pos, pos + node.nodeSize, {
					style,
					class: className
				}));
			}
		}
	});
	return decorations;
};
var findPreviousDomNodeWithClass = (view, pos, className) => {
	if (!(typeof document !== "undefined" && !!(document && document.createElement)) || !view || typeof view.domAtPos !== "function") return null;
	let { node } = view.domAtPos(pos);
	if (node.nodeType === 3) node = node.parentNode;
	while (node) {
		if (node.classList && node.classList.contains(className)) return node;
		if (node.previousSibling) {
			node = node.previousSibling;
			while (node && node.lastChild) node = node.lastChild;
		} else node = node.parentNode;
	}
	return null;
};
const normalizeWrap = (attrs = {}) => {
	const wrap = attrs.wrap;
	if (wrap?.type && wrap.type !== "Inline") return {
		type: wrap.type,
		attrs: wrap.attrs ?? {}
	};
	if (wrap?.type === "Inline" && Object.keys(wrap.attrs ?? {}).length) return {
		type: "Inline",
		attrs: wrap.attrs
	};
	if (!wrap && attrs.wrapText) return {
		type: "Square",
		attrs: { wrapText: attrs.wrapText }
	};
	if (!wrap && attrs.wrapTopAndBottom) return {
		type: "TopAndBottom",
		attrs: {}
	};
	if (wrap?.type === "Inline") return {
		type: "Inline",
		attrs: wrap.attrs ?? {}
	};
	return {
		type: "Inline",
		attrs: {}
	};
};
const normalizeMarginOffset = (marginOffset = {}) => {
	const { left, horizontal, ...rest } = marginOffset;
	return {
		...rest,
		horizontal: horizontal ?? left
	};
};
const getNormalizedImageAttrs = (attrs = {}) => {
	return {
		wrap: normalizeWrap(attrs),
		marginOffset: normalizeMarginOffset(attrs.marginOffset ?? {})
	};
};
const getRotationMargins = (w, h, angleDegrees) => {
	const rad = angleDegrees * (Math.PI / 180);
	const cos = Math.abs(Math.cos(rad));
	const sin = Math.abs(Math.sin(rad));
	const boundingWidth = w * cos + h * sin;
	const boundingHeight = w * sin + h * cos;
	return {
		horizontal: Math.round(Math.max(0, (boundingWidth - w) / 2)),
		vertical: Math.round(Math.max(0, (boundingHeight - h) / 2))
	};
};
var ACCEPT_IMAGE_TYPES = [
	".jpg",
	".jpeg",
	".png",
	"image/jpeg",
	"image/png"
];
const getFileOpener = () => {
	let fileInput = document.createElement("input");
	fileInput.type = "file";
	fileInput.accept = ACCEPT_IMAGE_TYPES.join(",");
	const openFile = () => {
		return new Promise((resolve, reject) => {
			fileInput.onchange = async () => {
				const files = fileInput.files;
				if (!files) return resolve(null);
				const file = files.item(0);
				if (!file) return resolve(null);
				return resolve({ file });
			};
			fileInput.oncancel = () => resolve(null);
			fileInput.onerror = reject;
			fileInput.click();
		});
	};
	return openFile;
};
async function processAndInsertImageFile({ file, editor, view, editorOptions, getMaxContentSize }) {
	const { size, file: processedFile } = await checkAndProcessImage({
		file,
		getMaxContentSize
	});
	if (!processedFile) return "skipped";
	const id = {};
	replaceSelectionWithImagePlaceholder({
		view,
		editorOptions,
		id
	});
	await uploadAndInsertImage({
		editor,
		view,
		file: processedFile,
		size,
		id
	});
	return "success";
}
var TAB_LEADER_TO_SEPARATOR = {
	dot: ".",
	hyphen: "-",
	underscore: "_",
	middleDot: "·"
};
var SEPARATOR_TO_TAB_LEADER = {
	".": "dot",
	"-": "hyphen",
	_: "underscore",
	"·": "middleDot"
};
const DEFAULT_TOC_CONFIG = {
	source: {
		outlineLevels: {
			from: 1,
			to: 3
		},
		useAppliedOutlineLevel: true
	},
	display: {
		hyperlinks: true,
		hideInWebView: true
	},
	preserved: {}
};
var SWITCH_PATTERN$1 = /\\([a-z])\s*(?:"([^"]*)")?/gi;
function parseLevelRange(value) {
	const match = value.match(/^(\d+)-(\d+)$/);
	if (!match) return void 0;
	return {
		from: parseInt(match[1], 10),
		to: parseInt(match[2], 10)
	};
}
function parseCustomStyles(value) {
	const entries = [];
	const parts = value.split(",");
	for (let i = 0; i < parts.length - 1; i += 2) {
		const styleName = parts[i].trim();
		const level = parseInt(parts[i + 1].trim(), 10);
		if (styleName && !isNaN(level)) entries.push({
			styleName,
			level
		});
	}
	return entries;
}
function deriveIncludePageNumbers(omitRange, outlineLevels) {
	if (!omitRange) return true;
	const effectiveRange = outlineLevels ?? {
		from: 1,
		to: 9
	};
	return !(omitRange.from <= effectiveRange.from && omitRange.to >= effectiveRange.to);
}
function deriveTabLeader(separator) {
	if (separator === void 0) return void 0;
	if (separator === "") return "none";
	return SEPARATOR_TO_TAB_LEADER[separator];
}
function parseTocInstruction(instruction) {
	const source = {};
	const display = {};
	const preserved = {};
	const rawExtensions = [];
	let match;
	SWITCH_PATTERN$1.lastIndex = 0;
	while ((match = SWITCH_PATTERN$1.exec(instruction)) !== null) {
		const switchChar = match[1].toLowerCase();
		const rawArg = match[2];
		const arg = rawArg ?? "";
		switch (switchChar) {
			case "o": {
				const range = parseLevelRange(arg);
				if (range) source.outlineLevels = range;
				break;
			}
			case "u":
				source.useAppliedOutlineLevel = true;
				break;
			case "f":
				if (arg) source.tcFieldIdentifier = arg;
				break;
			case "l": {
				const range = parseLevelRange(arg);
				if (range) source.tcFieldLevels = range;
				break;
			}
			case "h":
				display.hyperlinks = true;
				break;
			case "z":
				display.hideInWebView = true;
				break;
			case "n": {
				const range = parseLevelRange(arg);
				if (range) display.omitPageNumberLevels = range;
				break;
			}
			case "p":
				if (rawArg !== void 0) display.separator = rawArg;
				break;
			case "t":
				if (arg) preserved.customStyles = parseCustomStyles(arg);
				break;
			case "b":
				if (arg) preserved.bookmarkName = arg;
				break;
			case "a":
				if (arg) preserved.captionType = arg;
				break;
			case "c":
				if (arg) preserved.seqFieldIdentifier = arg;
				break;
			case "d":
				if (arg) preserved.chapterSeparator = arg;
				break;
			case "s":
				if (arg) preserved.chapterNumberSource = arg;
				break;
			case "w":
				preserved.preserveTabEntries = true;
				break;
			default:
				rawExtensions.push(arg ? `\\${switchChar} "${arg}"` : `\\${switchChar}`);
				break;
		}
	}
	if (rawExtensions.length > 0) preserved.rawExtensions = rawExtensions;
	display.includePageNumbers = deriveIncludePageNumbers(display.omitPageNumberLevels, source.outlineLevels);
	const tabLeader = deriveTabLeader(display.separator);
	if (tabLeader !== void 0) display.tabLeader = tabLeader;
	return {
		source,
		display,
		preserved
	};
}
function serializeTocInstruction(config) {
	const parts = ["TOC"];
	const { source, display, preserved } = config;
	if (source.outlineLevels) parts.push(`\\o "${source.outlineLevels.from}-${source.outlineLevels.to}"`);
	if (source.useAppliedOutlineLevel) parts.push("\\u");
	if (source.tcFieldIdentifier) parts.push(`\\f "${source.tcFieldIdentifier}"`);
	if (source.tcFieldLevels) parts.push(`\\l "${source.tcFieldLevels.from}-${source.tcFieldLevels.to}"`);
	if (preserved.customStyles?.length) {
		const pairs = preserved.customStyles.map((s) => `${s.styleName},${s.level}`).join(",");
		parts.push(`\\t "${pairs}"`);
	}
	if (display.hyperlinks) parts.push("\\h");
	if (display.hideInWebView) parts.push("\\z");
	if (display.omitPageNumberLevels) parts.push(`\\n "${display.omitPageNumberLevels.from}-${display.omitPageNumberLevels.to}"`);
	if (display.separator !== void 0) parts.push(`\\p "${display.separator}"`);
	if (preserved.captionType) parts.push(`\\a "${preserved.captionType}"`);
	if (preserved.bookmarkName) parts.push(`\\b "${preserved.bookmarkName}"`);
	if (preserved.seqFieldIdentifier) parts.push(`\\c "${preserved.seqFieldIdentifier}"`);
	if (preserved.chapterSeparator) parts.push(`\\d "${preserved.chapterSeparator}"`);
	if (preserved.chapterNumberSource) parts.push(`\\s "${preserved.chapterNumberSource}"`);
	if (preserved.preserveTabEntries) parts.push("\\w");
	if (preserved.rawExtensions?.length) parts.push(...preserved.rawExtensions);
	return parts.join(" ");
}
function computeOmitPageNumberRange(source) {
	return source.outlineLevels ?? {
		from: 1,
		to: 9
	};
}
function applyTocPatch(existing, patch) {
	if (patch.tabLeader !== void 0 && patch.separator !== void 0) throw new Error("INVALID_INPUT: cannot set both tabLeader and separator in the same patch");
	if (patch.includePageNumbers !== void 0 && patch.omitPageNumberLevels !== void 0) throw new Error("INVALID_INPUT: cannot set both includePageNumbers and omitPageNumberLevels in the same patch");
	const newSource = {
		...existing.source,
		...patch.outlineLevels !== void 0 && { outlineLevels: patch.outlineLevels },
		...patch.useAppliedOutlineLevel !== void 0 && { useAppliedOutlineLevel: patch.useAppliedOutlineLevel },
		...patch.tcFieldIdentifier !== void 0 && { tcFieldIdentifier: patch.tcFieldIdentifier },
		...patch.tcFieldLevels !== void 0 && { tcFieldLevels: patch.tcFieldLevels }
	};
	const newDisplay = {
		...existing.display,
		...patch.hyperlinks !== void 0 && { hyperlinks: patch.hyperlinks },
		...patch.hideInWebView !== void 0 && { hideInWebView: patch.hideInWebView }
	};
	if (patch.includePageNumbers !== void 0) {
		if (patch.includePageNumbers) delete newDisplay.omitPageNumberLevels;
		else newDisplay.omitPageNumberLevels = computeOmitPageNumberRange(newSource);
		newDisplay.includePageNumbers = patch.includePageNumbers;
	} else if (patch.omitPageNumberLevels !== void 0) {
		newDisplay.omitPageNumberLevels = patch.omitPageNumberLevels;
		newDisplay.includePageNumbers = deriveIncludePageNumbers(patch.omitPageNumberLevels, newSource.outlineLevels);
	}
	if (patch.tabLeader !== void 0) {
		if (patch.tabLeader === "none") newDisplay.separator = "";
		else newDisplay.separator = TAB_LEADER_TO_SEPARATOR[patch.tabLeader];
		newDisplay.tabLeader = patch.tabLeader;
	} else if (patch.separator !== void 0) {
		newDisplay.separator = patch.separator;
		const derived = deriveTabLeader(patch.separator);
		if (derived !== void 0) newDisplay.tabLeader = derived;
		else delete newDisplay.tabLeader;
	}
	return {
		source: newSource,
		display: newDisplay,
		preserved: { ...existing.preserved }
	};
}
function areTocConfigsEqual(a, b) {
	return serializeTocInstruction(a) === serializeTocInstruction(b);
}
function findAllTocNodes(doc) {
	const results = [];
	doc.descendants((node, pos) => {
		if (node.type.name === "tableOfContents") {
			const sdBlockId = node.attrs?.sdBlockId;
			const nodeId = resolvePublicTocNodeId(node, pos);
			const commandNodeId = sdBlockId;
			results.push({
				node,
				pos,
				nodeId,
				commandNodeId
			});
			return false;
		}
		return true;
	});
	return results;
}
function resolveTocTarget(doc, target) {
	const found = findAllTocNodes(doc).find((t) => t.nodeId === target.nodeId || t.commandNodeId === target.nodeId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Table of contents with nodeId "${target.nodeId}" not found.`);
	return found;
}
function resolvePostMutationTocId(doc, sdBlockId) {
	return findAllTocNodes(doc).find((t) => t.commandNodeId === sdBlockId)?.nodeId ?? sdBlockId;
}
function extractTocInfo(node) {
	const instruction = node.attrs?.instruction ?? "";
	const config = parseTocInstruction(instruction);
	const rightAlign = node.attrs?.rightAlignPageNumbers;
	return {
		nodeType: "tableOfContents",
		kind: "block",
		properties: {
			instruction,
			sourceConfig: config.source,
			displayConfig: {
				...config.display,
				...rightAlign !== void 0 && { rightAlignPageNumbers: rightAlign }
			},
			preservedSwitches: config.preserved,
			entryCount: node.childCount
		}
	};
}
function buildTocDiscoveryItem(resolved, evaluatedRevision) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	const config = parseTocInstruction(instruction);
	const address = {
		kind: "block",
		nodeType: "tableOfContents",
		nodeId: resolved.nodeId
	};
	const handle = buildResolvedHandle(resolved.nodeId, "stable", "tableOfContents");
	const rightAlign = resolved.node.attrs?.rightAlignPageNumbers;
	const domain = {
		address,
		instruction,
		sourceConfig: config.source,
		displayConfig: {
			...config.display,
			...rightAlign !== void 0 && { rightAlignPageNumbers: rightAlign }
		},
		preserved: config.preserved,
		entryCount: resolved.node.childCount
	};
	return buildDiscoveryItem(`toc:${resolved.nodeId}:${evaluatedRevision}`, handle, domain);
}
var DEFAULT_LEVEL = 1;
function extractEntryText(instruction) {
	const withoutPrefix = instruction.replace(/^TC\s+/i, "");
	const quoteMatch = withoutPrefix.match(/^"([^"]*)"/);
	if (quoteMatch) return {
		text: quoteMatch[1],
		rest: withoutPrefix.slice(quoteMatch[0].length)
	};
	const switchStart = withoutPrefix.indexOf("\\");
	if (switchStart === -1) return {
		text: withoutPrefix.trim(),
		rest: ""
	};
	return {
		text: withoutPrefix.slice(0, switchStart).trim(),
		rest: withoutPrefix.slice(switchStart)
	};
}
var SWITCH_PATTERN = /\\([a-z])(?:\s*(?:"([^"]*)"|([^\s\\]+)))?/gi;
function parseTcInstruction(instruction) {
	const { text, rest } = extractEntryText(instruction);
	let level = DEFAULT_LEVEL;
	let tableIdentifier;
	let omitPageNumber = false;
	const rawExtensions = [];
	let match;
	SWITCH_PATTERN.lastIndex = 0;
	while ((match = SWITCH_PATTERN.exec(rest)) !== null) {
		const switchChar = match[1].toLowerCase();
		const arg = match[2] ?? match[3] ?? "";
		switch (switchChar) {
			case "f":
				if (arg) tableIdentifier = arg;
				break;
			case "l": {
				const parsed = parseInt(arg, 10);
				if (!isNaN(parsed) && parsed >= 1) level = parsed;
				break;
			}
			case "n":
				omitPageNumber = true;
				break;
			default:
				rawExtensions.push(arg ? `\\${switchChar} "${arg}"` : `\\${switchChar}`);
				break;
		}
	}
	const config = {
		text,
		level,
		omitPageNumber
	};
	if (tableIdentifier !== void 0) config.tableIdentifier = tableIdentifier;
	if (rawExtensions.length > 0) config.rawExtensions = rawExtensions;
	return config;
}
function serializeTcInstruction(config) {
	const parts = [`TC "${config.text}"`];
	if (config.tableIdentifier) parts.push(`\\f "${config.tableIdentifier}"`);
	if (config.level !== DEFAULT_LEVEL) parts.push(`\\l "${config.level}"`);
	if (config.omitPageNumber) parts.push("\\n");
	if (config.rawExtensions?.length) parts.push(...config.rawExtensions);
	return parts.join(" ");
}
function applyTcPatch(existing, patch) {
	return {
		text: patch.text ?? existing.text,
		level: patch.level ?? existing.level,
		omitPageNumber: patch.omitPageNumber ?? existing.omitPageNumber,
		tableIdentifier: patch.tableIdentifier ?? existing.tableIdentifier,
		rawExtensions: existing.rawExtensions
	};
}
function areTcConfigsEqual(a, b) {
	return serializeTcInstruction(a) === serializeTcInstruction(b);
}
var TOC_BOOKMARK_PREFIX = "_Toc";
function generateTocBookmarkName(blockId) {
	return `${TOC_BOOKMARK_PREFIX}${encodeBlockId(blockId)}`;
}
function encodeBlockId(input) {
	let result = "";
	for (let i = 0; i < input.length; i++) {
		const ch = input[i];
		if (ch === "_") result += "__";
		else if (ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch >= "0" && ch <= "9") result += ch;
		else result += `_${ch.charCodeAt(0).toString(16).padStart(2, "0")}`;
	}
	return result;
}
function syncTocBookmarks(editor, sources) {
	const { schema, doc } = editor.state;
	if (!schema.nodes.bookmarkStart || !schema.nodes.bookmarkEnd) return;
	const needed = deduplicateByBlockId(sources);
	const existing = collectExistingTocBookmarkNames(doc);
	const missing = needed.filter((t) => !existing.has(t.bookmarkName));
	if (missing.length === 0) return;
	const insertions = resolveInsertionTargets(missing, buildBlockIdPositionMap(doc), doc);
	if (insertions.length === 0) return;
	const { tr } = editor.state;
	let nextId = findMaxBookmarkId(doc) + 1;
	for (const { bookmarkName, contentStart, contentEnd } of insertions) {
		const bookmarkId = String(nextId++);
		const endNode = schema.nodes.bookmarkEnd.create({ id: bookmarkId });
		const startNode = schema.nodes.bookmarkStart.create({
			name: bookmarkName,
			id: bookmarkId
		});
		tr.insert(tr.mapping.map(contentStart), startNode);
		tr.insert(tr.mapping.map(contentEnd), endNode);
	}
	if (tr.docChanged) dispatchTransaction(editor, tr);
}
function deduplicateByBlockId(sources) {
	const seenBlockIds = /* @__PURE__ */ new Set();
	const claimedNames = /* @__PURE__ */ new Map();
	const targets = [];
	for (const { sdBlockId } of sources) {
		if (seenBlockIds.has(sdBlockId)) continue;
		seenBlockIds.add(sdBlockId);
		const bookmarkName = generateTocBookmarkName(sdBlockId);
		const existingOwner = claimedNames.get(bookmarkName);
		if (existingOwner !== void 0 && existingOwner !== sdBlockId) continue;
		claimedNames.set(bookmarkName, sdBlockId);
		targets.push({
			blockId: sdBlockId,
			bookmarkName
		});
	}
	return targets;
}
function collectExistingTocBookmarkNames(doc) {
	const names = /* @__PURE__ */ new Set();
	doc.descendants((node) => {
		if (node.type.name === "bookmarkStart") {
			const name = node.attrs?.name;
			if (name?.startsWith(TOC_BOOKMARK_PREFIX)) names.add(name);
		}
		return true;
	});
	return names;
}
function buildBlockIdPositionMap(doc) {
	const map = /* @__PURE__ */ new Map();
	doc.descendants((node, pos) => {
		if (node.type.name === "paragraph") {
			const id = node.attrs?.sdBlockId ?? node.attrs?.paraId;
			if (id && !map.has(id)) map.set(id, pos);
		}
		return true;
	});
	return map;
}
function resolveInsertionTargets(missing, positions, doc) {
	const result = [];
	for (const { blockId, bookmarkName } of missing) {
		const pos = positions.get(blockId);
		if (pos === void 0) continue;
		const node = doc.nodeAt(pos);
		if (!node || node.type.name !== "paragraph") continue;
		result.push({
			bookmarkName,
			contentStart: pos + 1,
			contentEnd: pos + node.nodeSize - 1
		});
	}
	result.sort((a, b) => b.contentStart - a.contentStart);
	return result;
}
function findMaxBookmarkId(doc) {
	let maxId = -1;
	doc.descendants((node) => {
		if (node.type.name !== "bookmarkStart" && node.type.name !== "bookmarkEnd") return true;
		const raw = node.attrs?.id;
		const id = typeof raw === "string" ? parseInt(raw, 10) : typeof raw === "number" ? raw : NaN;
		if (!isNaN(id) && id > maxId) maxId = id;
		return true;
	});
	return maxId;
}
function dispatchTransaction(editor, tr) {
	if (typeof editor.dispatch === "function") editor.dispatch(tr);
	else if (typeof editor.view?.dispatch === "function") editor.view.dispatch(tr);
}
var ALLOWED_SOURCE_MARK_TYPES = new Set([
	"bold",
	"italic",
	"underline",
	"color",
	"highlight",
	"fontFamily"
]);
var TEXT_STYLE_ALLOWED_ATTRS = new Set(["fontFamily"]);
function sanitizeSourceMark(mark) {
	if (!mark?.type) return null;
	if (mark.type === "textStyle") {
		const attrs = mark.attrs ?? {};
		const kept = {};
		for (const key$1 of Object.keys(attrs)) if (TEXT_STYLE_ALLOWED_ATTRS.has(key$1) && attrs[key$1] != null) kept[key$1] = attrs[key$1];
		return Object.keys(kept).length > 0 ? {
			type: "textStyle",
			attrs: kept
		} : null;
	}
	if (!ALLOWED_SOURCE_MARK_TYPES.has(mark.type)) return null;
	return mark.attrs && Object.keys(mark.attrs).length > 0 ? {
		type: mark.type,
		attrs: { ...mark.attrs }
	} : { type: mark.type };
}
function collectTocSources(doc, config) {
	const sources = [];
	const { outlineLevels, useAppliedOutlineLevel, tcFieldIdentifier, tcFieldLevels } = config.source;
	const useApplied = useAppliedOutlineLevel ?? false;
	const collectTcFields = tcFieldIdentifier !== void 0 || tcFieldLevels !== void 0;
	let currentParagraphSdBlockId;
	doc.descendants((node, pos) => {
		if (node.type.name === "tableOfContents") return false;
		if (node.type.name === "paragraph") {
			const attrs = node.attrs;
			const paragraphProps = attrs?.paragraphProperties;
			const styleId = paragraphProps?.styleId;
			const sdBlockId = attrs?.sdBlockId ?? attrs?.paraId ?? buildFallbackBlockNodeId("paragraph", pos);
			currentParagraphSdBlockId = sdBlockId;
			if (!sdBlockId) return true;
			const text = flattenText(node);
			if (text.trim().length === 0) return true;
			if (outlineLevels) {
				const headingLevel = getHeadingLevel(styleId);
				if (headingLevel != null && headingLevel >= outlineLevels.from && headingLevel <= outlineLevels.to) {
					sources.push({
						text,
						segments: extractTextSegments(node),
						level: headingLevel,
						sdBlockId,
						kind: "heading"
					});
					return true;
				}
			}
			if (useApplied) {
				const effectiveLevels = outlineLevels ?? {
					from: 1,
					to: 9
				};
				const rawOutlineLevel = paragraphProps?.outlineLevel;
				if (rawOutlineLevel != null) {
					const tocLevel = rawOutlineLevel + 1;
					if (tocLevel >= effectiveLevels.from && tocLevel <= effectiveLevels.to) {
						sources.push({
							text,
							segments: extractTextSegments(node),
							level: tocLevel,
							sdBlockId,
							kind: "appliedOutline"
						});
						return true;
					}
				}
			}
			return true;
		}
		if (collectTcFields && node.type.name === "tableOfContentsEntry" && currentParagraphSdBlockId) {
			const tcConfig = parseTcInstruction(node.attrs?.instruction ?? "");
			if (tcFieldIdentifier && tcConfig.tableIdentifier !== tcFieldIdentifier) return false;
			if (tcFieldLevels) {
				if (tcConfig.level < tcFieldLevels.from || tcConfig.level > tcFieldLevels.to) return false;
			}
			sources.push({
				text: tcConfig.text,
				level: tcConfig.level,
				sdBlockId: currentParagraphSdBlockId,
				kind: "tcField",
				omitPageNumber: tcConfig.omitPageNumber || void 0
			});
			return false;
		}
		return true;
	});
	return sources;
}
function flattenText(node) {
	let text = "";
	node.descendants((child) => {
		if (child.isText) text += child.text;
		return true;
	});
	return text;
}
function extractTextSegments(node) {
	const segments = [];
	node.descendants((child) => {
		if (!child.isText || !child.text) return true;
		const marks = [];
		for (const mark of child.marks ?? []) {
			const raw = { type: mark.type?.name ?? "" };
			if (mark.attrs && Object.keys(mark.attrs).length > 0) raw.attrs = { ...mark.attrs };
			const sanitized = sanitizeSourceMark(raw);
			if (sanitized) marks.push(sanitized);
		}
		const last = segments[segments.length - 1];
		if (last && marksEqual$1(last.marks, marks)) last.text += child.text;
		else segments.push(marks.length > 0 ? {
			text: child.text,
			marks
		} : { text: child.text });
		return true;
	});
	return segments;
}
function marksEqual$1(a, b) {
	const aLen = a?.length ?? 0;
	if (aLen !== (b?.length ?? 0)) return false;
	if (aLen === 0) return true;
	return JSON.stringify(a) === JSON.stringify(b);
}
function buildTocEntryParagraphs(sources, config, options = {}) {
	return sources.map((source) => buildEntryParagraph(source, config, options));
}
var DEFAULT_RIGHT_TAB_POS = 9350;
var TAB_LEADER_MAP = {
	dot: "dot",
	hyphen: "hyphen",
	underscore: "heavy",
	middleDot: "middleDot"
};
function asRun(children) {
	return {
		type: "run",
		content: children
	};
}
function buildEntryParagraph(source, config, options = {}) {
	const { display } = config;
	const linkMark = display.hyperlinks ? {
		type: "link",
		attrs: {
			anchor: generateTocBookmarkName(source.sdBlockId),
			rId: null,
			history: true
		}
	} : void 0;
	const content = [asRun((source.segments && source.segments.length > 0 ? source.segments : [{ text: source.text || " " }]).map((segment) => {
		const marks = [...(segment.marks ?? []).map((m) => sanitizeSourceMark(m)).filter((m) => m !== null)];
		if (linkMark) marks.push(linkMark);
		const node = {
			type: "text",
			text: segment.text || " "
		};
		if (marks.length > 0) node.marks = marks;
		return node;
	}))];
	const omitRange = display.omitPageNumberLevels;
	const omitPageNumber = Boolean(omitRange && source.level >= omitRange.from && source.level <= omitRange.to || source.omitPageNumber);
	if (!omitPageNumber) {
		content.push(asRun([display.separator ? {
			type: "text",
			text: display.separator
		} : { type: "tab" }]));
		const resolvedPage = options.pageMap?.get(source.sdBlockId);
		content.push(asRun([{
			type: "text",
			text: resolvedPage != null ? String(resolvedPage) : "0",
			marks: [{ type: "tocPageNumber" }]
		}]));
	}
	const paragraphProperties = { styleId: `TOC${source.level}` };
	if (display.rightAlignPageNumbers !== false && !omitPageNumber) {
		const leader = display.tabLeader === "none" ? void 0 : display.tabLeader && TAB_LEADER_MAP[display.tabLeader] || "dot";
		paragraphProperties.tabStops = [{ tab: {
			tabType: "right",
			pos: options.tabPos ?? DEFAULT_RIGHT_TAB_POS,
			...leader ? { leader } : {}
		} }];
	}
	return {
		type: "paragraph",
		attrs: {
			paragraphProperties,
			sdBlockId: void 0,
			tocSourceId: source.sdBlockId
		},
		content
	};
}
var V3_PREFIX = "text:";
var V4_PREFIX = "text:v4:";
function encodeV4Ref(payload) {
	return `${V4_PREFIX}${btoa(JSON.stringify(payload))}`;
}
function decodeRef(ref) {
	if (ref.startsWith(V4_PREFIX)) return decodeV4(ref.slice(8));
	if (ref.startsWith(V3_PREFIX)) return decodeV3(ref.slice(5));
	return null;
}
function decodeV4(encoded) {
	try {
		const payload = JSON.parse(atob(encoded));
		if (!isPlainObject(payload)) return null;
		if (payload.v !== 4) return null;
		return payload;
	} catch {
		return null;
	}
}
function decodeV3(encoded) {
	try {
		const payload = JSON.parse(atob(encoded));
		if (!isPlainObject(payload)) return null;
		if (payload.v !== void 0 && payload.v !== 3) return null;
		return payload;
	} catch {
		return null;
	}
}
function isPlainObject(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}
var registry = /* @__PURE__ */ new Map();
function registerStepExecutor(opPrefix, executor) {
	if (registry.has(opPrefix)) throw new Error(`Step executor already registered for op prefix "${opPrefix}"`);
	registry.set(opPrefix, executor);
}
function getStepExecutor(op) {
	if (registry.has(op)) return registry.get(op);
	const prefix = op.split(".")[0];
	return registry.get(prefix);
}
function hasStepExecutor(op) {
	return getStepExecutor(op) !== void 0;
}
function isSimpleToggleOffValue(value) {
	return value === "0" || value === false || value === 0;
}
function isSimpleToggleOff(mark) {
	return isSimpleToggleOffValue(mark.attrs.value);
}
function isSimpleToggleOn(mark) {
	return !isSimpleToggleOff(mark);
}
function isUnderlineOff(mark) {
	return mark.attrs.underlineType === "none";
}
function isUnderlineOn(mark) {
	return !isUnderlineOff(mark);
}
const TOGGLE_MARK_SPECS = {
	bold: {
		schemaName: "bold",
		isOff: isSimpleToggleOff,
		isOn: isSimpleToggleOn,
		offAttrs: { value: "0" },
		createOn: (mt) => mt.create()
	},
	italic: {
		schemaName: "italic",
		isOff: isSimpleToggleOff,
		isOn: isSimpleToggleOn,
		offAttrs: { value: "0" },
		createOn: (mt) => mt.create()
	},
	strike: {
		schemaName: "strike",
		isOff: isSimpleToggleOff,
		isOn: isSimpleToggleOn,
		offAttrs: { value: "0" },
		createOn: (mt) => mt.create()
	},
	underline: {
		schemaName: "underline",
		isOff: isUnderlineOff,
		isOn: isUnderlineOn,
		offAttrs: { underlineType: "none" },
		createOn: (mt, existingMark) => {
			if (existingMark && isUnderlineOn(existingMark)) return existingMark;
			return mt.create({ underlineType: "single" });
		}
	}
};
function deriveToggleState(marks, markKey) {
	const spec = TOGGLE_MARK_SPECS[markKey];
	const mark = marks.find((m) => m.type.name === spec.schemaName);
	if (!mark) return "clear";
	return spec.isOff(mark) ? "off" : "on";
}
function applyDirectiveToMarks(marks, markKey, directive, markType) {
	const spec = TOGGLE_MARK_SPECS[markKey];
	const existingMark = marks.find((m) => m.type.name === spec.schemaName);
	const otherMarks = marks.filter((m) => m.type.name !== spec.schemaName);
	switch (directive) {
		case "on":
			if (existingMark && spec.isOn(existingMark)) return [...marks];
			return [...otherMarks, spec.createOn(markType, existingMark)];
		case "off":
			if (existingMark && spec.isOff(existingMark)) return [...marks];
			return [...otherMarks, markType.create(spec.offAttrs)];
		case "clear":
			if (!existingMark) return [...marks];
			return otherMarks;
	}
}
var CORE_MARK_NAMES = new Set([
	"bold",
	"italic",
	"underline",
	"strike"
]);
var METADATA_MARK_NAMES = new Set([
	"trackInsert",
	"trackDelete",
	"trackFormat",
	"commentMark",
	"aiMark",
	"aiAnimationMark"
]);
function captureRunsInRange(editor, blockPos, from, to, options) {
	const blockNode = editor.state.doc.nodeAt(blockPos);
	if (!blockNode || from < 0 || to < from || from === to) return {
		runs: [],
		isUniform: true
	};
	const runs = [];
	let offset = 0;
	const maybePushRun = (start, end, marks) => {
		const overlapStart = Math.max(start, from);
		const overlapEnd = Math.min(end, to);
		if (overlapStart >= overlapEnd) return;
		runs.push({
			from: overlapStart,
			to: overlapEnd,
			charCount: overlapEnd - overlapStart,
			marks: marks.filter((m) => !METADATA_MARK_NAMES.has(m.type.name))
		});
	};
	const walkNode = (node) => {
		if (node.isText) {
			const text = node.text ?? "";
			if (text.length > 0) {
				const marks = Array.isArray(node.marks) ? node.marks : [];
				if (options?.textModel === "visible" && marks.some((mark) => mark.type.name === "trackDelete")) return;
				const start = offset;
				const end = offset + text.length;
				maybePushRun(start, end, marks);
				offset = end;
			}
			return;
		}
		if (node.isLeaf) {
			const start = offset;
			offset += 1;
			maybePushRun(start, offset, []);
			return;
		}
		let isFirstChild = true;
		for (let i = 0; i < node.childCount; i++) {
			const child = node.child(i);
			if (child.isBlock && !isFirstChild) offset += 1;
			walkNode(child);
			isFirstChild = false;
		}
	};
	walkNode(blockNode);
	return {
		runs,
		isUniform: checkUniformity(runs)
	};
}
function checkUniformity(runs) {
	if (runs.length <= 1) return true;
	const reference = runs[0].marks;
	for (let i = 1; i < runs.length; i++) if (!marksEqual(reference, runs[i].marks)) return false;
	return true;
}
function marksEqual(a, b) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) if (!a[i].eq(b[i])) return false;
	return true;
}
function isCoreMarkName(markName) {
	return CORE_MARK_NAMES.has(markName);
}
function deriveCoreMarkDirective(run, markName) {
	const spec = TOGGLE_MARK_SPECS[markName];
	const mark = run.marks.find((m) => m.type.name === spec.schemaName);
	if (!mark) return "clear";
	return spec.isOff(mark) ? "off" : "on";
}
function findCoreMarkInState(runs, markName, directive) {
	for (const run of runs) {
		if (deriveCoreMarkDirective(run, markName) !== directive) continue;
		const spec = TOGGLE_MARK_SPECS[markName];
		const found = run.marks.find((m) => m.type.name === spec.schemaName);
		if (found) return found;
	}
}
function createCoreMarkFromState(editor, markName, directive) {
	const spec = TOGGLE_MARK_SPECS[markName];
	const markType = editor.state.schema.marks[spec.schemaName];
	if (!markType) return void 0;
	if (directive === "on") return spec.createOn(markType);
	return markType.create(spec.offAttrs);
}
function resolveMajorityDirectiveForCoreMark(runs, markName) {
	const tally = {
		on: {
			chars: 0,
			firstRunIdx: Number.POSITIVE_INFINITY
		},
		off: {
			chars: 0,
			firstRunIdx: Number.POSITIVE_INFINITY
		},
		clear: {
			chars: 0,
			firstRunIdx: Number.POSITIVE_INFINITY
		}
	};
	for (let i = 0; i < runs.length; i++) {
		const directive = deriveCoreMarkDirective(runs[i], markName);
		tally[directive].chars += runs[i].charCount;
		if (i < tally[directive].firstRunIdx) tally[directive].firstRunIdx = i;
	}
	let winner = "clear";
	for (const directive of [
		"on",
		"off",
		"clear"
	]) {
		const current = tally[directive];
		const best = tally[winner];
		if (current.chars > best.chars || current.chars === best.chars && current.firstRunIdx < best.firstRunIdx) winner = directive;
	}
	return winner;
}
function resolveInlineStyle(editor, captured, policy, stepId) {
	if (policy.mode === "clear") return [];
	if (policy.mode === "set") return buildMarksFromPolicy(editor, policy.setMarks);
	if (policy.requireUniform && !captured.isUniform) throw planError("STYLE_CONFLICT", "matched range has non-uniform inline styles and requireUniform is true", stepId, { runCount: captured.runs.length });
	let resolvedMarks;
	if (captured.isUniform || captured.runs.length === 0) resolvedMarks = captured.runs.length > 0 ? captured.runs[0].marks : [];
	else {
		const strategy = policy.onNonUniform ?? "useLeadingRun";
		if (strategy === "error") throw planError("STYLE_CONFLICT", "matched range has non-uniform inline styles and onNonUniform is \"error\"", stepId, { runCount: captured.runs.length });
		resolvedMarks = applyNonUniformStrategy(editor, captured.runs, strategy);
	}
	if (policy.setMarks) return applySetMarksToResolved(editor, resolvedMarks, policy.setMarks);
	return resolvedMarks;
}
function applyNonUniformStrategy(editor, runs, strategy) {
	switch (strategy) {
		case "useLeadingRun": return resolveUseLeadingRun(runs);
		case "majority": return resolveMajority(editor, runs);
		case "union": return resolveUnion(editor, runs);
	}
}
function resolveUseLeadingRun(runs) {
	return runs.length > 0 ? runs[0].marks : [];
}
function resolveMajority(editor, runs) {
	const totalChars = runs.reduce((sum, r) => sum + r.charCount, 0);
	if (totalChars === 0) return [];
	const allMarkNames = /* @__PURE__ */ new Set();
	for (const run of runs) for (const mark of run.marks) allMarkNames.add(mark.type.name);
	const resultMarks = [];
	for (const markName of allMarkNames) if (isCoreMarkName(markName)) {
		const winningDirective = resolveMajorityDirectiveForCoreMark(runs, markName);
		if (winningDirective === "clear") continue;
		const resolvedMark = findCoreMarkInState(runs, markName, winningDirective) ?? createCoreMarkFromState(editor, markName, winningDirective);
		if (resolvedMark) resultMarks.push(resolvedMark);
	} else resolveValueBearingMarkMajority(runs, markName, totalChars, resultMarks);
	return resultMarks;
}
function resolveValueBearingMarkMajority(runs, markName, totalChars, resultMarks) {
	let anyRunHasMark = false;
	for (const run of runs) if (run.marks.some((m) => m.type.name === markName)) {
		anyRunHasMark = true;
		break;
	}
	if (!anyRunHasMark) return;
	const allAttrKeys = /* @__PURE__ */ new Set();
	const markInstances = [];
	for (const run of runs) {
		const mark = run.marks.find((m) => m.type.name === markName);
		if (mark) {
			markInstances.push({
				mark,
				run
			});
			for (const key$1 of Object.keys(mark.attrs)) allAttrKeys.add(key$1);
		}
	}
	const resolvedAttrs = {};
	let hasAnyAttr = false;
	for (const key$1 of allAttrKeys) {
		const valueTally = /* @__PURE__ */ new Map();
		for (let i = 0; i < runs.length; i++) {
			const run = runs[i];
			const mark = run.marks.find((m) => m.type.name === markName);
			const value = mark ? mark.attrs[key$1] : void 0;
			const serialized = JSON.stringify(value);
			const existing = valueTally.get(serialized);
			if (existing) existing.chars += run.charCount;
			else valueTally.set(serialized, {
				chars: run.charCount,
				firstRunIdx: i,
				value
			});
		}
		let winner;
		for (const entry of valueTally.values()) if (!winner || entry.chars > winner.chars || entry.chars === winner.chars && entry.firstRunIdx < winner.firstRunIdx) winner = entry;
		if (winner && winner.value !== void 0) {
			resolvedAttrs[key$1] = winner.value;
			hasAnyAttr = true;
		}
	}
	if (hasAnyAttr && markInstances.length > 0) {
		const templateMark = markInstances[0].mark;
		try {
			const resolvedMark = templateMark.type.create(resolvedAttrs);
			resultMarks.push(resolvedMark);
		} catch {
			resultMarks.push(templateMark);
		}
	}
}
function resolveUnion(editor, runs) {
	const allMarkNames = /* @__PURE__ */ new Set();
	for (const run of runs) for (const mark of run.marks) allMarkNames.add(mark.type.name);
	const resultMarks = [];
	for (const markName of allMarkNames) if (isCoreMarkName(markName)) {
		const hasOn = runs.some((run) => deriveCoreMarkDirective(run, markName) === "on");
		const hasOff = !hasOn && runs.some((run) => deriveCoreMarkDirective(run, markName) === "off");
		const unionDirective = hasOn ? "on" : hasOff ? "off" : "clear";
		if (unionDirective === "clear") continue;
		const resolvedMark = findCoreMarkInState(runs, markName, unionDirective) ?? createCoreMarkFromState(editor, markName, unionDirective);
		if (resolvedMark) resultMarks.push(resolvedMark);
	} else for (const run of runs) {
		const found = run.marks.find((m) => m.type.name === markName);
		if (found) {
			resultMarks.push(found);
			break;
		}
	}
	return resultMarks;
}
function buildMarksFromPolicy(editor, setMarks) {
	if (!setMarks) return [];
	const { schema } = editor.state;
	const marks = [];
	for (const key$1 of MARK_KEYS) {
		const directive = setMarks[key$1];
		if (!directive) continue;
		const spec = TOGGLE_MARK_SPECS[key$1];
		const markType = schema.marks[spec.schemaName];
		if (!markType) continue;
		if (directive === "on") marks.push(spec.createOn(markType));
		else if (directive === "off") marks.push(markType.create(spec.offAttrs));
	}
	return marks;
}
function applySetMarksToResolved(editor, existingMarks, setMarks) {
	const { schema } = editor.state;
	let marks = [...existingMarks];
	for (const key$1 of MARK_KEYS) {
		const directive = setMarks[key$1];
		if (!directive) continue;
		const spec = TOGGLE_MARK_SPECS[key$1];
		const markType = schema.marks[spec.schemaName];
		if (!markType) continue;
		marks = applyDirectiveToMarks(marks, key$1, directive, markType);
	}
	return marks;
}
function planRepairs(doc, identityMap) {
	if (identityMap) return planRepairsFromIdentityMap(identityMap);
	return planRepairsByWalk(doc);
}
function planRepairsFromIdentityMap(identityMap) {
	let hasDuplicates = false;
	for (const observations of identityMap.values()) if (observations.length > 1) {
		hasDuplicates = true;
		break;
	}
	if (!hasDuplicates) return {
		plans: [],
		report: {
			repairedBlockCount: 0,
			duplicateBlockIds: [],
			renames: []
		}
	};
	const rewrites = [];
	for (const [value, observations] of identityMap) {
		if (observations.length <= 1) continue;
		for (let i = 1; i < observations.length; i += 1) {
			const { pos, attrs } = observations[i];
			rewrites.push({
				pos,
				value,
				attrs
			});
		}
	}
	rewrites.sort((a, b) => a.pos - b.pos);
	const allocateDocxId = createDeterministicDocxIdAllocator(new Set(identityMap.keys()));
	const plansByPos = /* @__PURE__ */ new Map();
	const duplicateBlockIds = [];
	const renames = [];
	for (const { pos, value, attrs } of rewrites) {
		const replacementValue = allocateDocxId();
		let plan = plansByPos.get(pos);
		if (!plan) {
			plan = {
				pos,
				rewrittenGroups: []
			};
			plansByPos.set(pos, plan);
		}
		const attrsCopy = [...attrs];
		plan.rewrittenGroups.push({
			originalValue: value,
			replacementValue,
			attrs: attrsCopy
		});
		duplicateBlockIds.push(value);
		renames.push({
			originalValue: value,
			replacementValue,
			attrs: attrsCopy
		});
	}
	const plans = [...plansByPos.values()].sort((a, b) => a.pos - b.pos);
	return {
		plans,
		report: {
			repairedBlockCount: plans.length,
			duplicateBlockIds,
			renames
		}
	};
}
function planRepairsByWalk(doc) {
	const reservedIds = /* @__PURE__ */ new Set();
	let hasDuplicates = false;
	doc.descendants((node) => {
		const entries = getExplicitIdentityEntries(node.attrs, node.type?.name);
		for (const { value } of groupIdentityEntriesByValue(entries)) if (reservedIds.has(value)) hasDuplicates = true;
		else reservedIds.add(value);
	});
	if (!hasDuplicates) return {
		plans: [],
		report: {
			repairedBlockCount: 0,
			duplicateBlockIds: [],
			renames: []
		}
	};
	const allocateDocxId = createDeterministicDocxIdAllocator(reservedIds);
	const seenIds = /* @__PURE__ */ new Set();
	const plans = [];
	const duplicateBlockIds = [];
	const renames = [];
	doc.descendants((node, pos) => {
		const groups = groupIdentityEntriesByValue(getExplicitIdentityEntries(node.attrs, node.type?.name));
		if (groups.length === 0) return;
		let plan = null;
		for (const group of groups) if (seenIds.has(group.value)) {
			if (!plan) plan = {
				pos,
				rewrittenGroups: []
			};
			const replacementValue = allocateDocxId();
			plan.rewrittenGroups.push({
				originalValue: group.value,
				replacementValue,
				attrs: [...group.attrs]
			});
			duplicateBlockIds.push(group.value);
			renames.push({
				originalValue: group.value,
				replacementValue,
				attrs: [...group.attrs]
			});
			seenIds.add(replacementValue);
		} else seenIds.add(group.value);
		if (plan) plans.push(plan);
	});
	return {
		plans,
		report: {
			repairedBlockCount: plans.length,
			duplicateBlockIds,
			renames
		}
	};
}
function repairDuplicateBlockIdentities(editor) {
	const doc = editor.state?.doc;
	if (!doc || typeof doc.descendants !== "function") return null;
	if (typeof editor.state?.tr !== "object" || editor.state.tr === null) return null;
	if (typeof editor.dispatch !== "function") return null;
	let identityMap;
	try {
		identityMap = getBlockIndex(editor).explicitIdentities;
	} catch {
		identityMap = void 0;
	}
	const { plans, report } = planRepairs(doc, identityMap);
	if (plans.length === 0) return null;
	const tr = editor.state.tr;
	tr.setMeta("addToHistory", false);
	tr.setMeta("superdoc/block-identity-repair", report);
	for (const plan of plans) for (const group of plan.rewrittenGroups) for (const attr of group.attrs) tr.setNodeAttribute(plan.pos, attr, group.replacementValue);
	editor.dispatch(tr);
	const blockedNodeIds = [];
	for (const plan of plans) {
		const node = editor.state.doc.nodeAt(plan.pos);
		if (!node) {
			blockedNodeIds.push(`pos:${plan.pos}`);
			continue;
		}
		for (const group of plan.rewrittenGroups) for (const attr of group.attrs) if (node.attrs?.[attr] !== group.replacementValue) {
			const observedId = typeof node.attrs?.id === "string" && node.attrs.id || typeof node.attrs?.sdBlockId === "string" && node.attrs.sdBlockId || `pos:${plan.pos}`;
			blockedNodeIds.push(observedId);
		}
	}
	if (blockedNodeIds.length > 0) {
		const unique = [...new Set(blockedNodeIds)];
		const MAX_ID_PREVIEW_LENGTH = 32;
		const truncate = (id) => id.length > MAX_ID_PREVIEW_LENGTH ? `${id.slice(0, MAX_ID_PREVIEW_LENGTH - 1)}…` : id;
		const preview = unique.slice(0, 4).map(truncate).join(", ");
		const previewSuffix = unique.length > 4 ? `, +${unique.length - 4} more` : "";
		throw planError("REPAIR_BLOCKED", `Runtime identity repair was rejected by a transaction filter (${unique.length} node${unique.length === 1 ? "" : "s"}: ${preview}${previewSuffix}). A structured-content lock or permission range likely covers one of the duplicate blocks. Re-import the document via doc.open to assign unique identities.`, void 0, {
			blockedNodeIds: unique,
			remediation: "Re-import the document via doc.open to assign unique identities."
		});
	}
	return report;
}
var SNIPPET_PADDING = 30;
var DUAL_KIND_TYPES = new Set(["sdt", "image"]);
var KNOWN_BLOCK_PM_NODE_TYPES = new Set([
	"paragraph",
	"table",
	"tableRow",
	"tableCell",
	"tableHeader",
	"structuredContentBlock",
	"sdt",
	"image"
]);
var KNOWN_INLINE_PM_NODE_TYPES = new Set([
	"text",
	"run",
	"structuredContent",
	"image",
	"tab",
	"lineBreak",
	"hardBreak",
	"hard_break",
	"footnoteReference",
	"bookmarkStart",
	"bookmarkEnd",
	"commentRangeStart",
	"commentRangeEnd"
]);
function getCandidateText(editor, candidate, options) {
	if (candidate.node.childCount > 0) return textContentInBlock(candidate.node, options);
	return editor.state.doc.textBetween(candidate.pos + 1, candidate.end - 1, "\n", "￼");
}
function resolveUnknownBlockId(attrs) {
	if (!attrs) return void 0;
	return toId(attrs.paraId) ?? toId(attrs.sdBlockId) ?? toId(attrs.blockId) ?? toId(attrs.id) ?? toId(attrs.uuid);
}
function isDualKindType(nodeType) {
	return Boolean(nodeType && DUAL_KIND_TYPES.has(nodeType));
}
function getAddressStartPos(editor, index, address) {
	if (address.kind === "block") return findBlockById(index, address)?.pos ?? Number.MAX_SAFE_INTEGER;
	return findInlineByAnchor(getInlineIndex(editor), address)?.pos ?? Number.MAX_SAFE_INTEGER;
}
function buildTextContext(editor, address, matchFrom, matchTo, textRanges, options) {
	if (textRanges?.length) {
		const index = getBlockIndex(editor);
		const firstRange = textRanges[0];
		const lastRange = textRanges[textRanges.length - 1];
		const firstBlock = index.candidates.find((candidate) => candidate.nodeId === firstRange.blockId);
		const lastBlock = index.candidates.find((candidate) => candidate.nodeId === lastRange.blockId);
		if (firstBlock && lastBlock) {
			const matchText = textRanges.map((range) => {
				const block = index.candidates.find((candidate) => candidate.nodeId === range.blockId);
				if (!block) return "";
				return getCandidateText(editor, block, options).slice(range.range.start, range.range.end);
			}).join("\n");
			const firstText = getCandidateText(editor, firstBlock, options);
			const lastText = getCandidateText(editor, lastBlock, options);
			const leftContext = firstText.slice(Math.max(0, firstRange.range.start - SNIPPET_PADDING), firstRange.range.start);
			const snippet$1 = `${leftContext}${matchText}${lastText.slice(lastRange.range.end, lastRange.range.end + SNIPPET_PADDING)}`.replace(/ {2,}/g, " ");
			const prefix$1 = leftContext.replace(/ {2,}/g, " ");
			const normalizedMatch = matchText.replace(/ {2,}/g, " ");
			return {
				address,
				snippet: snippet$1,
				highlightRange: {
					start: prefix$1.length,
					end: prefix$1.length + normalizedMatch.length
				},
				textRanges
			};
		}
	}
	const docSize = editor.state.doc.content.size;
	const snippetFrom = Math.max(0, matchFrom - SNIPPET_PADDING);
	const snippetTo = Math.min(docSize, matchTo + SNIPPET_PADDING);
	const snippet = editor.state.doc.textBetween(snippetFrom, snippetTo, " ").replace(/ {2,}/g, " ");
	const rawPrefix = editor.state.doc.textBetween(snippetFrom, matchFrom, " ");
	const rawMatch = editor.state.doc.textBetween(matchFrom, matchTo, " ");
	const prefix = rawPrefix.replace(/ {2,}/g, " ");
	const matchNormalized = rawMatch.replace(/ {2,}/g, " ");
	return {
		address,
		snippet,
		highlightRange: {
			start: prefix.length,
			end: prefix.length + matchNormalized.length
		},
		textRanges: textRanges?.length ? textRanges : void 0
	};
}
function toTextAddress$1(editor, block, range, options) {
	const blockStart = block.pos + 1;
	const blockEnd = block.end - 1;
	if (range.from < blockStart || range.to > blockEnd) return void 0;
	const start = block.node.childCount > 0 ? pmPositionToTextOffset(block.node, block.pos, range.from, options) : editor.state.doc.textBetween(blockStart, range.from, "\n", "￼").length;
	const end = block.node.childCount > 0 ? pmPositionToTextOffset(block.node, block.pos, range.to, options) : editor.state.doc.textBetween(blockStart, range.to, "\n", "￼").length;
	return {
		kind: "text",
		blockId: block.nodeId,
		range: {
			start,
			end
		}
	};
}
function shouldQueryBothKinds(select) {
	if (select.type === "node") return !select.kind && isDualKindType(select.nodeType);
	return false;
}
function sortAddressesByPosition(editor, index, addresses) {
	return [...addresses].sort((a, b) => {
		const aPos = getAddressStartPos(editor, index, a);
		const bPos = getAddressStartPos(editor, index, b);
		if (aPos !== bPos) return aPos - bPos;
		if (a.kind === b.kind) return 0;
		return a.kind === "block" ? -1 : 1;
	});
}
function collectUnknownNodeDiagnostics(editor, index, diagnostics) {
	editor.state.doc.descendants((node, pos) => {
		if (node.isBlock && !KNOWN_BLOCK_PM_NODE_TYPES.has(node.type.name)) {
			const blockId = resolveUnknownBlockId(node.attrs ?? {});
			diagnostics.push({
				message: `Unknown block node type "${node.type.name}" is not part of the stable Document API match set.`,
				hint: blockId ? `Skipped unknown block with stable id "${blockId}".` : "Skipped unknown block with no stable id available."
			});
			return;
		}
		if (node.isInline && !KNOWN_INLINE_PM_NODE_TYPES.has(node.type.name)) {
			const container = findCandidateByPos(index.candidates, pos);
			diagnostics.push({
				message: `Unknown inline node type "${node.type.name}" is not part of the stable Document API match set.`,
				address: container ? toBlockAddress(container) : void 0,
				hint: container ? `Skipped unknown inline node inside block "${container.nodeType}" with id "${container.nodeId}".` : "Skipped unknown inline node outside resolvable block scope."
			});
		}
	});
}
function isInlineQuery(select) {
	if (select.type === "node") {
		if (select.kind) return select.kind === "inline";
		return Boolean(select.nodeType && isInlineQueryType(select.nodeType));
	}
	return false;
}
var MAX_PATTERN_LENGTH = 1024;
function compileRegex(selector, diagnostics) {
	if (selector.pattern.length > MAX_PATTERN_LENGTH) {
		addDiagnostic(diagnostics, `Text query regex pattern exceeds ${MAX_PATTERN_LENGTH} characters.`);
		return null;
	}
	const flags = selector.caseSensitive ? "g" : "gi";
	try {
		return new RegExp(selector.pattern, flags);
	} catch (error) {
		addDiagnostic(diagnostics, `Invalid text query regex: ${error instanceof Error ? error.message : String(error)}`);
		return null;
	}
}
function buildSearchPattern(selector, diagnostics) {
	if ((selector.mode ?? "contains") === "regex") return compileRegex(selector, diagnostics);
	if (selector.pattern.length > MAX_PATTERN_LENGTH) {
		addDiagnostic(diagnostics, `Text query pattern exceeds ${MAX_PATTERN_LENGTH} characters.`);
		return null;
	}
	const flexible = selector.pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/"/g, "[\"“”„]").replace(/'/g, "['‘’‚]");
	const flags = selector.caseSensitive ? "g" : "gi";
	return new RegExp(flexible, flags);
}
function executeTextSelector(editor, index, query, diagnostics, options = {}) {
	if (query.select.type !== "text") {
		addDiagnostic(diagnostics, `Text strategy received a non-text selector (type="${query.select.type}").`);
		return {
			matches: [],
			total: 0
		};
	}
	const selector = query.select;
	if (!selector.pattern.length) {
		addDiagnostic(diagnostics, "Text query pattern must be non-empty.");
		return {
			matches: [],
			total: 0
		};
	}
	const scope = resolveWithinScope(index, query, diagnostics);
	if (!scope.ok) return {
		matches: [],
		total: 0
	};
	const pattern = buildSearchPattern(selector, diagnostics);
	if (!pattern) return {
		matches: [],
		total: 0
	};
	const search = requireEditorCommand(editor.commands?.search, "find (search)");
	const searchModel = options.searchModel ?? "visible";
	const textOffsetOptions = { textModel: searchModel };
	pattern.lastIndex = 0;
	const rawResult = search(pattern, {
		highlight: false,
		caseSensitive: selector.caseSensitive ?? false,
		maxMatches: Infinity,
		searchModel
	});
	if (!Array.isArray(rawResult)) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "Editor search command returned an unexpected result format.");
	const scopeRange = scope.range;
	const allMatches = rawResult;
	const matches = scopeRange ? allMatches.filter((m) => m.from >= scopeRange.start && m.to <= scopeRange.end) : allMatches;
	const textBlocks = index.candidates.filter(isTextBlockCandidate);
	const contexts = [];
	const addresses = [];
	for (const match of matches) {
		const ranges = match.ranges?.length ? match.ranges : [{
			from: match.from,
			to: match.to
		}];
		let source;
		const textRanges = ranges.map((range) => {
			const block = findCandidateByPos(textBlocks, range.from);
			if (!block) return void 0;
			if (!source) source = block;
			return toTextAddress$1(editor, block, range, textOffsetOptions);
		}).filter((range) => Boolean(range));
		if (!source) source = findCandidateByPos(textBlocks, match.from) ?? findBlockByPos(index, match.from);
		if (!source) continue;
		const address = toBlockAddress(source);
		addresses.push(address);
		contexts.push(buildTextContext(editor, address, match.from, match.to, textRanges, textOffsetOptions));
	}
	const paged = paginate(addresses, query.offset, query.limit);
	const pagedContexts = paginate(contexts, query.offset, query.limit).items;
	return {
		matches: paged.items,
		total: paged.total,
		context: pagedContexts.length ? pagedContexts : void 0
	};
}
function executeBlockSelector(index, query, diagnostics) {
	const scope = resolveWithinScope(index, query, diagnostics);
	if (!scope.ok) return {
		matches: [],
		total: 0
	};
	const scoped = scopeByRange(index.candidates, scope.range);
	const select = query.select;
	let filtered = [];
	if (select.type === "node") if (select.kind && select.kind !== "block") addDiagnostic(diagnostics, "Only block nodes are supported by the current adapter.");
	else filtered = scoped.filter((candidate) => {
		if (select.nodeType) {
			if (candidate.nodeType !== select.nodeType) return false;
		}
		return true;
	});
	const paged = paginate(filtered.map((candidate) => ({
		kind: "block",
		nodeType: candidate.nodeType,
		nodeId: candidate.nodeId
	})), query.offset, query.limit);
	return {
		matches: paged.items,
		total: paged.total
	};
}
function resolveTextPoint(editor, index, point) {
	const candidate = findTextBlockByNodeId(index, point.blockId);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Block "${point.blockId}" not found.`, {
		field: "blockId",
		value: point.blockId
	});
	const resolved = resolveTextRangeInBlock(candidate.node, candidate.pos, {
		start: point.offset,
		end: point.offset
	}, { textModel: "visible" });
	if (!resolved) throw new DocumentApiAdapterError("INVALID_TARGET", `Offset ${point.offset} is out of range in block "${point.blockId}".`, {
		field: "offset",
		value: point.offset,
		blockId: point.blockId
	});
	return resolved.from;
}
function resolveNodeEdgePoint(index, point) {
	const { node, edge } = point;
	const candidate = findBlockByTypeAndId(index, node.nodeType, node.nodeId);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Node "${node.nodeType}" with id "${node.nodeId}" not found.`, {
		field: "nodeId",
		value: node.nodeId,
		nodeType: node.nodeType
	});
	if (candidate.nodeType !== node.nodeType) throw new DocumentApiAdapterError("INVALID_TARGET", `Node "${node.nodeId}" has type "${candidate.nodeType}", expected "${node.nodeType}".`, {
		field: "nodeType",
		expected: node.nodeType,
		actual: candidate.nodeType
	});
	return edge === "before" ? candidate.pos : candidate.end;
}
function resolvePoint(editor, index, point) {
	if (point.kind === "text") return resolveTextPoint(editor, index, point);
	return resolveNodeEdgePoint(index, point);
}
function resolveSelectionPointPosition(editor, point) {
	return resolvePoint(editor, getBlockIndex(editor), point);
}
function resolveSelectionTarget(editor, target) {
	const index = getBlockIndex(editor);
	const rawFrom = resolvePoint(editor, index, target.start);
	const rawTo = resolvePoint(editor, index, target.end);
	const absFrom = Math.min(rawFrom, rawTo);
	const absTo = Math.max(rawFrom, rawTo);
	return {
		absFrom,
		absTo,
		text: editor.state.doc.textBetween(absFrom, absTo, "\n", "￼")
	};
}
function findTextBlockByNodeId(index, nodeId) {
	const matches = index.candidates.filter((c) => c.nodeId === nodeId && isTextBlockCandidate(c));
	if (matches.length > 1) throw new DocumentApiAdapterError("INVALID_TARGET", `Block ID "${nodeId}" is ambiguous: matched ${matches.length} text blocks.`, {
		blockId: nodeId,
		matchCount: matches.length
	});
	if (matches.length === 1) return matches[0];
	try {
		const resolved = findBlockByNodeIdOnly(index, nodeId);
		if (isTextBlockCandidate(resolved)) return resolved;
	} catch (e) {
		if (e instanceof DocumentApiAdapterError && e.code === "AMBIGUOUS_TARGET") throw e;
	}
}
function findBlockByTypeAndId(index, nodeType, nodeId) {
	const key$1 = `${nodeType}:${nodeId}`;
	if (index.ambiguous.has(key$1)) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple blocks share key "${key$1}".`, {
		nodeType,
		nodeId
	});
	const exact = index.byId.get(key$1);
	if (exact) return exact;
	try {
		return findBlockByNodeIdOnly(index, nodeId);
	} catch (e) {
		if (e instanceof DocumentApiAdapterError && e.code === "AMBIGUOUS_TARGET") throw e;
	}
}
function expandDeleteSelection(editor, absFrom, absTo, start, end) {
	if (absFrom === absTo) return {
		absFrom,
		absTo
	};
	const index = getBlockIndex(editor);
	return {
		absFrom: maybeExpandStart(index, absFrom, start),
		absTo: maybeExpandEnd(index, absTo, end)
	};
}
function maybeExpandStart(index, absFrom, point) {
	if (point.kind === "nodeEdge") return absFrom;
	const block = findInnermostTextBlock(index, absFrom);
	if (!block) return absFrom;
	if (absFrom <= block.pos + 1) return block.pos;
	return absFrom;
}
function maybeExpandEnd(index, absTo, point) {
	if (point.kind === "nodeEdge") return absTo;
	const block = findInnermostTextBlock(index, absTo);
	if (!block) return absTo;
	if (absTo >= block.end - 1) return block.end;
	return absTo;
}
function findInnermostTextBlock(index, pos) {
	let best;
	if (!findBlockByPos(index, pos)) return void 0;
	for (const candidate of index.candidates) {
		if (candidate.pos > pos) break;
		if (candidate.end < pos) continue;
		if (!isTextBlockCandidate(candidate)) continue;
		if (!best || candidate.end - candidate.pos < best.end - best.pos) best = candidate;
	}
	return best;
}
function isAssertStep(step) {
	return step.op === "assert";
}
function isCreateOp(op) {
	return op === "create.heading" || op === "create.paragraph";
}
var VALID_CREATE_POSITIONS = ["before", "after"];
function isSelectWhere(where) {
	return where.by === "select";
}
function isRefWhere(where) {
	return where.by === "ref";
}
function isTargetWhere(where) {
	return where.by === "target";
}
function isBlockWhere(where) {
	return where.by === "block";
}
function validateCreateStepPosition(step) {
	const args = step.args;
	if (args.position === void 0 || args.position === null) {
		args.position = "after";
		return;
	}
	if (!VALID_CREATE_POSITIONS.includes(args.position)) throw planError("INVALID_INPUT", `create step requires args.position to be 'before' or 'after'`, step.id, {
		receivedPosition: args.position,
		allowedValues: [...VALID_CREATE_POSITIONS],
		default: "after"
	});
}
function resolveCreateAnchorFromTargets(targets, position, stepId) {
	const target = targets[0];
	if (!target) throw planError("INVALID_INPUT", "create step has no resolved targets", stepId);
	if (target.kind === "range") return target.blockId;
	if (target.kind === "span") {
		const segments = target.segments;
		if (!segments.length) throw planError("INVALID_INPUT", "span target has no segments", stepId);
		return position === "before" ? segments[0].blockId : segments[segments.length - 1].blockId;
	}
	if (target.segments && target.segments.length > 0) return position === "before" ? target.segments[0].blockId : target.segments[target.segments.length - 1].blockId;
	throw planError("INVALID_INPUT", "selection target has no block identity for create anchor", stepId);
}
function validateInsertionContext(editor, index, step, stepIndex, anchorBlockId, position) {
	const candidate = index.candidates.find((c) => c.nodeId === anchorBlockId);
	if (!candidate) return;
	const paragraphType = editor.state.schema?.nodes?.paragraph;
	if (!paragraphType) return;
	const resolvedPos = editor.state.doc.resolve(candidate.pos);
	const parent = resolvedPos.parent;
	const anchorIndex = resolvedPos.index();
	const insertionIndex = position === "before" ? anchorIndex : anchorIndex + 1;
	if (!(typeof parent.canReplaceWith === "function" ? parent.canReplaceWith(insertionIndex, insertionIndex, paragraphType) : parent.type.contentMatch.matchType(paragraphType))) {
		const allowedChildTypes = [];
		const match = parent.type.contentMatch;
		for (const nodeType of Object.values(editor.state.schema.nodes)) if (match.matchType(nodeType)) allowedChildTypes.push(nodeType.name);
		throw planError("INVALID_INSERTION_CONTEXT", `Cannot create ${step.op} inside ${parent.type.name}`, step.id, {
			stepIndex,
			stepId: step.id,
			operation: step.op,
			anchorBlockId,
			parentType: parent.type.name,
			allowedChildTypes,
			insertionIndex,
			requestedChildType: "paragraph",
			requestedSemanticType: step.op === "create.heading" ? "heading" : "paragraph"
		});
	}
}
function resolveAbsoluteRange(editor, candidate, from, to, stepId, options) {
	const resolved = resolveTextRangeInBlock(candidate.node, candidate.pos, {
		start: from,
		end: to
	}, options);
	if (!resolved) throw planError("INVALID_INPUT", `text offset [${from}, ${to}) out of range in block`, stepId);
	return {
		absFrom: resolved.from,
		absTo: resolved.to
	};
}
function normalizeMatchRanges(stepId, ranges) {
	const span = normalizeMatchSpan(stepId, ranges);
	if (span.kind === "cross-block") throw planError("CROSS_BLOCK_MATCH", `mutation target spans multiple blocks`, stepId, { blockIds: span.segments.map((s) => s.blockId) });
	return {
		blockId: span.blockId,
		from: span.from,
		to: span.to
	};
}
function normalizeMatchSpan(stepId, ranges) {
	if (ranges.length === 0) throw planError("INVALID_INPUT", "logical match produced zero ranges", stepId);
	for (const r of ranges) if (r.range.start < 0 || r.range.end < r.range.start) throw planError("INVALID_INPUT", `invalid range bounds [${r.range.start}, ${r.range.end}) in block "${r.blockId}"`, stepId);
	const byBlock = groupRangesByBlock(ranges);
	const blockIds = [...byBlock.keys()];
	if (blockIds.length === 1) {
		const blockId = blockIds[0];
		const coalesced = coalesceBlockRanges(stepId, blockId, byBlock.get(blockId));
		return {
			kind: "single-block",
			blockId,
			from: coalesced.from,
			to: coalesced.to
		};
	}
	const segments = [];
	for (const blockId of blockIds) {
		const coalesced = coalesceBlockRanges(stepId, blockId, byBlock.get(blockId));
		segments.push({
			blockId,
			from: coalesced.from,
			to: coalesced.to
		});
	}
	return {
		kind: "cross-block",
		segments
	};
}
function groupRangesByBlock(ranges) {
	const byBlock = /* @__PURE__ */ new Map();
	for (const r of ranges) {
		let group = byBlock.get(r.blockId);
		if (!group) {
			group = [];
			byBlock.set(r.blockId, group);
		}
		group.push(r);
	}
	return byBlock;
}
function coalesceBlockRanges(stepId, blockId, ranges) {
	if (ranges.length === 1) return {
		from: ranges[0].range.start,
		to: ranges[0].range.end
	};
	const sorted = [...ranges].sort((a, b) => a.range.start - b.range.start);
	const from = sorted[0].range.start;
	let to = sorted[0].range.end;
	for (let i = 1; i < sorted.length; i++) {
		const r = sorted[i];
		if (r.range.start > to) throw planError("INVALID_INPUT", `match ranges are discontiguous within block "${blockId}" (gap between offset ${to} and ${r.range.start})`, stepId);
		if (r.range.end > to) to = r.range.end;
	}
	return {
		from,
		to
	};
}
function buildRangeTarget(editor, step, addr, candidate) {
	const textOffsetOptions = { textModel: addr.textModel };
	const abs = resolveAbsoluteRange(editor, candidate, addr.from, addr.to, step.id, textOffsetOptions);
	const capturedStyle = step.op === "text.rewrite" || step.op === "format.apply" ? captureRunsInRange(editor, candidate.pos, addr.from, addr.to, textOffsetOptions) : void 0;
	return {
		kind: "range",
		stepId: step.id,
		op: step.op,
		blockId: addr.blockId,
		from: addr.from,
		to: addr.to,
		absFrom: abs.absFrom,
		absTo: abs.absTo,
		text: addr.text,
		marks: addr.marks,
		capturedStyle
	};
}
function buildSpanTarget(editor, index, step, segments, matchId, textModel = "visible") {
	validateSegmentOrder(editor, index, segments, step.id);
	const compiledSegments = [];
	const capturedStyles = [];
	const textParts = [];
	for (const seg of segments) {
		const candidate = index.candidates.find((c) => c.nodeId === seg.blockId);
		if (!candidate) throw planError("INVALID_INPUT", `block "${seg.blockId}" not found for span segment`, step.id);
		const textOffsetOptions = { textModel };
		const abs = resolveAbsoluteRange(editor, candidate, seg.from, seg.to, step.id, textOffsetOptions);
		compiledSegments.push({
			blockId: seg.blockId,
			from: seg.from,
			to: seg.to,
			absFrom: abs.absFrom,
			absTo: abs.absTo
		});
		const blockText = getBlockText(editor, candidate, textOffsetOptions);
		textParts.push(blockText.slice(seg.from, seg.to));
		if (step.op === "text.rewrite" || step.op === "format.apply") capturedStyles.push(captureRunsInRange(editor, candidate.pos, seg.from, seg.to, textOffsetOptions));
	}
	return {
		kind: "span",
		stepId: step.id,
		op: step.op,
		matchId,
		segments: compiledSegments,
		text: textParts.join(""),
		marks: [],
		capturedStyleBySegment: capturedStyles.length > 0 ? capturedStyles : void 0
	};
}
function validateSegmentOrder(_editor, index, segments, stepId) {
	const orderedCandidates = [...index.candidates].sort((a, b) => a.pos - b.pos);
	const orderByBlockId = /* @__PURE__ */ new Map();
	for (let i = 0; i < orderedCandidates.length; i++) {
		const id = orderedCandidates[i].nodeId;
		if (!orderByBlockId.has(id)) orderByBlockId.set(id, i);
	}
	let lastOrder = -1;
	let previousBlockId;
	for (const seg of segments) {
		if (!index.candidates.find((c) => c.nodeId === seg.blockId)) throw planError("INVALID_INPUT", `unknown block "${seg.blockId}" in span target`, stepId);
		const currentOrder = orderByBlockId.get(seg.blockId);
		if (currentOrder === void 0) throw planError("INVALID_INPUT", `unknown block "${seg.blockId}" in span target`, stepId);
		if (currentOrder <= lastOrder) throw planError("INVALID_INPUT", `span segments are not in strict document order (block "${seg.blockId}" appears before or at the same position as a prior segment)`, stepId);
		if (lastOrder >= 0 && currentOrder !== lastOrder + 1) throw planError("INVALID_INPUT", `span segments are not contiguous in document order (gap between "${previousBlockId}" and "${seg.blockId}")`, stepId);
		lastOrder = currentOrder;
		previousBlockId = seg.blockId;
	}
}
function resolveTextSelector(editor, index, selector, within, stepId, options) {
	const textModel = options?.textModel ?? "visible";
	const textOffsetOptions = { textModel };
	if (selector.type === "text") {
		const result$1 = executeTextSelector(editor, index, {
			select: selector,
			within,
			includeNodes: false
		}, [], { searchModel: textModel });
		const addresses$1 = [];
		if (result$1.context) for (const ctx of result$1.context) {
			if (!ctx.textRanges?.length) continue;
			const coalesced = normalizeMatchRanges(stepId, ctx.textRanges);
			const candidate = index.candidates.find((c) => c.nodeId === coalesced.blockId);
			if (!candidate) continue;
			const matchText = getBlockText(editor, candidate, textOffsetOptions).slice(coalesced.from, coalesced.to);
			const captured = captureRunsInRange(editor, candidate.pos, coalesced.from, coalesced.to, textOffsetOptions);
			addresses$1.push({
				blockId: coalesced.blockId,
				from: coalesced.from,
				to: coalesced.to,
				text: matchText,
				marks: captured.runs.length > 0 ? captured.runs[0].marks : [],
				blockPos: candidate.pos,
				textModel
			});
		}
		return { addresses: addresses$1 };
	}
	const result = executeBlockSelector(index, {
		select: selector,
		within,
		includeNodes: false
	}, []);
	const eligibleCandidates = options?.allBlockTypes ? index.candidates : index.candidates.filter(isTextBlockCandidate);
	const addresses = [];
	for (const match of result.matches) {
		if (match.kind !== "block") continue;
		const candidate = eligibleCandidates.find((c) => c.nodeId === match.nodeId);
		if (!candidate) continue;
		if (isTextBlockCandidate(candidate)) {
			const blockText = getBlockText(editor, candidate, textOffsetOptions);
			addresses.push({
				blockId: match.nodeId,
				from: 0,
				to: blockText.length,
				text: blockText,
				marks: [],
				blockPos: candidate.pos,
				textModel
			});
		} else addresses.push({
			blockId: match.nodeId,
			from: 0,
			to: 0,
			text: "",
			marks: [],
			blockPos: candidate.pos,
			textModel
		});
	}
	return { addresses };
}
function getBlockText(editor, candidate, options = { textModel: "visible" }) {
	if (candidate.node && candidate.node.childCount > 0) return textContentInBlock(candidate.node, options);
	const blockStart = candidate.pos + 1;
	const blockEnd = candidate.end - 1;
	return editor.state.doc.textBetween(blockStart, blockEnd, "\n", "￼");
}
function resolveV3TextRef(editor, index, step, refData) {
	const currentRevision = getRevision(editor);
	if (refData.rev !== currentRevision) throw planError("REVISION_MISMATCH", `Text ref is ephemeral and revision-scoped. Re-run query.match to obtain a fresh handle.ref for revision ${currentRevision}.`, step.id, {
		refRevision: refData.rev,
		currentRevision,
		refStability: "ephemeral",
		refScope: refData.scope,
		blockId: refData.segments?.[0]?.blockId,
		remediation: `Re-run query.match() to obtain a fresh ref valid for the current revision.`
	});
	if (!refData.segments?.length) return [];
	const segments = refData.segments.map((s) => ({
		blockId: s.blockId,
		from: s.start,
		to: s.end
	}));
	if (segments.length === 1) {
		const seg = segments[0];
		const candidate = index.candidates.find((c) => c.nodeId === seg.blockId);
		if (!candidate) return [];
		const matchText = getBlockText(editor, candidate).slice(seg.from, seg.to);
		const target = buildRangeTarget(editor, step, {
			blockId: seg.blockId,
			from: seg.from,
			to: seg.to,
			text: matchText,
			marks: [],
			blockPos: candidate.pos,
			textModel: "visible"
		}, candidate);
		target.matchId = refData.matchId;
		return [target];
	}
	return [buildSpanTarget(editor, index, step, segments, refData.matchId, "visible")];
}
function resolveV4TextRef(editor, index, step, refData) {
	if (refData.scope === "node" && refData.node?.nodeId) return resolveBlockRef(editor, index, step, refData.node.nodeId);
	const currentRevision = getRevision(editor);
	if (refData.rev !== currentRevision) throw planError("REVISION_MISMATCH", `Text ref is ephemeral and revision-scoped. Re-run query.match to obtain a fresh handle.ref for revision ${currentRevision}.`, step.id, {
		refRevision: refData.rev,
		currentRevision,
		refStability: "ephemeral",
		storyKey: refData.storyKey,
		remediation: "Re-run query.match() to obtain a fresh ref valid for the current revision."
	});
	if (!refData.segments?.length) return [];
	const segments = refData.segments.map((s) => ({
		blockId: s.blockId,
		from: s.start,
		to: s.end
	}));
	if (segments.length === 1) {
		const seg = segments[0];
		const candidate = index.candidates.find((c) => c.nodeId === seg.blockId);
		if (!candidate) return [];
		const matchText = getBlockText(editor, candidate).slice(seg.from, seg.to);
		const target = buildRangeTarget(editor, step, {
			blockId: seg.blockId,
			from: seg.from,
			to: seg.to,
			text: matchText,
			marks: [],
			blockPos: candidate.pos,
			textModel: "visible"
		}, candidate);
		if (refData.matchId) target.matchId = refData.matchId;
		return [target];
	}
	return [buildSpanTarget(editor, index, step, segments, refData.matchId ?? `v4:${step.id}`, "visible")];
}
function resolveTextRef(editor, index, step, ref) {
	const decoded = decodeRef(ref);
	if (!decoded) throw planError("INVALID_INPUT", "invalid text ref encoding", step.id);
	if (decoded.v === 4) return resolveV4TextRef(editor, index, step, decoded);
	return resolveV3TextRef(editor, index, step, decoded);
}
function resolveBlockRef(editor, index, step, ref) {
	const primaryMatches = index.candidates.filter((c) => c.nodeId === ref);
	if (primaryMatches.length > 1) throw planError("AMBIGUOUS_TARGET", `Multiple blocks share nodeId "${ref}".`, step.id, {
		ref,
		count: primaryMatches.length
	});
	const candidate = primaryMatches[0] ?? resolveBlockAlias(index, ref);
	if (!candidate) return [];
	const blockText = getBlockText(editor, candidate);
	return [buildRangeTarget(editor, step, {
		blockId: candidate.nodeId,
		from: 0,
		to: blockText.length,
		text: blockText,
		marks: [],
		blockPos: candidate.pos,
		textModel: "visible"
	}, candidate)];
}
var REF_HANDLERS = [
	{
		prefix: "text:",
		handler: resolveTextRef
	},
	{
		prefix: "tc:",
		handler: (_editor, _index, step, ref) => {
			throw planError("INVALID_INPUT", `entity ref "${ref}" (tracked change) cannot be used as a text mutation target`, step.id);
		}
	},
	{
		prefix: "comment:",
		handler: (_editor, _index, step, ref) => {
			throw planError("INVALID_INPUT", `entity ref "${ref}" (comment) cannot be used as a text mutation target`, step.id);
		}
	},
	{
		prefix: "",
		handler: resolveBlockRef
	}
];
function dispatchRefHandler(editor, index, step, ref) {
	for (const entry of REF_HANDLERS) if (entry.prefix === "" || ref.startsWith(entry.prefix)) return entry.handler(editor, index, step, ref);
	return resolveBlockRef(editor, index, step, ref);
}
function resolveRefTargets(editor, index, step, where) {
	return dispatchRefHandler(editor, index, step, where.ref);
}
function resolveTargetWhereClause(editor, step, where) {
	const resolved = resolveSelectionTarget(editor, where.target);
	let { absFrom, absTo } = resolved;
	const args = step.args;
	if (step.op === "text.delete" && args?.behavior !== "exact") {
		const rawStartPos = resolveSelectionPointPosition(editor, where.target.start);
		const fromPoint = rawStartPos === absFrom ? where.target.start : where.target.end;
		const toPoint = rawStartPos === absFrom ? where.target.end : where.target.start;
		const expanded = expandDeleteSelection(editor, absFrom, absTo, fromPoint, toPoint);
		absFrom = expanded.absFrom;
		absTo = expanded.absTo;
	}
	const text = absFrom !== resolved.absFrom || absTo !== resolved.absTo ? editor.state.doc.textBetween(absFrom, absTo, "\n", "￼") : resolved.text;
	const capturedStyle = step.op === "text.rewrite" || step.op === "format.apply" ? captureStyleAtAbsoluteRange(editor, absFrom, absTo) : void 0;
	return {
		kind: "selection",
		stepId: step.id,
		op: step.op,
		absFrom,
		absTo,
		normalizedTarget: where.target,
		text,
		capturedStyle
	};
}
function buildWholeBlockRangeTarget(editor, step, candidate) {
	if (isTextBlockCandidate(candidate)) {
		const blockText = getBlockText(editor, candidate);
		return buildRangeTarget(editor, step, {
			blockId: candidate.nodeId,
			from: 0,
			to: blockText.length,
			text: blockText,
			marks: [],
			blockPos: candidate.pos,
			textModel: "visible"
		}, candidate);
	}
	return {
		kind: "range",
		stepId: step.id,
		op: step.op,
		blockId: candidate.nodeId,
		from: 0,
		to: 0,
		absFrom: candidate.pos,
		absTo: candidate.end,
		text: "",
		marks: [],
		capturedStyle: void 0
	};
}
function resolveBlockWhereClause(editor, index, step, where) {
	const key$1 = `${where.nodeType}:${where.nodeId}`;
	if (index.ambiguous.has(key$1)) throw planError("AMBIGUOUS_TARGET", `block "${key$1}" matched multiple blocks`, step.id, {
		stepId: step.id,
		stepOp: step.op,
		whereBy: "block",
		target: {
			nodeType: where.nodeType,
			nodeId: where.nodeId
		}
	});
	const candidate = index.byId.get(key$1);
	if (!candidate) throw planError("TARGET_NOT_FOUND", `block "${key$1}" was not found`, step.id, {
		stepId: step.id,
		stepOp: step.op,
		whereBy: "block",
		target: {
			nodeType: where.nodeType,
			nodeId: where.nodeId
		}
	});
	if (!isCreateOp(step.op) && !isTextBlockCandidate(candidate)) throw planError("INVALID_TARGET", `step "${step.op}" requires a text-bearing block for where.by "block", but "${where.nodeType}" is not text-bearing`, step.id, {
		stepId: step.id,
		stepOp: step.op,
		whereBy: "block",
		target: {
			nodeType: where.nodeType,
			nodeId: where.nodeId
		}
	});
	return buildWholeBlockRangeTarget(editor, step, candidate);
}
function captureStyleAtAbsoluteRange(editor, absFrom, absTo) {
	const doc = editor.state.doc;
	const allRuns = [];
	let runOffset = 0;
	doc.nodesBetween(absFrom, absTo, (node, pos) => {
		if (!node.isTextblock) return true;
		const blockEnd = pos + node.nodeSize;
		const overlapFrom = Math.max(absFrom, pos + 1);
		const overlapTo = Math.min(absTo, blockEnd - 1);
		if (overlapFrom >= overlapTo) return false;
		const relFrom = overlapFrom - pos - 1;
		const relTo = overlapTo - pos - 1;
		const captured = captureRunsInRange(editor, pos, relFrom, relTo);
		for (const run of captured.runs) allRuns.push({
			...run,
			from: runOffset + (run.from - relFrom),
			to: runOffset + (run.to - relFrom)
		});
		runOffset += relTo - relFrom;
		return false;
	});
	if (allRuns.length === 0) return void 0;
	return {
		runs: allRuns,
		isUniform: checkUniformity(allRuns)
	};
}
function resolveStepTargets(editor, index, step, options = {}) {
	const where = step.where;
	const refWhere = isRefWhere(where) ? where : void 0;
	const selectWhere = isSelectWhere(where) ? where : void 0;
	const targetWhere = isTargetWhere(where) ? where : void 0;
	const blockWhere = isBlockWhere(where) ? where : void 0;
	let targets;
	if (targetWhere) targets = [resolveTargetWhereClause(editor, step, targetWhere)];
	else if (blockWhere) targets = [resolveBlockWhereClause(editor, index, step, blockWhere)];
	else if (refWhere) targets = resolveRefTargets(editor, index, step, refWhere);
	else if (selectWhere) {
		const isStructuralOp = step.op === "structural.insert" || step.op === "structural.replace";
		targets = resolveTextSelector(editor, index, selectWhere.select, selectWhere.within, step.id, {
			allBlockTypes: isStructuralOp,
			textModel: options.selectTextModel ?? "visible"
		}).addresses.map((addr) => {
			const candidate = index.candidates.find((c) => c.nodeId === addr.blockId);
			if (!candidate) throw planError("TARGET_NOT_FOUND", `block "${addr.blockId}" not in index`, step.id);
			if (isStructuralOp && !isTextBlockCandidate(candidate)) return {
				kind: "range",
				stepId: step.id,
				op: step.op,
				blockId: addr.blockId,
				from: 0,
				to: 0,
				absFrom: candidate.pos,
				absTo: candidate.pos + candidate.node.nodeSize,
				text: "",
				marks: [],
				capturedStyle: void 0
			};
			return buildRangeTarget(editor, step, addr, candidate);
		});
	} else throw planError("INVALID_INPUT", "unsupported where.by value", step.id);
	targets.sort((a, b) => {
		if (a.kind === "range" && b.kind === "range") {
			if (a.blockId === b.blockId) return a.from - b.from;
			return a.absFrom - b.absFrom;
		}
		return (a.kind === "span" ? a.segments[0].absFrom : a.absFrom) - (b.kind === "span" ? b.segments[0].absFrom : b.absFrom);
	});
	targets = targets.filter((t, i) => {
		if (i === 0) return true;
		const prev = targets[i - 1];
		if (t.kind !== "range" || prev.kind !== "range") return true;
		return t.blockId !== prev.blockId || t.from !== prev.from || t.to !== prev.to;
	});
	if (targetWhere || blockWhere) return targets;
	if (refWhere) {
		if (targets.length === 0) throw planError("MATCH_NOT_FOUND", `ref "${refWhere.ref}" did not resolve to any targets`, step.id, {
			selectorType: "ref",
			selectorPattern: refWhere.ref,
			candidateCount: 0
		});
		if (targets.length > 1) throw planError("AMBIGUOUS_MATCH", `ref "${refWhere.ref}" resolved to ${targets.length} targets`, step.id, { matchCount: targets.length });
		return targets;
	}
	if (!selectWhere) throw planError("INVALID_INPUT", "unsupported where.by value", step.id);
	applyCardinalityCheck(step, targets, editor);
	if (selectWhere.require === "first" && targets.length > 1) targets = [targets[0]];
	return targets;
}
function buildMatchNotFoundDetails(step, editor) {
	const where = step.where;
	const select = "select" in where ? where.select : void 0;
	const within = "within" in where ? where.within : void 0;
	let textPreview;
	if (editor) {
		const rawDocSize = editor.state.doc.content?.size;
		const len = typeof rawDocSize === "number" ? Math.min(rawDocSize, 300) : 300;
		if (len > 0 && typeof editor.state.doc.textBetween === "function") textPreview = editor.state.doc.textBetween(0, len, "\n", "\n");
	}
	return {
		stepId: step.id,
		stepOp: step.op,
		whereBy: where.by,
		selectorType: select?.type ?? "unknown",
		selectorPattern: select?.pattern ?? "",
		selectorMode: select?.mode ?? "contains",
		searchScope: within?.nodeId ? `${within.nodeType ?? "block"}:${within.nodeId}` : "document",
		candidateCount: 0,
		...textPreview ? { textPreview } : {}
	};
}
function buildMatchNotFoundMessage(step) {
	const where = step.where;
	const select = "select" in where ? where.select : void 0;
	const within = "within" in where ? where.within : void 0;
	const selectorDescription = select?.type === "node" ? `node selector for "${select.nodeType ?? "unknown"}"` : `text selector for "${select?.pattern ?? ""}"`;
	const scopeDescription = within?.nodeId ? ` within ${within.nodeType ?? "block"}:${within.nodeId}` : "";
	return `step "${step.id}" (${step.op}) matched zero ranges for ${selectorDescription}${scopeDescription}`;
}
function applyCardinalityCheck(step, targets, editor) {
	const where = step.where;
	if (!("require" in where) || where.require === void 0) return;
	const require = where.require;
	if (require === "first") {
		if (targets.length === 0) throw planError("MATCH_NOT_FOUND", buildMatchNotFoundMessage(step), step.id, buildMatchNotFoundDetails(step, editor));
	} else if (require === "exactlyOne") {
		if (targets.length === 0) throw planError("MATCH_NOT_FOUND", buildMatchNotFoundMessage(step), step.id, buildMatchNotFoundDetails(step, editor));
		if (targets.length > 1) throw planError("AMBIGUOUS_MATCH", `selector matched ${targets.length} ranges, expected exactly one`, step.id, { matchCount: targets.length });
	} else if (require === "all") {
		if (targets.length === 0) throw planError("MATCH_NOT_FOUND", buildMatchNotFoundMessage(step), step.id, buildMatchNotFoundDetails(step, editor));
	}
}
const STEP_INTERACTION_MATRIX = new Map([
	["text.rewrite::format.apply::same_target", "allow"],
	["text.rewrite::text.rewrite::same_target", "reject"],
	["text.rewrite::text.delete::overlapping", "reject"],
	["text.rewrite::create.*::same_block", "allow"],
	["text.rewrite::text.insert::same_target", "reject"],
	["format.apply::format.apply::same_target", "allow"],
	["format.apply::text.rewrite::same_target", "reject"],
	["format.apply::text.delete::overlapping", "reject"],
	["format.apply::create.*::same_block", "allow"],
	["format.apply::text.insert::same_target", "allow"],
	["text.delete::text.rewrite::overlapping", "reject"],
	["text.delete::text.delete::overlapping", "reject"],
	["text.delete::format.apply::overlapping", "reject"],
	["text.delete::create.*::same_block", "allow"],
	["text.delete::text.insert::overlapping", "reject"],
	["create.*::text.rewrite::same_block", "allow"],
	["create.*::format.apply::same_block", "allow"],
	["create.*::text.delete::same_block", "allow"],
	["create.*::create.*::same_block", "allow"],
	["create.*::text.insert::same_block", "allow"],
	["text.insert::format.apply::same_target", "allow"],
	["text.insert::text.rewrite::same_target", "reject"],
	["text.insert::text.delete::overlapping", "reject"],
	["text.insert::create.*::same_block", "allow"],
	["text.insert::text.insert::same_target", "reject"]
]);
const MATRIX_EXEMPT_OPS = new Set(["assert"]);
function normalizeOpForMatrix(op) {
	return op.startsWith("create.") ? "create.*" : op;
}
function classifyOverlap(stepA, stepB, index) {
	const rangesA = extractBlockRanges(stepA, index);
	const rangesB = extractBlockRanges(stepB, index);
	const opA = normalizeOpForMatrix(stepA.step.op);
	const opB = normalizeOpForMatrix(stepB.step.op);
	const isCreateA = opA === "create.*";
	const isCreateB = opB === "create.*";
	for (const [blockId, aEntries] of rangesA) {
		const bEntries = rangesB.get(blockId);
		if (!bEntries) continue;
		for (const a of aEntries) for (const b of bEntries) {
			if (isCreateA || isCreateB) return {
				overlapClass: "same_block",
				blockId,
				rangeA: a,
				rangeB: b
			};
			if (a.to <= b.from || b.to <= a.from) continue;
			if (a.from === b.from && a.to === b.to) return {
				overlapClass: "same_target",
				blockId,
				rangeA: a,
				rangeB: b
			};
			return {
				overlapClass: "overlapping",
				blockId,
				rangeA: a,
				rangeB: b
			};
		}
	}
}
function extractBlockRanges(compiled, index) {
	const result = /* @__PURE__ */ new Map();
	for (const target of compiled.targets) if (target.kind === "range") pushBlockRange(result, target.blockId, target.absFrom, target.absTo);
	else if (target.kind === "span") for (const seg of target.segments) pushBlockRange(result, seg.blockId, seg.absFrom, seg.absTo);
	else {
		const sel = target;
		const coveredBlocks = findCoveredBlocks(index, sel.absFrom, sel.absTo);
		if (coveredBlocks.length > 0) for (const blockId of coveredBlocks) pushBlockRange(result, blockId, sel.absFrom, sel.absTo);
		else pushBlockRange(result, `__unresolved_${sel.absFrom}_${sel.absTo}__`, sel.absFrom, sel.absTo);
	}
	return result;
}
function findCoveredBlocks(index, absFrom, absTo) {
	const seen = /* @__PURE__ */ new Set();
	const result = [];
	for (const candidate of index.candidates) {
		if (candidate.end <= absFrom || candidate.pos >= absTo) continue;
		if (!seen.has(candidate.nodeId)) {
			seen.add(candidate.nodeId);
			result.push(candidate.nodeId);
		}
	}
	return result;
}
function pushBlockRange(map, blockId, from, to) {
	let entries = map.get(blockId);
	if (!entries) {
		entries = [];
		map.set(blockId, entries);
	}
	entries.push({
		from,
		to
	});
}
function validateStepInteractions(steps, index) {
	for (let i = 0; i < steps.length; i++) for (let j = i + 1; j < steps.length; j++) {
		const stepA = steps[i];
		const stepB = steps[j];
		if (MATRIX_EXEMPT_OPS.has(stepA.step.op) || MATRIX_EXEMPT_OPS.has(stepB.step.op)) continue;
		const overlap = classifyOverlap(stepA, stepB, index);
		if (!overlap) continue;
		const matrixKey = `${normalizeOpForMatrix(stepA.step.op)}::${normalizeOpForMatrix(stepB.step.op)}::${overlap.overlapClass}`;
		const verdict = STEP_INTERACTION_MATRIX.get(matrixKey) ?? "reject";
		if (verdict === "reject") throw planError("PLAN_CONFLICT_OVERLAP", `steps "${stepA.step.id}" and "${stepB.step.id}" target overlapping ranges in block "${overlap.blockId}"`, stepB.step.id, {
			blockId: overlap.blockId,
			stepIdA: stepA.step.id,
			stepIdB: stepB.step.id,
			opKeyA: stepA.step.op,
			opKeyB: stepB.step.op,
			rangeA: overlap.rangeA,
			rangeB: overlap.rangeB,
			overlapRegion: {
				from: Math.max(overlap.rangeA.from, overlap.rangeB.from),
				to: Math.min(overlap.rangeA.to, overlap.rangeB.to)
			},
			matrixVerdict: verdict,
			matrixKey
		});
	}
}
function assertNoDuplicateBlockIds(index) {
	const seen = /* @__PURE__ */ new Map();
	const duplicates = [];
	for (const candidate of index.candidates) {
		const count = seen.get(candidate.nodeId) ?? 0;
		seen.set(candidate.nodeId, count + 1);
		if (count === 1) duplicates.push(candidate.nodeId);
	}
	if (duplicates.length > 0) {
		const preview = duplicates.slice(0, 4).join(", ");
		const previewSuffix = duplicates.length > 4 ? `, +${duplicates.length - 4} more` : "";
		throw planError("DOCUMENT_IDENTITY_CONFLICT", `Document contains ${duplicates.length} block identit${duplicates.length === 1 ? "y" : "ies"} shared by multiple blocks (${preview}${previewSuffix}). Re-import the document via doc.open to assign unique identities.`, void 0, {
			duplicateBlockIds: duplicates,
			blockCount: duplicates.length,
			remediation: "Re-import the document via doc.open to assign unique identities."
		});
	}
}
function assertSingleStoryKey(steps) {
	let seenStoryKey;
	let seenStepId;
	for (const step of steps) {
		const where = step.where;
		if (!isRefWhere(where)) continue;
		const ref = where.ref;
		if (!ref.startsWith("text:v4:")) continue;
		const decoded = decodeRef(ref);
		if (!decoded || decoded.v !== 4) continue;
		const v4 = decoded;
		if (seenStoryKey === void 0) {
			seenStoryKey = v4.storyKey;
			seenStepId = step.id;
		} else if (v4.storyKey !== seenStoryKey) throw planError("CROSS_STORY_PLAN", `Plan contains refs targeting different stories: step "${seenStepId}" targets "${seenStoryKey}" but step "${step.id}" targets "${v4.storyKey}". A single plan call must target one story.`, step.id, {
			storyKeyA: seenStoryKey,
			stepIdA: seenStepId,
			storyKeyB: v4.storyKey,
			stepIdB: step.id
		});
	}
}
function collectReferencedBlockIds(step) {
	const where = step.where;
	const ids = [];
	const withinNodeId = where.within?.nodeId;
	if (withinNodeId) ids.push(withinNodeId);
	if (isRefWhere(where)) {
		const ref = where.ref;
		if (ref.startsWith("text:")) {
			const decoded = decodeRef(ref);
			if (decoded) {
				for (const seg of decoded.segments ?? []) if (seg?.blockId) ids.push(seg.blockId);
				const nodeId = decoded.node?.nodeId;
				if (nodeId) ids.push(nodeId);
			}
		} else ids.push(ref);
		return ids;
	}
	if (isBlockWhere(where)) {
		ids.push(where.nodeId);
		return ids;
	}
	if (isTargetWhere(where)) for (const point of [where.target?.start, where.target?.end]) {
		const blockId = point?.blockId;
		if (blockId) ids.push(blockId);
		const edgeNodeId = point?.node?.nodeId;
		if (edgeNodeId) ids.push(edgeNodeId);
	}
	return ids;
}
function assertNoStaleRefsAfterRepair(steps, repairedIds) {
	if (repairedIds.size === 0) return;
	for (const step of steps) for (const blockId of collectReferencedBlockIds(step)) {
		if (!repairedIds.has(blockId)) continue;
		throw planError("STALE_REF", `Step "${step.id}" references block id "${blockId}", which was duplicated in this document and has just been repaired (the duplicate occurrence was renamed). The reference is ambiguous — it may have pointed at the renamed block. Re-run query.match / doc.find against the repaired document and retry with a fresh ref.`, step.id, {
			blockId,
			repairedBlockIds: [...repairedIds],
			remediation: "Re-run query.match() or doc.find() to obtain fresh refs, then retry the mutation."
		});
	}
}
function compilePlan(editor, steps, options = {}) {
	if (steps.length > 200) throw planError("INVALID_INPUT", `plan contains ${steps.length} steps, maximum is 200`);
	let index = getBlockIndex(editor);
	if (!options.skipIdentityRepair) {
		const repair = repairDuplicateBlockIdentities(editor);
		if (repair) {
			clearIndexCache(editor);
			index = getBlockIndex(editor);
			console.warn(`[plan-engine] Repaired ${repair.repairedBlockCount} block(s) with duplicate identities before plan compilation. Original ids: ${repair.duplicateBlockIds.slice(0, 4).join(", ")}${repair.duplicateBlockIds.length > 4 ? `, +${repair.duplicateBlockIds.length - 4} more` : ""}.`);
			assertNoStaleRefsAfterRepair(steps, new Set(repair.duplicateBlockIds));
		}
	}
	const compiledRevision = getRevision(editor);
	assertNoDuplicateBlockIds(index);
	const mutationSteps = [];
	const assertSteps = [];
	const seenIds = /* @__PURE__ */ new Set();
	for (const step of steps) {
		if (!step.id) throw planError("INVALID_INPUT", "step.id is required");
		if (seenIds.has(step.id)) throw planError("INVALID_INPUT", `duplicate step id "${step.id}"`, step.id);
		seenIds.add(step.id);
	}
	assertSingleStoryKey(steps);
	let totalTargets = 0;
	let stepIndex = 0;
	for (const step of steps) {
		if (isAssertStep(step)) {
			assertSteps.push(step);
			stepIndex++;
			continue;
		}
		if (!isPublicMutationStepOp(step.op)) throw planError("INVALID_INPUT", `unknown step op "${step.op}"`, step.id);
		if (!hasStepExecutor(step.op)) throw planError("INVALID_INPUT", `unknown step op "${step.op}"`, step.id);
		if (isCreateOp(step.op)) validateCreateStepPosition(step);
		const targets = resolveStepTargets(editor, index, step, options);
		if (isCreateOp(step.op) && targets.length > 0) {
			const position = step.args.position ?? "after";
			const anchorBlockId = resolveCreateAnchorFromTargets(targets, position, step.id);
			validateInsertionContext(editor, index, step, stepIndex, anchorBlockId, position);
		}
		totalTargets += targets.length;
		mutationSteps.push({
			step,
			targets
		});
		stepIndex++;
	}
	if (totalTargets > 500) throw planError("INVALID_INPUT", `plan resolved ${totalTargets} total targets, maximum is 500`);
	validateStepInteractions(mutationSteps, index);
	return {
		mutationSteps,
		assertSteps,
		compiledRevision
	};
}
var PARAGRAPH_NODE_TYPES = new Set([
	"paragraph",
	"heading",
	"listItem"
]);
var TEXT_STYLE_CHARACTER_STYLE_ATTR = "styleId";
var DIRECT_FORMATTING_MARK_NAMES = new Set([
	"textStyle",
	"bold",
	"italic",
	"underline",
	"strike",
	"subscript",
	"superscript",
	"highlight"
]);
function resolveParagraphBlock(editor, target) {
	const candidate = findBlockByIdStrict(getBlockIndex(editor), target);
	if (!PARAGRAPH_NODE_TYPES.has(candidate.nodeType)) throw new DocumentApiAdapterError("INVALID_TARGET", `format.paragraph.* / styles.paragraph.* operations require a paragraph, heading, or listItem target. Got "${candidate.nodeType}".`, { nodeType: candidate.nodeType });
	return candidate;
}
function successResult(target) {
	return {
		success: true,
		target,
		resolution: { target }
	};
}
function noOpResult(operation) {
	return {
		success: false,
		failure: {
			code: "NO_OP",
			message: `${operation} produced no changes.`
		}
	};
}
function getPreservedCharacterStyleAttrs(mark) {
	const styleId = mark.attrs?.[TEXT_STYLE_CHARACTER_STYLE_ATTR];
	if (typeof styleId !== "string" || styleId.length === 0) return null;
	return { [TEXT_STYLE_CHARACTER_STYLE_ATTR]: styleId };
}
function hasTextStyleDirectFormatting(mark) {
	return Object.entries(mark.attrs ?? {}).some(([key$1, value]) => key$1 !== TEXT_STYLE_CHARACTER_STYLE_ATTR && value != null);
}
function clearTextStyleDirectFormatting(tr, from, to, mark) {
	const preservedCharacterStyle = getPreservedCharacterStyleAttrs(mark);
	const hadDirectFormatting = hasTextStyleDirectFormatting(mark);
	if (!hadDirectFormatting && preservedCharacterStyle) return false;
	tr.removeMark?.(from, to, mark);
	if (hadDirectFormatting && preservedCharacterStyle && mark.type?.create && tr.addMark) tr.addMark(from, to, mark.type.create(preservedCharacterStyle));
	return true;
}
function clearDirectFormattingInBlock(tr, pos, nodeSize) {
	if (!tr.doc?.nodesBetween || !tr.removeMark || nodeSize <= 2) return false;
	let changed = false;
	tr.doc.nodesBetween(pos + 1, pos + nodeSize - 1, (node, nodePos) => {
		if (!node.isText || !Array.isArray(node.marks) || node.marks.length === 0 || typeof node.nodeSize !== "number") return true;
		node.marks.forEach((mark) => {
			const markName = mark?.type?.name;
			if (!markName || !DIRECT_FORMATTING_MARK_NAMES.has(markName)) return;
			if (markName === "textStyle") {
				changed = clearTextStyleDirectFormatting(tr, nodePos, nodePos + node.nodeSize, mark) || changed;
				return;
			}
			tr.removeMark(nodePos, nodePos + node.nodeSize, mark);
			changed = true;
		});
		return true;
	});
	return changed;
}
function mutateParagraphProperties(editor, candidate, operation, target, transform, options, extras) {
	if (options?.dryRun) return successResult(target);
	if (executeDomainCommand(editor, () => {
		const node = editor.state.doc.nodeAt(candidate.pos);
		if (!node) return false;
		const existing = node.attrs.paragraphProperties ?? {};
		const updated = transform({ ...existing }, node, candidate.pos);
		if (JSON.stringify(existing) === JSON.stringify(updated)) return false;
		const tr = editor.state.tr;
		if (extras?.clearDirectFormatting) clearDirectFormattingInBlock(tr, candidate.pos, node.nodeSize);
		tr.setNodeMarkup(candidate.pos, void 0, {
			...node.attrs,
			paragraphProperties: updated
		});
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return noOpResult(operation);
	return successResult(target);
}
function mapAlignmentToJustificationForParagraph(alignment, isRtl) {
	return mapDisplayAlignmentToStoredJustification(alignment, isRtl);
}
function mergeDefinedFields(existing, patch) {
	const result = { ...existing ?? {} };
	for (const [key$1, value] of Object.entries(patch)) if (value !== void 0) result[key$1] = value;
	return result;
}
function mergeIndentationFields(existing, patch) {
	const result = mergeDefinedFields(existing, patch);
	const firstLineWasUpdated = patch.firstLine !== void 0;
	const hangingWasUpdated = patch.hanging !== void 0;
	if (firstLineWasUpdated && !hangingWasUpdated) delete result.hanging;
	if (hangingWasUpdated && !firstLineWasUpdated) delete result.firstLine;
	return result;
}
function deleteKey(obj, key$1) {
	const result = { ...obj };
	delete result[key$1];
	return Object.keys(result).length > 0 ? result : void 0;
}
function addOrReplaceTabStop(existing, entry) {
	return [...(existing ?? []).filter((t) => t.tab.pos !== entry.tab.pos), entry].sort((a, b) => a.tab.pos - b.tab.pos);
}
function removeTabStop(existing, position) {
	const filtered = (existing ?? []).filter((t) => t.tab.pos !== position);
	return filtered.length > 0 ? filtered : void 0;
}
function paragraphsSetStyleWrapper(editor, input, options) {
	rejectTrackedMode("styles.paragraph.setStyle", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "styles.paragraph.setStyle", input.target, (pPr) => ({
		...pPr,
		styleId: input.styleId
	}), options, { clearDirectFormatting: true });
}
function paragraphsClearStyleWrapper(editor, input, options) {
	rejectTrackedMode("styles.paragraph.clearStyle", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "styles.paragraph.clearStyle", input.target, (pPr) => {
		const result = { ...pPr };
		delete result.styleId;
		return result;
	}, options);
}
function paragraphsResetDirectFormattingWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.resetDirectFormatting", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.resetDirectFormatting", input.target, (pPr) => {
		const result = {};
		if (pPr.styleId !== void 0) result.styleId = pPr.styleId;
		if (pPr.numberingProperties !== void 0) result.numberingProperties = pPr.numberingProperties;
		if (pPr.sectPr !== void 0) result.sectPr = pPr.sectPr;
		return result;
	}, options);
}
function paragraphsSetAlignmentWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setAlignment", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setAlignment", input.target, (pPr, node, pos) => {
		const resolved = calculateResolvedParagraphProperties(editor, node, typeof editor.state.doc.resolve === "function" ? editor.state.doc.resolve(pos) : null);
		return {
			...pPr,
			justification: mapAlignmentToJustificationForParagraph(input.alignment, resolved?.rightToLeft === true)
		};
	}, options);
}
function paragraphsClearAlignmentWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearAlignment", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearAlignment", input.target, (pPr) => {
		const result = { ...pPr };
		delete result.justification;
		return result;
	}, options);
}
function paragraphsSetIndentationWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setIndentation", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setIndentation", input.target, (pPr) => ({
		...pPr,
		indent: mergeIndentationFields(pPr.indent, {
			left: input.left,
			right: input.right,
			firstLine: input.firstLine,
			hanging: input.hanging
		})
	}), options);
}
function paragraphsClearIndentationWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearIndentation", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearIndentation", input.target, (pPr) => {
		const result = { ...pPr };
		delete result.indent;
		return result;
	}, options);
}
function paragraphsSetSpacingWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setSpacing", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setSpacing", input.target, (pPr) => ({
		...pPr,
		spacing: mergeDefinedFields(pPr.spacing, {
			before: input.before,
			after: input.after,
			line: input.line,
			lineRule: input.lineRule
		})
	}), options);
}
function paragraphsClearSpacingWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearSpacing", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearSpacing", input.target, (pPr) => {
		const result = { ...pPr };
		delete result.spacing;
		return result;
	}, options);
}
function paragraphsSetKeepOptionsWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setKeepOptions", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setKeepOptions", input.target, (pPr) => {
		const result = { ...pPr };
		if (input.keepNext !== void 0) result.keepNext = input.keepNext;
		if (input.keepLines !== void 0) result.keepLines = input.keepLines;
		if (input.widowControl !== void 0) result.widowControl = input.widowControl;
		return result;
	}, options);
}
function paragraphsSetOutlineLevelWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setOutlineLevel", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setOutlineLevel", input.target, (pPr) => {
		if (input.outlineLevel === null) {
			const result = { ...pPr };
			delete result.outlineLvl;
			return result;
		}
		return {
			...pPr,
			outlineLvl: input.outlineLevel
		};
	}, options);
}
function paragraphsSetFlowOptionsWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setFlowOptions", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setFlowOptions", input.target, (pPr) => {
		const result = { ...pPr };
		if (input.contextualSpacing !== void 0) result.contextualSpacing = input.contextualSpacing;
		if (input.pageBreakBefore !== void 0) result.pageBreakBefore = input.pageBreakBefore;
		if (input.suppressAutoHyphens !== void 0) result.suppressAutoHyphens = input.suppressAutoHyphens;
		return result;
	}, options);
}
function paragraphsSetTabStopWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setTabStop", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setTabStop", input.target, (pPr) => {
		const entry = { tab: {
			pos: input.position,
			tabType: input.alignment,
			...input.leader !== void 0 && { leader: input.leader }
		} };
		return {
			...pPr,
			tabStops: addOrReplaceTabStop(pPr.tabStops, entry)
		};
	}, options);
}
function paragraphsClearTabStopWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearTabStop", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearTabStop", input.target, (pPr) => {
		const updated = removeTabStop(pPr.tabStops, input.position);
		if (updated === void 0) {
			const result = { ...pPr };
			delete result.tabStops;
			return result;
		}
		return {
			...pPr,
			tabStops: updated
		};
	}, options);
}
function paragraphsClearAllTabStopsWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearAllTabStops", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearAllTabStops", input.target, (pPr) => {
		const result = { ...pPr };
		delete result.tabStops;
		return result;
	}, options);
}
function paragraphsSetBorderWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setBorder", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setBorder", input.target, (pPr) => {
		const existing = pPr.borders ?? {};
		const border = { val: input.style };
		if (input.color !== void 0) border.color = input.color;
		if (input.size !== void 0) border.size = input.size;
		if (input.space !== void 0) border.space = input.space;
		return {
			...pPr,
			borders: {
				...existing,
				[input.side]: border
			}
		};
	}, options);
}
function paragraphsClearBorderWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearBorder", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearBorder", input.target, (pPr) => {
		if (input.side === "all") {
			const result = { ...pPr };
			delete result.borders;
			return result;
		}
		const updated = deleteKey(pPr.borders ?? {}, input.side);
		if (updated === void 0) {
			const result = { ...pPr };
			delete result.borders;
			return result;
		}
		return {
			...pPr,
			borders: updated
		};
	}, options);
}
function paragraphsSetShadingWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setShading", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setShading", input.target, (pPr) => ({
		...pPr,
		shading: mergeDefinedFields(pPr.shading, {
			fill: input.fill,
			color: input.color,
			val: input.pattern
		})
	}), options);
}
function paragraphsClearShadingWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearShading", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearShading", input.target, (pPr) => {
		const result = { ...pPr };
		delete result.shading;
		return result;
	}, options);
}
function paragraphsSetDirectionWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.setDirection", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.setDirection", input.target, (pPr) => {
		const result = { ...pPr };
		result.rightToLeft = input.direction === "rtl";
		if (input.alignmentPolicy === "matchDirection") result.justification = input.direction === "rtl" ? "right" : "left";
		return result;
	}, options);
}
function paragraphsClearDirectionWrapper(editor, input, options) {
	rejectTrackedMode("format.paragraph.clearDirection", options);
	return mutateParagraphProperties(editor, resolveParagraphBlock(editor, input.target), "format.paragraph.clearDirection", input.target, (pPr) => {
		const result = { ...pPr };
		delete result.rightToLeft;
		return result;
	}, options);
}
function resolveBlockInsertionPos(editor, anchorBlockId, position, stepId) {
	const candidate = getBlockIndex(editor).candidates.find((c) => c.nodeId === anchorBlockId);
	if (!candidate) throw planError("TARGET_NOT_FOUND", `block "${anchorBlockId}" not found`, stepId);
	return position === "before" ? candidate.pos : candidate.end;
}
function resolveCreateAnchor(editor, target, position, stepId) {
	const index = getBlockIndex(editor);
	let candidate;
	try {
		candidate = findBlockByNodeIdOnly(index, target.nodeId);
	} catch (e) {
		if (e instanceof Error && "code" in e) throw planError(e.code, e.message, stepId, e.details);
		throw e;
	}
	if (target.nodeType && candidate.nodeType !== target.nodeType) {
		const remediation = candidate.nodeType === "listItem" ? "Use lists.insert to add an item to a list sequence." : `The block is a ${candidate.nodeType}, not a ${target.nodeType}.`;
		throw planError("INVALID_TARGET", `Expected ${target.nodeType}:${target.nodeId} but found ${candidate.nodeType}:${candidate.nodeId}.`, stepId, {
			requestedNodeType: target.nodeType,
			actualNodeType: candidate.nodeType,
			nodeId: target.nodeId,
			remediation
		});
	}
	return {
		pos: position === "before" ? candidate.pos : candidate.end,
		anchor: candidate
	};
}
function normalizeReplacementText(text, stepId) {
	const chunks = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n").split(/\n{2,}/);
	while (chunks.length > 0 && chunks[0].length === 0) chunks.shift();
	while (chunks.length > 0 && chunks[chunks.length - 1].length === 0) chunks.pop();
	if (chunks.length === 0) throw planError("INVALID_INPUT", "replacement text normalized to zero blocks", stepId);
	return chunks;
}
function myersDiff(oldSeq, newSeq, isEqual) {
	const oldLen = oldSeq.length;
	const newLen = newSeq.length;
	if (oldLen === 0 && newLen === 0) return [];
	const max = oldLen + newLen;
	const size = 2 * max + 3;
	const offset = max + 1;
	const v = new Array(size).fill(-1);
	v[offset + 1] = 0;
	const trace = [];
	let foundPath = false;
	for (let d = 0; d <= max && !foundPath; d += 1) {
		for (let k = -d; k <= d; k += 2) {
			const index = offset + k;
			let x;
			if (k === -d || k !== d && v[index - 1] < v[index + 1]) x = v[index + 1];
			else x = v[index - 1] + 1;
			let y = x - k;
			while (x < oldLen && y < newLen && isEqual(oldSeq[x], newSeq[y])) {
				x += 1;
				y += 1;
			}
			v[index] = x;
			if (x >= oldLen && y >= newLen) {
				foundPath = true;
				break;
			}
		}
		trace.push(v.slice());
	}
	return backtrackMyers(trace, oldLen, newLen, offset);
}
function backtrackMyers(trace, oldLen, newLen, offset) {
	const operations = [];
	let x = oldLen;
	let y = newLen;
	for (let d = trace.length - 1; d > 0; d -= 1) {
		const v = trace[d - 1];
		const k = x - y;
		const index = offset + k;
		let prevK;
		if (k === -d || k !== d && v[index - 1] < v[index + 1]) prevK = k + 1;
		else prevK = k - 1;
		const prevX = v[offset + prevK];
		const prevY = prevX - prevK;
		while (x > prevX && y > prevY) {
			x -= 1;
			y -= 1;
			operations.push("equal");
		}
		if (x === prevX) {
			y -= 1;
			operations.push("insert");
		} else {
			x -= 1;
			operations.push("delete");
		}
	}
	while (x > 0 && y > 0) {
		x -= 1;
		y -= 1;
		operations.push("equal");
	}
	while (x > 0) {
		x -= 1;
		operations.push("delete");
	}
	while (y > 0) {
		y -= 1;
		operations.push("insert");
	}
	return operations.reverse();
}
function tokenizeWords(text) {
	const tokens = [];
	const regex = /(\s+|\S+)/g;
	let match;
	while ((match = regex.exec(text)) !== null) tokens.push({
		text: match[0],
		offset: match.index
	});
	return tokens;
}
function getWordChanges(oldText, newText) {
	if (oldText === newText) return [];
	const oldTokens = tokenizeWords(oldText);
	const newTokens = tokenizeWords(newText);
	if (oldTokens.length === 0 && newTokens.length === 0) return [];
	if (oldTokens.length === 0) return [{
		type: "insert",
		insertAt: 0,
		newText
	}];
	if (newTokens.length === 0) return [{
		type: "delete",
		oldFrom: 0,
		oldTo: oldText.length
	}];
	const ops = myersDiff(oldTokens, newTokens, (a, b) => a.text === b.text);
	const steps = [];
	let oldIdx = 0;
	let newIdx = 0;
	for (const op of ops) {
		steps.push({
			type: op,
			oldIdx,
			newIdx
		});
		if (op === "equal") {
			oldIdx++;
			newIdx++;
		} else if (op === "delete") oldIdx++;
		else newIdx++;
	}
	const result = [];
	let i = 0;
	while (i < steps.length) {
		if (steps[i].type === "equal") {
			i++;
			continue;
		}
		const groupStart = i;
		let deleteStart = -1;
		let deleteEnd = -1;
		let insertText = "";
		while (i < steps.length && (steps[i].type === "delete" || steps[i].type === "insert")) {
			const s = steps[i];
			if (s.type === "delete") {
				const token = oldTokens[s.oldIdx];
				if (deleteStart === -1) deleteStart = token.offset;
				deleteEnd = token.offset + token.text.length;
			} else insertText += newTokens[s.newIdx].text;
			i++;
		}
		if (deleteStart !== -1 && insertText.length > 0) result.push({
			type: "replace",
			oldFrom: deleteStart,
			oldTo: deleteEnd,
			newText: insertText
		});
		else if (deleteStart !== -1) result.push({
			type: "delete",
			oldFrom: deleteStart,
			oldTo: deleteEnd
		});
		else if (insertText.length > 0) {
			const prevStep = groupStart > 0 ? steps[groupStart - 1] : null;
			let insertAt = 0;
			if (prevStep && prevStep.type === "equal") {
				const prevToken = oldTokens[prevStep.oldIdx];
				insertAt = prevToken.offset + prevToken.text.length;
			} else if (result.length > 0) {
				const lastOp = result[result.length - 1];
				insertAt = "oldTo" in lastOp ? lastOp.oldTo : "insertAt" in lastOp ? lastOp.insertAt : 0;
			}
			result.push({
				type: "insert",
				insertAt,
				newText: insertText
			});
		}
	}
	return result;
}
function charOffsetToDocPos(doc, rangeFrom, rangeTo, charOffset) {
	let count = 0;
	let foundPos = -1;
	const resolveAtom = (pos, nodeSize, len) => {
		if (count + len < charOffset) return false;
		foundPos = charOffset === count ? pos : pos + nodeSize;
		return true;
	};
	doc.nodesBetween(rangeFrom, rangeTo, (node, pos) => {
		if (foundPos >= 0) return false;
		if (node.isText) {
			const textStart = Math.max(pos, rangeFrom);
			const textLen = Math.min(pos + node.nodeSize, rangeTo) - textStart;
			if (textLen <= 0) return false;
			if (count + textLen >= charOffset) foundPos = textStart + (charOffset - count);
			count += textLen;
			return false;
		}
		if (node.type?.name === "tab") {
			resolveAtom(pos, node.nodeSize, 1);
			count += 1;
			return false;
		}
		if (node.isLeaf && node.isInline) {
			const leafTextFn = (node.type?.spec)?.leafText;
			if (typeof leafTextFn === "function") {
				const leafText = leafTextFn(node);
				if (typeof leafText === "string" && leafText.length > 0) {
					resolveAtom(pos, node.nodeSize, leafText.length);
					count += leafText.length;
				}
			}
			return false;
		}
		return true;
	});
	return foundPos >= 0 ? foundPos : rangeTo;
}
var DEFAULT_INLINE_POLICY = {
	mode: "preserve",
	onNonUniform: "majority"
};
var CORE_SET_MARK_KEYS = [
	"bold",
	"italic",
	"underline",
	"strike"
];
var DEBUG_TEXT_REWRITE = typeof process$1 !== "undefined" && typeof process$1.env?.SUPERDOC_DEBUG_TEXT_REWRITE === "string" ? process$1.env.SUPERDOC_DEBUG_TEXT_REWRITE === "1" : false;
function debugTextRewrite(message, details) {
	if (!DEBUG_TEXT_REWRITE) return;
	console.error("[text-rewrite]", message, details ?? {});
}
function asProseMirrorMarks(marks) {
	return marks;
}
var TRACKED_REVIEW_MARK_NAMES = new Set([
	TrackInsertMarkName,
	TrackDeleteMarkName,
	TrackFormatMarkName
]);
function hasTrackedReviewMark(marks) {
	return Boolean(marks?.some((mark) => TRACKED_REVIEW_MARK_NAMES.has(mark.type.name)));
}
function rangeTouchesTrackedReviewState(doc, from, to) {
	let found = false;
	doc.nodesBetween(from, to, (node, pos) => {
		if (found) return false;
		if (node.isText) {
			if (Math.max(from, pos) >= Math.min(to, pos + node.nodeSize)) return false;
		}
		if ((node.isText || node.isInline) && hasTrackedReviewMark(node.marks)) {
			found = true;
			return false;
		}
	});
	return found;
}
function resolveMarksForRange(editor, target, step) {
	if (step.op !== "text.rewrite") return [];
	const policy = step.args.style?.inline ?? DEFAULT_INLINE_POLICY;
	if (target.capturedStyle) return resolveInlineStyle(editor, target.capturedStyle, policy, step.id);
	if (target.blockId === "__selection__") return [];
	return resolveInlineStyle(editor, captureRunsInRange(editor, toAbsoluteBlockPos(editor, target.blockId), target.from, target.to), policy, step.id);
}
function toAbsoluteBlockPos(editor, blockId) {
	const candidate = getBlockIndex(editor).candidates.find((c) => c.nodeId === blockId);
	if (!candidate) throw planError("TARGET_NOT_FOUND", `block "${blockId}" not found in style capture fallback`);
	return candidate.pos;
}
function buildMarksFromSetMarks(editor, setMarks) {
	if (!setMarks) return [];
	const { schema } = editor.state;
	const marks = [];
	for (const key$1 of CORE_SET_MARK_KEYS) {
		const directive = setMarks[key$1];
		if (!directive) continue;
		const spec = TOGGLE_MARK_SPECS[key$1];
		const markType = schema.marks[spec.schemaName];
		if (!markType) continue;
		if (directive === "on") {
			marks.push(spec.createOn(markType));
			continue;
		}
		if (directive === "off") marks.push(markType.create(spec.offAttrs));
	}
	return marks;
}
var BOOLEAN_INLINE_MARK_KEYS = [
	"bold",
	"italic",
	"strike"
];
var TEXT_STYLE_KEYS = [
	"color",
	"fontSize",
	"fontFamily",
	"letterSpacing",
	"vertAlign",
	"position"
];
var PRESERVE_RUN_PROPERTIES_META_KEY = "sdPreserveRunPropertiesKeys";
function isRecord$1(value) {
	return value !== null && typeof value === "object" && !Array.isArray(value);
}
function isDeepEqual(left, right) {
	return JSON.stringify(left) === JSON.stringify(right);
}
function normalizeHexColor(color) {
	const trimmed = color.trim();
	if (trimmed.startsWith("#")) return trimmed;
	if (/^[0-9a-fA-F]{3,8}$/.test(trimmed)) return `#${trimmed}`;
	return trimmed;
}
function toPointString(value) {
	return `${value}pt`;
}
function toHalfPoints(value) {
	return Math.round(value * 2);
}
function capsToTextTransform(caps) {
	if (caps === null) return null;
	return caps ? "uppercase" : "none";
}
function collectInlineTextSegments(doc, absFrom, absTo) {
	const segments = [];
	doc.nodesBetween(absFrom, absTo, (node, pos) => {
		if (!node.isText) return;
		const from = Math.max(absFrom, pos);
		const to = Math.min(absTo, pos + node.nodeSize);
		if (from >= to) return;
		segments.push({
			from,
			to,
			marks: node.marks ?? []
		});
	});
	return segments;
}
function findMark(marks, markTypeName) {
	return marks.find((mark) => mark.type.name === markTypeName);
}
function compactAttrs(attrs) {
	return Object.fromEntries(Object.entries(attrs).filter(([, value]) => value !== null && value !== void 0));
}
function applyTriStateMarkPatch(tr, markType, absFrom, absTo, value) {
	if (value === void 0 || !markType) return false;
	if (value === null) {
		tr.removeMark(absFrom, absTo, markType);
		return true;
	}
	if (value === true) {
		tr.addMark(absFrom, absTo, markType.create());
		return true;
	}
	tr.addMark(absFrom, absTo, markType.create({ value: "0" }));
	return true;
}
function applyHighlightPatch(tr, markType, absFrom, absTo, value) {
	if (value === void 0 || !markType) return false;
	if (value === null) {
		tr.removeMark(absFrom, absTo, markType);
		return true;
	}
	tr.addMark(absFrom, absTo, markType.create({ color: value }));
	return true;
}
function mergeTextStyleAttrs(currentAttrs, patch) {
	const next = { ...currentAttrs };
	for (const [key$1, value] of Object.entries(patch)) {
		if (value === void 0) continue;
		if (value === null) {
			delete next[key$1];
			continue;
		}
		if (key$1 === "color" && typeof value === "string") {
			next.color = normalizeHexColor(value);
			continue;
		}
		if ((key$1 === "fontSize" || key$1 === "letterSpacing" || key$1 === "position") && typeof value === "number") {
			next[key$1] = toPointString(value);
			continue;
		}
		next[key$1] = value;
	}
	return compactAttrs(next);
}
function applyTextStylePatch(tr, markType, absFrom, absTo, patch) {
	if (!markType) return false;
	if (Object.keys(patch).length === 0) return false;
	const segments = collectInlineTextSegments(tr.doc, absFrom, absTo);
	let changed = false;
	for (const segment of segments) {
		const existingMark = findMark(segment.marks, markType.name);
		const existingAttrs = existingMark?.attrs ?? {};
		const nextAttrs = mergeTextStyleAttrs(existingAttrs, patch);
		const hadMark = Boolean(existingMark);
		const shouldKeepMark = Object.keys(nextAttrs).length > 0;
		if (!hadMark && !shouldKeepMark) continue;
		if (hadMark && shouldKeepMark && isDeepEqual(existingAttrs, nextAttrs)) continue;
		tr.removeMark(segment.from, segment.to, markType);
		if (shouldKeepMark) tr.addMark(segment.from, segment.to, markType.create(nextAttrs));
		changed = true;
	}
	return changed;
}
function mergeUnderlineAttrs(currentAttrs, patchValue) {
	if (patchValue === null) return null;
	const next = { ...currentAttrs };
	if (patchValue === true) {
		if (!next.underlineType || next.underlineType === "none") next.underlineType = "single";
		return compactAttrs(next);
	}
	if (patchValue === false) {
		next.underlineType = "none";
		return compactAttrs(next);
	}
	const patch = patchValue;
	if (patch.style !== void 0) if (patch.style === null) delete next.underlineType;
	else next.underlineType = patch.style;
	if (patch.color !== void 0) if (patch.color === null) delete next.underlineColor;
	else next.underlineColor = normalizeHexColor(patch.color);
	if (patch.themeColor !== void 0) if (patch.themeColor === null) delete next.underlineThemeColor;
	else next.underlineThemeColor = patch.themeColor;
	if (!next.underlineType && (next.underlineColor || next.underlineThemeColor)) next.underlineType = "single";
	const compacted = compactAttrs(next);
	return Object.keys(compacted).length > 0 ? compacted : null;
}
function applyUnderlinePatch(tr, markType, absFrom, absTo, patchValue) {
	if (patchValue === void 0 || !markType) return false;
	const segments = collectInlineTextSegments(tr.doc, absFrom, absTo);
	let changed = false;
	for (const segment of segments) {
		const existingMark = findMark(segment.marks, markType.name);
		const existingAttrs = existingMark?.attrs ?? {};
		const nextAttrs = mergeUnderlineAttrs(existingAttrs, patchValue);
		const hadMark = Boolean(existingMark);
		if (!hadMark && nextAttrs === null) continue;
		if (hadMark && nextAttrs !== null && isDeepEqual(existingAttrs, nextAttrs)) continue;
		tr.removeMark(segment.from, segment.to, markType);
		if (nextAttrs !== null) tr.addMark(segment.from, segment.to, markType.create(nextAttrs));
		changed = true;
	}
	return changed;
}
function collectOverlappingRuns(doc, runType, absFrom, absTo) {
	const runs = [];
	doc.nodesBetween(absFrom, absTo, (node, pos) => {
		if (node.type !== runType) return true;
		const runFrom = pos + 1;
		const runTo = pos + node.nodeSize - 1;
		if (Math.max(absFrom, runFrom) < Math.min(absTo, runTo)) runs.push({ pos });
		return false;
	});
	return runs;
}
function normalizeRFontsPatch(patch) {
	const next = {};
	for (const [key$1, value] of Object.entries(patch)) {
		if (key$1 === "csTheme") {
			next.cstheme = value;
			continue;
		}
		next[key$1] = value;
	}
	return next;
}
function normalizeBorderPatch(patch) {
	const next = {};
	if (patch.val !== void 0) next.val = patch.val;
	if (patch.sz !== void 0) next.size = patch.sz;
	if (patch.color !== void 0) next.color = patch.color;
	if (patch.space !== void 0) next.space = patch.space;
	return next;
}
function normalizeRunAttributePatchValue(key$1, value) {
	if (value === null) return null;
	switch (key$1) {
		case "border": return normalizeBorderPatch(value);
		case "rFonts": return normalizeRFontsPatch(value);
		case "fontSizeCs": return toHalfPoints(value);
		case "kerning": return toHalfPoints(value);
		case "stylisticSets": return Array.isArray(value) ? value.map((entry) => ({ ...entry })) : value;
		default: return value;
	}
}
function mergeRunAttributeValue(currentValue, patchValue) {
	if (patchValue === null) return { changed: currentValue !== void 0 };
	if (Array.isArray(patchValue)) {
		if (isDeepEqual(currentValue, patchValue)) return {
			changed: false,
			nextValue: currentValue
		};
		return {
			changed: true,
			nextValue: patchValue
		};
	}
	if (isRecord$1(patchValue)) {
		const merged = isRecord$1(currentValue) ? { ...currentValue } : {};
		for (const [key$1, value] of Object.entries(patchValue)) if (value === null || value === void 0) delete merged[key$1];
		else merged[key$1] = value;
		if (Object.keys(merged).length === 0) return { changed: currentValue !== void 0 };
		if (isDeepEqual(currentValue, merged)) return {
			changed: false,
			nextValue: currentValue
		};
		return {
			changed: true,
			nextValue: merged
		};
	}
	if (Object.is(currentValue, patchValue)) return {
		changed: false,
		nextValue: currentValue
	};
	return {
		changed: true,
		nextValue: patchValue
	};
}
function buildRunAttributeUpdates(inline) {
	const updates = {};
	const keys = Object.keys(inline);
	for (const key$1 of keys) {
		const entry = INLINE_PROPERTY_BY_KEY[key$1];
		if (!entry || entry.storage !== "runAttribute") continue;
		const value = inline[key$1];
		if (value === void 0) continue;
		const carrier = entry.carrier;
		const runPropertyKey = carrier.storage === "runAttribute" ? carrier.runPropertyKey : (() => {
			throw planError("INTERNAL_ERROR", `Invalid carrier for runAttribute key "${key$1}"`);
		})();
		updates[runPropertyKey] = normalizeRunAttributePatchValue(key$1, value);
	}
	return updates;
}
function applyRunAttributePatch(tr, runType, absFrom, absTo, updates) {
	if (!runType) return false;
	if (Object.keys(updates).length === 0) return false;
	const overlappingRuns = collectOverlappingRuns(tr.doc, runType, absFrom, absTo).sort((left, right) => right.pos - left.pos);
	if (overlappingRuns.length === 0) return false;
	if (Object.prototype.hasOwnProperty.call(updates, "fontFamily")) tr.setMeta(PRESERVE_RUN_PROPERTIES_META_KEY, [{
		key: "fontFamily",
		preferExisting: true
	}]);
	let changed = false;
	for (const run of overlappingRuns) {
		const runPos = tr.mapping.map(run.pos, 1);
		const runNode = tr.doc.nodeAt(runPos);
		if (!runNode || runNode.type !== runType) continue;
		const mappedFrom = tr.mapping.map(absFrom, 1);
		const mappedTo = tr.mapping.map(absTo, -1);
		const runContentFrom = runPos + 1;
		const runContentTo = runPos + runNode.nodeSize - 1;
		const patchFrom = Math.max(mappedFrom, runContentFrom);
		const patchTo = Math.min(mappedTo, runContentTo);
		if (patchFrom >= patchTo) continue;
		const currentRunProperties = isRecord$1(runNode.attrs?.runProperties) ? { ...runNode.attrs.runProperties } : {};
		const currentStyleKeys = Array.isArray(runNode.attrs?.runPropertiesStyleKeys) ? runNode.attrs.runPropertiesStyleKeys : [];
		const currentOverrideKeys = Array.isArray(runNode.attrs?.runPropertiesOverrideKeys) ? runNode.attrs.runPropertiesOverrideKeys : [];
		const hasInlineOwnershipMetadata = Array.isArray(runNode.attrs?.runPropertiesInlineKeys);
		let currentInlineKeys;
		if (hasInlineOwnershipMetadata) currentInlineKeys = runNode.attrs.runPropertiesInlineKeys;
		else if (currentStyleKeys.length > 0) currentInlineKeys = [...new Set([...Object.keys(currentRunProperties).filter((key$1) => !currentStyleKeys.includes(key$1)), ...currentOverrideKeys])];
		else currentInlineKeys = Object.keys(currentRunProperties);
		const nextRunProperties = { ...currentRunProperties };
		let runChanged = false;
		const changedRunPropertyKeys = /* @__PURE__ */ new Set();
		for (const [runPropertyKey, patchValue] of Object.entries(updates)) {
			const existingValue = nextRunProperties[runPropertyKey];
			const mergeResult = mergeRunAttributeValue(existingValue, patchValue);
			if (!mergeResult.changed) continue;
			if (mergeResult.nextValue === void 0) delete nextRunProperties[runPropertyKey];
			else nextRunProperties[runPropertyKey] = mergeResult.nextValue;
			runChanged = true;
			changedRunPropertyKeys.add(runPropertyKey);
		}
		if (!runChanged) continue;
		const normalizedNextRunProperties = Object.keys(nextRunProperties).length > 0 ? nextRunProperties : null;
		const nextInlineKeys = [...new Set([...currentInlineKeys.filter((key$1) => normalizedNextRunProperties && key$1 in normalizedNextRunProperties), ...[...changedRunPropertyKeys].filter((key$1) => normalizedNextRunProperties && key$1 in normalizedNextRunProperties)])];
		const nextOverrideKeys = [...new Set([...currentOverrideKeys.filter((key$1) => normalizedNextRunProperties && key$1 in normalizedNextRunProperties && currentStyleKeys.includes(key$1)), ...[...changedRunPropertyKeys].filter((key$1) => normalizedNextRunProperties && key$1 in normalizedNextRunProperties && currentStyleKeys.includes(key$1))])];
		if (patchFrom === runContentFrom && patchTo === runContentTo) {
			tr.setNodeMarkup(runPos, runNode.type, {
				...runNode.attrs,
				runProperties: normalizedNextRunProperties,
				runPropertiesInlineKeys: nextInlineKeys.length ? nextInlineKeys : null,
				runPropertiesOverrideKeys: nextOverrideKeys.length ? nextOverrideKeys : null
			}, runNode.marks);
			changed = true;
			continue;
		}
		const relativeFrom = patchFrom - runContentFrom;
		const relativeTo = patchTo - runContentFrom;
		if (relativeFrom === relativeTo) continue;
		const replacementRuns = [];
		if (relativeFrom > 0) {
			const leftContent = runNode.content.cut(0, relativeFrom);
			replacementRuns.push(runType.create(runNode.attrs, leftContent, runNode.marks));
		}
		const middleContent = runNode.content.cut(relativeFrom, relativeTo);
		replacementRuns.push(runType.create({
			...runNode.attrs,
			runProperties: normalizedNextRunProperties,
			runPropertiesInlineKeys: nextInlineKeys.length ? nextInlineKeys : null,
			runPropertiesOverrideKeys: nextOverrideKeys.length ? nextOverrideKeys : null
		}, middleContent, runNode.marks));
		if (relativeTo < runNode.content.size) {
			const rightContent = runNode.content.cut(relativeTo, runNode.content.size);
			replacementRuns.push(runType.create(runNode.attrs, rightContent, runNode.marks));
		}
		tr.replaceWith(runPos, runPos + runNode.nodeSize, replacementRuns);
		changed = true;
	}
	return changed;
}
function applyInlinePatchToRange(editor, tr, absFrom, absTo, inline) {
	if (absFrom >= absTo) return false;
	const { schema } = editor.state;
	let changed = false;
	for (const key$1 of BOOLEAN_INLINE_MARK_KEYS) {
		const markType = schema.marks[key$1];
		const value = inline[key$1];
		if (applyTriStateMarkPatch(tr, markType, absFrom, absTo, value)) changed = true;
	}
	if (applyUnderlinePatch(tr, schema.marks.underline, absFrom, absTo, inline.underline)) changed = true;
	if (applyHighlightPatch(tr, schema.marks.highlight, absFrom, absTo, inline.highlight)) changed = true;
	const textStylePatch = {};
	for (const key$1 of TEXT_STYLE_KEYS) if (inline[key$1] !== void 0) textStylePatch[key$1] = inline[key$1];
	if (inline.caps !== void 0) textStylePatch.textTransform = capsToTextTransform(inline.caps ?? null);
	if (textStylePatch.fontFamily != null) tr.setMeta(PRESERVE_RUN_PROPERTIES_META_KEY, ["fontFamily"]);
	if (applyTextStylePatch(tr, schema.marks.textStyle, absFrom, absTo, textStylePatch)) changed = true;
	const runAttributeUpdates = buildRunAttributeUpdates(inline);
	if (applyRunAttributePatch(tr, schema.nodes?.run, absFrom, absTo, runAttributeUpdates)) changed = true;
	return changed;
}
function resolveCreateAnchorBlockId(target, position, stepId) {
	if (target.kind === "range") return target.blockId;
	const segments = target.segments;
	if (!segments.length) throw planError("INVALID_INPUT", "span target has no segments", stepId);
	return position === "before" ? segments[0].blockId : segments[segments.length - 1].blockId;
}
function executeTextRewrite(editor, tr, target, step, mapping) {
	const absFrom = mapping.map(target.absFrom);
	const absTo = mapping.map(target.absTo);
	const replacementText = getReplacementText(step.args.replacement);
	const marks = resolveMarksForRange(editor, target, step);
	const lineBreakNodeType = editor.state.schema.nodes?.lineBreak;
	const parentAllowsLineBreakAt = (pos) => lineBreakNodeType ? parentAllowsNodeAt(tr, pos, lineBreakNodeType) : false;
	const structuralRewrite = resolveStructuralRangeRewrite(tr.doc, absFrom, absTo, step);
	if (structuralRewrite) {
		const slice = buildReplacementParagraphSlice(editor, structuralRewrite.replacementBlocks, marks, structuralRewrite.paragraphAttrs, step.id, structuralRewrite.leadingWrappers, structuralRewrite.trailingWrappers, structuralRewrite.openStart, structuralRewrite.openEnd);
		try {
			tr.doc.replace(structuralRewrite.replaceFrom, structuralRewrite.replaceTo, slice);
			tr.replace(structuralRewrite.replaceFrom, structuralRewrite.replaceTo, slice);
			return { changed: replacementText !== target.text };
		} catch (error) {
			debugTextRewrite("structural rewrite fell back to inline replacement", {
				replaceFrom: structuralRewrite.replaceFrom,
				replaceTo: structuralRewrite.replaceTo,
				openStart: structuralRewrite.openStart,
				openEnd: structuralRewrite.openEnd,
				replacementBlockCount: structuralRewrite.replacementBlocks.length,
				stepId: step.id,
				error: error instanceof Error ? error.message : String(error)
			});
		}
	}
	const originalText = textBetweenWithTabs(tr.doc, absFrom, absTo, "", "");
	const origLen = originalText.length;
	const replLen = replacementText.length;
	if (rangeTouchesTrackedReviewState(tr.doc, absFrom, absTo)) {
		if (replacementText.length === 0) {
			tr.delete(absFrom, absTo);
			return { changed: target.text.length > 0 };
		}
		const content = buildTextWithTabs(editor.state.schema, replacementText, asProseMirrorMarks(marks), { parentAllowsLineBreak: parentAllowsLineBreakAt(absFrom) });
		tr.replaceWith(absFrom, absTo, content);
		return { changed: replacementText !== target.text };
	}
	let prefix = 0;
	while (prefix < origLen && prefix < replLen && originalText[prefix] === replacementText[prefix]) prefix++;
	if (prefix === origLen && prefix === replLen) return { changed: false };
	let suffix = 0;
	while (suffix < origLen - prefix && suffix < replLen - prefix && originalText[origLen - 1 - suffix] === replacementText[replLen - 1 - suffix]) suffix++;
	const trimmedFrom = charOffsetToDocPos(tr.doc, absFrom, absTo, prefix);
	const trimmedTo = charOffsetToDocPos(tr.doc, absFrom, absTo, origLen - suffix);
	const trimmedOld = originalText.slice(prefix, origLen - suffix);
	const trimmedNew = replacementText.slice(prefix, replLen - suffix);
	const wordChanges = getWordChanges(trimmedOld, trimmedNew);
	if (wordChanges.length > 1) {
		const doc = tr.doc;
		const baseSteps = tr.steps.length;
		const mapped = wordChanges.map((change) => {
			if (change.type === "insert") return {
				...change,
				docPos: charOffsetToDocPos(doc, trimmedFrom, trimmedTo, change.insertAt)
			};
			return {
				...change,
				docFrom: charOffsetToDocPos(doc, trimmedFrom, trimmedTo, change.oldFrom),
				docTo: charOffsetToDocPos(doc, trimmedFrom, trimmedTo, change.oldTo)
			};
		});
		for (let i = 0; i < mapped.length; i++) {
			const change = mapped[i];
			const remap = (pos) => {
				for (let s = baseSteps; s < tr.steps.length; s++) pos = tr.steps[s].getMap().map(pos);
				return pos;
			};
			if (change.type === "delete") tr.delete(remap(change.docFrom), remap(change.docTo));
			else if (change.type === "insert") {
				const content = buildTextWithTabs(editor.state.schema, change.newText, asProseMirrorMarks(marks), { parentAllowsLineBreak: parentAllowsLineBreakAt(remap(change.docPos)) });
				tr.insert(remap(change.docPos), content);
			} else {
				const content = buildTextWithTabs(editor.state.schema, change.newText, asProseMirrorMarks(marks), { parentAllowsLineBreak: parentAllowsLineBreakAt(remap(change.docFrom)) });
				tr.replaceWith(remap(change.docFrom), remap(change.docTo), content);
			}
		}
	} else if (trimmedNew.length === 0) tr.delete(trimmedFrom, trimmedTo);
	else {
		const content = buildTextWithTabs(editor.state.schema, trimmedNew, asProseMirrorMarks(marks), { parentAllowsLineBreak: parentAllowsLineBreakAt(trimmedFrom) });
		tr.replaceWith(trimmedFrom, trimmedTo, content);
	}
	return { changed: replacementText !== target.text };
}
function resolveInheritedMarksAt(editor, tr, absPos) {
	try {
		if (typeof editor.state?.doc?.resolve !== "function") return mergeDirectInsertTrackedInsertionMark(tr, absPos, tr.doc.resolve(absPos).marks());
		return mergeDirectInsertTrackedInsertionMark(tr, absPos, getFormattingStateAtPos(editor.state, absPos, editor)?.resolvedMarks ?? []);
	} catch {
		return mergeDirectInsertTrackedInsertionMark(tr, absPos, tr.doc.resolve(absPos).marks());
	}
}
function getSharedTrackedInsertionMarkAt(tr, absPos) {
	const maxPos = typeof tr.doc.content?.size === "number" ? tr.doc.content.size : absPos;
	const boundedPos = Math.max(0, Math.min(maxPos, absPos));
	const $pos = tr.doc.resolve(boundedPos);
	const beforeInsert = $pos.nodeBefore?.marks?.find((mark) => mark.type?.name === "trackInsert") ?? null;
	const afterInsert = $pos.nodeAfter?.marks?.find((mark) => mark.type?.name === "trackInsert") ?? null;
	const beforeId = typeof beforeInsert?.attrs?.id === "string" ? beforeInsert.attrs.id : null;
	const afterId = typeof afterInsert?.attrs?.id === "string" ? afterInsert.attrs.id : null;
	if (!beforeInsert || !afterInsert || !beforeId || beforeId !== afterId) return null;
	return beforeInsert;
}
function mergeDirectInsertTrackedInsertionMark(tr, absPos, marks) {
	if (tr.getMeta?.("skipTrackChanges") !== true) return marks;
	const sharedInsert = getSharedTrackedInsertionMarkAt(tr, absPos);
	if (!sharedInsert) return marks;
	const sharedInsertId = typeof sharedInsert.attrs?.id === "string" ? sharedInsert.attrs.id : null;
	if (sharedInsertId && marks.some((mark) => mark.type?.name === "trackInsert" && mark.attrs?.id === sharedInsertId)) return marks;
	return [...marks, sharedInsert];
}
function executeTextInsert(editor, tr, target, step, mapping) {
	const position = step.args.position;
	const absPos = mapping.map(position === "before" ? target.absFrom : target.absTo);
	const text = step.args.content.text;
	if (!text) return { changed: false };
	let marks = [];
	const stylePolicy = step.args.style?.inline;
	if (stylePolicy?.mode === "set") marks = buildMarksFromSetMarks(editor, stylePolicy.setMarks);
	else if (stylePolicy?.mode === "clear") marks = [];
	else marks = resolveInheritedMarksAt(editor, tr, absPos);
	const structuralInsert = resolveStructuralTextInsert(tr.doc, absPos, step);
	if (structuralInsert) {
		const slice = buildReplacementParagraphSlice(editor, structuralInsert.replacementBlocks, marks, structuralInsert.paragraphAttrs, step.id, structuralInsert.leadingWrappers, structuralInsert.trailingWrappers, structuralInsert.openStart, structuralInsert.openEnd);
		try {
			tr.doc.replace(structuralInsert.insertAt, structuralInsert.insertAt, slice);
			tr.replace(structuralInsert.insertAt, structuralInsert.insertAt, slice);
			return { changed: true };
		} catch (error) {
			debugTextRewrite("structural insert fell back to inline insertion", {
				insertAt: structuralInsert.insertAt,
				openStart: structuralInsert.openStart,
				openEnd: structuralInsert.openEnd,
				replacementBlockCount: structuralInsert.replacementBlocks.length,
				stepId: step.id,
				error: error instanceof Error ? error.message : String(error)
			});
		}
	}
	const tabNodeType = editor.state.schema.nodes?.tab;
	const parentAllowsTab = tabNodeType && text.includes("	") ? parentAllowsNodeAt(tr, absPos, tabNodeType) : false;
	const lineBreakNodeType = editor.state.schema.nodes?.lineBreak;
	const parentAllowsLineBreak = lineBreakNodeType && /[\r\n]/.test(text) ? parentAllowsNodeAt(tr, absPos, lineBreakNodeType) : false;
	tr.insert(absPos, buildTextWithTabs(editor.state.schema, text, marks, {
		parentAllowsTab,
		parentAllowsLineBreak
	}));
	return { changed: true };
}
function executeTextDelete(_editor, tr, target, _step, mapping) {
	const absFrom = mapping.map(target.absFrom);
	const absTo = mapping.map(target.absTo);
	if (absFrom === absTo) return { changed: false };
	tr.delete(absFrom, absTo);
	return { changed: true };
}
function applyAlignmentToRange(editor, tr, absFrom, absTo, alignment) {
	if (!alignment) return false;
	let changed = false;
	tr.doc.nodesBetween(absFrom, absTo, (node, pos) => {
		if (!node.isTextblock) return;
		const existing = node.attrs.paragraphProperties;
		const justification = mapAlignmentToJustificationForParagraph(alignment, calculateResolvedParagraphProperties(editor, node, typeof tr.doc.resolve === "function" ? tr.doc.resolve(pos) : null)?.rightToLeft === true);
		if (existing?.justification === justification) return;
		const updated = {
			...existing ?? {},
			justification
		};
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			paragraphProperties: updated
		});
		changed = true;
	});
	return changed;
}
function expandToBlockBoundaries$1(doc, from, to) {
	let expandedFrom = from;
	let expandedTo = to;
	doc.nodesBetween(from, to, (node, pos) => {
		if (!node.isTextblock) return;
		const blockContentStart = pos + 1;
		const blockContentEnd = pos + node.nodeSize - 1;
		expandedFrom = Math.min(expandedFrom, blockContentStart);
		expandedTo = Math.max(expandedTo, blockContentEnd);
	});
	return {
		from: expandedFrom,
		to: expandedTo
	};
}
function executeStyleApply(editor, tr, target, step, mapping) {
	let absFrom = mapping.map(target.absFrom);
	let absTo = mapping.map(target.absTo);
	if (step.args.scope === "block") {
		const expanded = expandToBlockBoundaries$1(tr.doc, absFrom, absTo);
		absFrom = expanded.from;
		absTo = expanded.to;
	}
	let changed = false;
	if (step.args.inline) changed = applyInlinePatchToRange(editor, tr, absFrom, absTo, step.args.inline) || changed;
	if (step.args.alignment) changed = applyAlignmentToRange(editor, tr, absFrom, absTo, step.args.alignment) || changed;
	return { changed };
}
function validateMappedSpanContiguity(target, mapping, stepId) {
	let lastMappedEnd = -1;
	let lastOriginalEnd = -1;
	for (const seg of target.segments) {
		const mappedFrom = mapping.map(seg.absFrom, 1);
		const mappedTo = mapping.map(seg.absTo, -1);
		if (mappedFrom > mappedTo) throw planError("SPAN_FRAGMENTED", `span target "${target.matchId}" has been fragmented by a prior mutation step`, stepId, { matchId: target.matchId });
		if (lastMappedEnd >= 0) {
			if (mappedFrom < lastMappedEnd) throw planError("SPAN_FRAGMENTED", `span target "${target.matchId}" has been fragmented by a prior mutation step`, stepId, { matchId: target.matchId });
			const expectedGap = seg.absFrom - lastOriginalEnd;
			if (mappedFrom - lastMappedEnd !== expectedGap) throw planError("SPAN_FRAGMENTED", `span target "${target.matchId}" has been fragmented by a prior mutation step`, stepId, { matchId: target.matchId });
		}
		lastMappedEnd = mappedTo;
		lastOriginalEnd = seg.absTo;
	}
}
function executeSpanTextRewrite(editor, tr, target, step, mapping) {
	validateMappedSpanContiguity(target, mapping, step.id);
	const replacementBlocks = resolveReplacementBlocks(step.args.replacement, step.id);
	const policy = step.args.style?.inline ?? DEFAULT_INLINE_POLICY;
	const firstSeg = target.segments[0];
	const lastSeg = target.segments[target.segments.length - 1];
	const absFrom = mapping.map(firstSeg.absFrom, 1);
	const absTo = mapping.map(lastSeg.absTo, -1);
	if (replacementBlocks.length === 1) {
		const marks = resolveSpanMarks(editor, target, policy, step.id);
		const lineBreakNodeType = editor.state.schema.nodes?.lineBreak;
		const parentAllowsLineBreak = lineBreakNodeType ? parentAllowsNodeAt(tr, absFrom, lineBreakNodeType) : false;
		const content = buildTextWithTabs(editor.state.schema, replacementBlocks[0], asProseMirrorMarks(marks), { parentAllowsLineBreak });
		tr.replaceWith(absFrom, absTo, content);
		return { changed: true };
	}
	const { schema } = editor.state;
	const paragraphType = schema.nodes.paragraph;
	if (!paragraphType) throw planError("INVALID_INPUT", "paragraph node type not in schema", step.id);
	const nodes = [];
	for (let i = 0; i < replacementBlocks.length; i++) {
		const segmentIndex = Math.min(i, target.segments.length - 1);
		const marks = resolveSegmentMarks(editor, target, segmentIndex, policy, step.id);
		const paragraphAttrs = resolveInheritedParagraphAttrsForReplacement(editor, target, segmentIndex);
		const text = replacementBlocks[i];
		const content = text.length > 0 ? buildTextWithTabs(schema, text, asProseMirrorMarks(marks)) : null;
		const para = paragraphType.createAndFill(paragraphAttrs, content ?? void 0) ?? paragraphType.create(paragraphAttrs, content ?? void 0);
		nodes.push(para);
	}
	const slice = new Slice(Fragment.from(nodes), 1, 1);
	tr.replace(absFrom, absTo, slice);
	return { changed: true };
}
function executeSpanTextDelete(_editor, tr, target, step, mapping) {
	validateMappedSpanContiguity(target, mapping, step.id);
	const firstSeg = target.segments[0];
	const lastSeg = target.segments[target.segments.length - 1];
	const absFrom = mapping.map(firstSeg.absFrom, 1);
	const absTo = mapping.map(lastSeg.absTo, -1);
	if (absFrom === absTo) return { changed: false };
	tr.delete(absFrom, absTo);
	return { changed: true };
}
function executeSpanStyleApply(editor, tr, target, step, mapping) {
	validateMappedSpanContiguity(target, mapping, step.id);
	const firstSeg = target.segments[0];
	const lastSeg = target.segments[target.segments.length - 1];
	let absFrom = mapping.map(firstSeg.absFrom, 1);
	let absTo = mapping.map(lastSeg.absTo, -1);
	if (step.args.scope === "block") {
		const expanded = expandToBlockBoundaries$1(tr.doc, absFrom, absTo);
		absFrom = expanded.from;
		absTo = expanded.to;
	}
	let changed = false;
	if (step.args.inline) changed = applyInlinePatchToRange(editor, tr, absFrom, absTo, step.args.inline) || changed;
	if (step.args.alignment) changed = applyAlignmentToRange(editor, tr, absFrom, absTo, step.args.alignment) || changed;
	return { changed };
}
function getReplacementText(replacement) {
	if (replacement.blocks !== void 0) return replacement.blocks.map((b) => b.text).join("\n\n");
	if (replacement.text == null) throw planError("INVALID_INPUT", "replacement must specify either text or blocks");
	return replacement.text;
}
function resolveReplacementBlocks(replacement, stepId) {
	if (replacement.blocks !== void 0) {
		if (replacement.blocks.length === 0) throw planError("INVALID_INPUT", "replacement.blocks must contain at least one entry", stepId);
		return replacement.blocks.map((b) => b.text);
	}
	if (replacement.text == null) throw planError("INVALID_INPUT", "replacement must specify either text or blocks", stepId);
	return normalizeReplacementText(replacement.text, stepId);
}
function resolveStructuredTextPayload(text, stepId) {
	const normalized = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
	const splitBefore = normalized.startsWith("\n");
	const splitAfter = normalized.endsWith("\n");
	const coreText = splitBefore || splitAfter ? normalized.replace(/^\n+/, "").replace(/\n+$/, "") : normalized;
	return {
		blocks: coreText.length === 0 ? [""] : normalizeReplacementText(coreText, stepId),
		splitBefore,
		splitAfter
	};
}
function resolveStructuredReplacementPayload(replacement, stepId) {
	if (replacement.blocks !== void 0) {
		if (replacement.blocks.length === 0) throw planError("INVALID_INPUT", "replacement.blocks must contain at least one entry", stepId);
		return {
			blocks: replacement.blocks.map((block) => block.text),
			splitBefore: false,
			splitAfter: false
		};
	}
	if (replacement.text == null) throw planError("INVALID_INPUT", "replacement must specify either text or blocks", stepId);
	return resolveStructuredTextPayload(replacement.text, stepId);
}
function payloadNeedsStructuralHandling(payload) {
	return payload.blocks.length > 1 || payload.splitBefore || payload.splitAfter;
}
function findSharedTextblockDepth($from, $to) {
	const maxDepth = Math.min($from.depth, $to.depth);
	for (let depth = maxDepth; depth >= 0; depth -= 1) {
		if ($from.node(depth) !== $to.node(depth)) continue;
		if ($from.node(depth)?.isTextblock) return depth;
	}
	return null;
}
function findAddressableInlineRangeWithinTextblock(doc, from, to) {
	let inlineFrom = null;
	let inlineTo = null;
	doc.nodesBetween(from, to, (node, pos) => {
		if (!node.isInline) return;
		if (node.isText && node.text) {
			const nodeFrom$1 = Math.max(from, pos);
			const nodeTo$1 = Math.min(to, pos + node.text.length);
			if (nodeFrom$1 >= nodeTo$1) return;
			if (inlineFrom === null) inlineFrom = nodeFrom$1;
			inlineTo = nodeTo$1;
			return;
		}
		if (!node.isLeaf && !node.isAtom) return;
		const nodeFrom = Math.max(from, pos);
		const nodeTo = Math.min(to, pos + node.nodeSize);
		if (nodeFrom >= nodeTo) return;
		if (inlineFrom === null) inlineFrom = nodeFrom;
		inlineTo = nodeTo;
	});
	return inlineFrom === null || inlineTo === null ? null : {
		from: inlineFrom,
		to: inlineTo
	};
}
function resolveInlineWrapperChainAt(doc, pos, textblockDepth) {
	const $pos = doc.resolve(pos);
	const chain = [];
	for (let depth = textblockDepth + 1; depth <= $pos.depth; depth += 1) {
		const node = $pos.node(depth);
		if (!node?.isInline || node.isText) continue;
		chain.push({
			type: node.type,
			attrs: { ...node.attrs ?? {} },
			marks: node.marks
		});
	}
	return chain;
}
function stripIdentityAttrs(attrs) {
	const cloned = { ...attrs };
	delete cloned.paraId;
	delete cloned.sdBlockId;
	delete cloned.nodeId;
	delete cloned.id;
	delete cloned.blockId;
	delete cloned.uuid;
	return Object.keys(cloned).length > 0 ? cloned : null;
}
function resolveStructuralRangeRewrite(doc, absFrom, absTo, step) {
	if (absFrom === absTo) return null;
	const payload = resolveStructuredReplacementPayload(step.args.replacement, step.id);
	if (!payloadNeedsStructuralHandling(payload)) return null;
	const $from = doc.resolve(absFrom);
	const textblockDepth = findSharedTextblockDepth($from, doc.resolve(absTo));
	if (textblockDepth === null) {
		debugTextRewrite("structural rewrite skipped: no shared textblock", {
			absFrom,
			absTo,
			stepId: step.id
		});
		return null;
	}
	const textblockStart = $from.start(textblockDepth);
	const textblockEnd = $from.end(textblockDepth);
	const inlineRange = findAddressableInlineRangeWithinTextblock(doc, textblockStart, textblockEnd);
	const replacesEntireTextblock = inlineRange !== null && absFrom <= inlineRange.from && absTo >= inlineRange.to;
	const selectionStaysWithinTextblock = inlineRange !== null && absFrom >= inlineRange.from && absTo <= inlineRange.to;
	if (!replacesEntireTextblock && !selectionStaysWithinTextblock) {
		debugTextRewrite("structural rewrite skipped: selection does not cover full inline range", {
			absFrom,
			absTo,
			textblockDepth,
			textblockType: $from.node(textblockDepth).type.name,
			textblockStart,
			textblockEnd,
			inlineRange,
			stepId: step.id
		});
		return null;
	}
	const effectiveBlocks = [...payload.blocks];
	if (payload.splitBefore) effectiveBlocks.unshift("");
	if (payload.splitAfter) effectiveBlocks.push("");
	if (replacesEntireTextblock) {
		if (effectiveBlocks.length <= 1) {
			debugTextRewrite("structural rewrite skipped: whole-textblock rewrite resolved to one block", {
				replacementBlocks: effectiveBlocks,
				stepId: step.id
			});
			return null;
		}
		const replaceFrom = $from.before(textblockDepth);
		const replaceTo = $from.after(textblockDepth);
		debugTextRewrite("structural rewrite enabled", {
			absFrom,
			absTo,
			textblockDepth,
			textblockType: $from.node(textblockDepth).type.name,
			inlineRange,
			replaceFrom,
			replaceTo,
			replacementBlockCount: effectiveBlocks.length,
			openStart: 0,
			openEnd: 0,
			stepId: step.id
		});
		return {
			replacementBlocks: effectiveBlocks,
			paragraphAttrs: stripIdentityAttrs($from.node(textblockDepth).attrs),
			replaceFrom,
			replaceTo,
			openStart: 0,
			openEnd: 0,
			leadingWrappers: [],
			trailingWrappers: []
		};
	}
	const leadingWrappers = resolveInlineWrapperChainAt(doc, absFrom, textblockDepth);
	const trailingWrappers = resolveInlineWrapperChainAt(doc, absTo, textblockDepth);
	const openStart = 1 + leadingWrappers.length;
	const openEnd = 1 + trailingWrappers.length;
	debugTextRewrite("structural rewrite enabled", {
		absFrom,
		absTo,
		textblockDepth,
		textblockType: $from.node(textblockDepth).type.name,
		inlineRange,
		replaceFrom: absFrom,
		replaceTo: absTo,
		replacementBlockCount: effectiveBlocks.length,
		openStart,
		openEnd,
		leadingWrapperDepth: leadingWrappers.length,
		trailingWrapperDepth: trailingWrappers.length,
		stepId: step.id
	});
	return {
		replacementBlocks: effectiveBlocks,
		paragraphAttrs: stripIdentityAttrs($from.node(textblockDepth).attrs),
		replaceFrom: absFrom,
		replaceTo: absTo,
		openStart,
		openEnd,
		leadingWrappers,
		trailingWrappers
	};
}
function resolveStructuralTextInsert(doc, absPos, step) {
	const text = step.args.content.text;
	if (!text) return null;
	const payload = resolveStructuredTextPayload(text, step.id);
	if (!payloadNeedsStructuralHandling(payload)) return null;
	const $pos = doc.resolve(absPos);
	const textblockDepth = findSharedTextblockDepth($pos, $pos);
	if (textblockDepth === null) {
		debugTextRewrite("structural insert skipped: no shared textblock", {
			absPos,
			stepId: step.id
		});
		return null;
	}
	const wrappers = resolveInlineWrapperChainAt(doc, absPos, textblockDepth);
	const effectiveBlocks = [...payload.blocks];
	if (payload.splitBefore) effectiveBlocks.unshift("");
	if (payload.splitAfter) effectiveBlocks.push("");
	const openStart = 1 + wrappers.length;
	const openEnd = 1 + wrappers.length;
	debugTextRewrite("structural insert enabled", {
		absPos,
		textblockDepth,
		textblockType: $pos.node(textblockDepth).type.name,
		replacementBlockCount: effectiveBlocks.length,
		openStart,
		openEnd,
		wrapperDepth: wrappers.length,
		stepId: step.id
	});
	return {
		replacementBlocks: effectiveBlocks,
		paragraphAttrs: stripIdentityAttrs($pos.node(textblockDepth).attrs),
		insertAt: absPos,
		openStart,
		openEnd,
		leadingWrappers: wrappers,
		trailingWrappers: wrappers
	};
}
function buildReplacementParagraphNodes(editor, replacementBlocks, marks, paragraphAttrs, stepId, leadingWrappers, trailingWrappers) {
	const { schema } = editor.state;
	const paragraphType = schema.nodes.paragraph;
	if (!paragraphType) throw planError("INVALID_INPUT", "paragraph node type not in schema", stepId);
	const wrapInlineContent = (contentNode, wrappers) => {
		let content = contentNode;
		for (let index = wrappers.length - 1; index >= 0; index -= 1) {
			const wrapper = wrappers[index];
			content = wrapper.type.createAndFill(wrapper.attrs, content ?? void 0, wrapper.marks) ?? wrapper.type.create(wrapper.attrs, content ?? void 0, wrapper.marks);
		}
		if (!content || content instanceof Fragment) throw planError("INVALID_INPUT", "could not build inline wrapper content", stepId);
		return content;
	};
	const defaultWrappers = leadingWrappers.length > 0 ? leadingWrappers : trailingWrappers;
	return replacementBlocks.map((text, index) => {
		const textContent = text.length > 0 ? buildTextWithTabs(schema, text, asProseMirrorMarks(marks)) : null;
		const wrappers = index === 0 ? leadingWrappers.length > 0 ? leadingWrappers : defaultWrappers : index === replacementBlocks.length - 1 ? trailingWrappers.length > 0 ? trailingWrappers : defaultWrappers : defaultWrappers;
		const content = textContent == null ? wrappers.length > 0 ? wrapInlineContent(null, wrappers) : void 0 : wrappers.length > 0 ? wrapInlineContent(textContent, wrappers) : textContent;
		return paragraphType.createAndFill(paragraphAttrs, content ?? void 0) ?? paragraphType.create(paragraphAttrs, content ?? void 0);
	});
}
function buildReplacementParagraphSlice(editor, replacementBlocks, marks, paragraphAttrs, stepId, leadingWrappers, trailingWrappers, openStart, openEnd) {
	const nodes = buildReplacementParagraphNodes(editor, replacementBlocks, marks, paragraphAttrs, stepId, leadingWrappers, trailingWrappers);
	return new Slice(Fragment.from(nodes), openStart, openEnd);
}
function resolveInheritedParagraphAttrsForReplacement(editor, target, segmentIndex) {
	const sourceSegment = target.segments[Math.min(segmentIndex, target.segments.length - 1)];
	const sourceAttrs = getBlockIndex(editor).candidates.find((c) => c.nodeId === sourceSegment.blockId)?.node?.attrs;
	if (!sourceAttrs || typeof sourceAttrs !== "object") return null;
	return stripIdentityAttrs(sourceAttrs);
}
function resolveSpanMarks(editor, target, policy, stepId) {
	if (policy.mode === "set") return buildMarksFromSetMarks(editor, policy.setMarks);
	if (policy.mode === "clear") return [];
	if (!target.capturedStyleBySegment?.length) return [];
	const allRuns = target.capturedStyleBySegment.flatMap((cs) => cs.runs);
	return resolveInlineStyle(editor, {
		runs: allRuns,
		isUniform: allRuns.length <= 1
	}, policy, stepId);
}
function resolveSegmentMarks(editor, target, segmentIndex, policy, stepId) {
	if (policy.mode === "set") return buildMarksFromSetMarks(editor, policy.setMarks);
	if (policy.mode === "clear") return [];
	if (!target.capturedStyleBySegment?.length) return [];
	const captured = target.capturedStyleBySegment[segmentIndex];
	if (!captured) return [];
	return resolveInlineStyle(editor, captured, policy, stepId);
}
function countTextMatches(text, pattern, mode, caseSensitive) {
	if (mode === "regex") {
		if (pattern.length > 1024) return 0;
		const flags = caseSensitive ? "g" : "gi";
		try {
			const regex = new RegExp(pattern, flags);
			const matches = text.match(regex);
			return matches ? matches.length : 0;
		} catch {
			return 0;
		}
	}
	const searchText = caseSensitive ? text : text.toLowerCase();
	const searchPattern = caseSensitive ? pattern : pattern.toLowerCase();
	let count = 0;
	let pos = 0;
	while (true) {
		const idx = searchText.indexOf(searchPattern, pos);
		if (idx === -1) break;
		count++;
		pos = idx + 1;
	}
	return count;
}
function asId(value) {
	return typeof value === "string" && value.length > 0 ? value : void 0;
}
function resolveAssertNodeId(node, mappedType) {
	const attrs = node.attrs ?? {};
	if (mappedType === "paragraph" || mappedType === "heading" || mappedType === "listItem") return asId(attrs.paraId) ?? asId(attrs.sdBlockId) ?? asId(attrs.nodeId);
	return asId(attrs.blockId) ?? asId(attrs.id) ?? asId(attrs.paraId) ?? asId(attrs.uuid) ?? asId(attrs.sdBlockId) ?? asId(attrs.nodeId);
}
function buildAssertIndex(doc) {
	const candidates = [];
	const byId = /* @__PURE__ */ new Map();
	const ambiguous = /* @__PURE__ */ new Set();
	function registerKey(key$1, candidate) {
		if (byId.has(key$1)) {
			ambiguous.add(key$1);
			byId.delete(key$1);
			return;
		}
		if (!ambiguous.has(key$1)) byId.set(key$1, candidate);
	}
	doc.descendants((node, pos) => {
		const nodeType = mapBlockNodeType(node);
		if (!nodeType) return true;
		const nodeId = resolveAssertNodeId(node, nodeType);
		if (!nodeId) return true;
		const candidate = {
			node,
			pos,
			end: pos + node.nodeSize,
			nodeType,
			nodeId
		};
		candidates.push(candidate);
		registerKey(`${nodeType}:${nodeId}`, candidate);
		if (nodeType === "paragraph" || nodeType === "heading" || nodeType === "listItem") {
			const aliasId = asId(node.attrs?.sdBlockId);
			if (aliasId && aliasId !== nodeId) registerKey(`${nodeType}:${aliasId}`, candidate);
		}
		return true;
	});
	return {
		candidates,
		byId,
		ambiguous
	};
}
function resolveAssertScope(index, select, within) {
	if (!within) return {
		ok: true,
		range: void 0
	};
	const scope = resolveWithinScope(index, {
		select,
		within
	}, []);
	if (!scope.ok) return { ok: false };
	return {
		ok: true,
		range: scope.range
	};
}
function countNodeMatchesInDoc(doc, selector, within) {
	const index = buildAssertIndex(doc);
	const scope = resolveAssertScope(index, selector, within);
	if (!scope.ok) return 0;
	if (selector.kind && selector.kind !== "block") return 0;
	const scoped = scopeByRange(index.candidates, scope.range);
	let count = 0;
	for (const candidate of scoped) {
		if (selector.nodeType && candidate.nodeType !== selector.nodeType) continue;
		count++;
	}
	return count;
}
function resolveScopedTextForAssert(doc, selector, within) {
	const scope = resolveAssertScope(buildAssertIndex(doc), selector, within);
	if (!scope.ok) return "";
	if (!scope.range) return doc.textContent;
	return textBetweenWithTabs(doc, scope.range.start, scope.range.end, "\n", "￼");
}
function executeAssertStep(_editor, tr, step) {
	const where = step.where;
	if (where.by !== "select") throw planError("INVALID_INPUT", `assert steps only support by: 'select'`, step.id);
	const selector = where.select;
	if (selector.type !== "text") {
		const count$1 = countNodeMatchesInDoc(tr.doc, selector, where.within);
		return {
			passed: count$1 === step.args.expectCount,
			actualCount: count$1
		};
	}
	const text = resolveScopedTextForAssert(tr.doc, selector, where.within);
	const pattern = selector.pattern;
	const count = countTextMatches(text, pattern, selector.mode ?? "contains", selector.caseSensitive ?? false);
	return {
		passed: count === step.args.expectCount,
		actualCount: count
	};
}
function executeCreateStep(editor, tr, step, targets, mapping) {
	const target = targets[0];
	if (!target) throw planError("INVALID_INPUT", `${step.op} step requires at least one target`, step.id);
	const args = step.args;
	const position = args.position ?? "after";
	const anchorPos = resolveBlockInsertionPos(editor, resolveCreateAnchorBlockId(target, position, step.id), position, step.id);
	const pos = mapping.map(anchorPos);
	const paragraphType = editor.state.schema?.nodes?.paragraph;
	if (!paragraphType) throw planError("INVALID_INPUT", "paragraph node type not in schema", step.id);
	const sdBlockId = args.sdBlockId;
	const text = args.text ?? "";
	const textContent = text.length > 0 ? buildTextWithTabs(editor.state.schema, text, void 0) : null;
	let attrs;
	if (step.op === "create.heading") {
		const level = args.level ?? 1;
		attrs = {
			...sdBlockId ? { sdBlockId } : void 0,
			paragraphProperties: { styleId: `Heading${level}` }
		};
	} else attrs = sdBlockId ? { sdBlockId } : void 0;
	const node = paragraphType.createAndFill(attrs, textContent ?? void 0) ?? paragraphType.create(attrs, textContent ?? void 0);
	if (!node) throw planError("INVALID_INPUT", `could not create ${step.op} node`, step.id);
	tr.insert(pos, node);
	assertNoPostInsertDuplicateIds(tr.doc, step.id);
	return {
		stepId: step.id,
		op: step.op,
		effect: "changed",
		matchCount: 1,
		data: {
			domain: "text",
			resolutions: []
		}
	};
}
function assertNoPostInsertDuplicateIds(doc, stepId) {
	const seen = /* @__PURE__ */ new Set();
	const duplicateSet = /* @__PURE__ */ new Set();
	doc.descendants((node) => {
		if (!node.isTextblock) return true;
		const attrs = node.attrs ?? {};
		const id = typeof attrs.paraId === "string" && attrs.paraId || typeof attrs.sdBlockId === "string" && attrs.sdBlockId || typeof attrs.nodeId === "string" && attrs.nodeId;
		if (!id) return true;
		if (seen.has(id)) duplicateSet.add(id);
		else seen.add(id);
		return true;
	});
	if (duplicateSet.size > 0) {
		const duplicates = [...duplicateSet];
		throw planError("INTERNAL_ERROR", `create step produced duplicate block identities: [${duplicates.join(", ")}]`, stepId, {
			source: "executor:checkPostInsertIdentityUniqueness",
			invariant: "post-insert block IDs must be unique",
			duplicateBlockIds: duplicates
		});
	}
}
function runMutationsOnTransaction(editor, tr, compiled, options) {
	const mapping = tr.mapping;
	const stepOutcomes = [];
	const assertFailures = [];
	const ctx = {
		editor,
		tr,
		mapping,
		changeMode: options.changeMode ?? "direct",
		planGroupId: "",
		commandDispatched: false,
		isPreview: options.isPreview ?? false
	};
	for (const compiledStep of compiled.mutationSteps) {
		const { step, targets } = compiledStep;
		const executor = getStepExecutor(step.op);
		if (!executor) throw planError("INVALID_INPUT", `unsupported step op "${step.op}"`, step.id);
		const outcome = executor.execute(ctx, targets, step);
		stepOutcomes.push(outcome);
	}
	for (const assertStep of compiled.assertSteps) {
		const { passed, actualCount } = executeAssertStep(editor, tr, assertStep);
		if (!passed) {
			if (options.throwOnAssertFailure) throw planError("PRECONDITION_FAILED", `assert "${assertStep.id}" expected ${assertStep.args.expectCount} matches but found ${actualCount}`, assertStep.id, {
				expectedCount: assertStep.args.expectCount,
				actualCount
			});
			assertFailures.push({
				stepId: assertStep.id,
				expectedCount: assertStep.args.expectCount,
				actualCount
			});
		}
		const data = {
			domain: "assert",
			expectedCount: assertStep.args.expectCount,
			actualCount
		};
		stepOutcomes.push({
			stepId: assertStep.id,
			op: "assert",
			effect: passed ? "assert_passed" : "assert_failed",
			matchCount: actualCount,
			data
		});
	}
	return {
		stepOutcomes,
		assertFailures,
		commandDispatched: ctx.commandDispatched
	};
}
function executeCompiledPlan(editor, compiled, options = {}) {
	const startTime = performance.now();
	const revisionBefore = getRevision(editor);
	checkRevision(editor, options.expectedRevision);
	if (editor.options?.collaborationProvider && editor.options?.ydoc) try {
		yUndoPluginKey.getState(editor.state)?.undoManager?.stopCapturing();
	} catch {}
	else try {
		editor.view?.dispatch?.(closeHistory(editor.state.tr));
	} catch {}
	if (compiled.compiledRevision !== revisionBefore) throw planError("REVISION_CHANGED_SINCE_COMPILE", `Document revision changed between compile and execute. Compiled at "${compiled.compiledRevision}", now at "${revisionBefore}".`, void 0, {
		compiledRevision: compiled.compiledRevision,
		currentRevision: revisionBefore,
		stepCount: compiled.mutationSteps.length,
		failedAtStep: "pre-execution",
		remediation: "Re-compile the plan against the current document state."
	});
	const tr = editor.state.tr;
	const changeMode = options.changeMode ?? "direct";
	if (changeMode === "tracked") applyTrackedMutationMeta(tr);
	else applyDirectMutationMeta(tr);
	const { stepOutcomes } = runMutationsOnTransaction(editor, tr, compiled, {
		throwOnAssertFailure: true,
		changeMode,
		isPreview: false
	});
	if (tr.docChanged) editor.dispatch(tr);
	const revisionAfter = getRevision(editor);
	const totalMs = performance.now() - startTime;
	return {
		success: true,
		revision: {
			before: revisionBefore,
			after: revisionAfter
		},
		steps: stepOutcomes,
		timing: { totalMs }
	};
}
function executePlan(editor, input) {
	if (!input.steps?.length) throw planError("INVALID_INPUT", "plan must contain at least one step");
	checkRevision(editor, input.expectedRevision);
	return executeCompiledPlan(editor, compilePlan(editor, input.steps, { selectTextModel: input.changeMode === "tracked" ? "raw" : "visible" }), {
		changeMode: input.changeMode ?? "direct",
		expectedRevision: input.expectedRevision
	});
}
var CONTENT_CAPABILITIES = new Map([
	["paragraph", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["heading", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["table", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["list", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["image", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["toc", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["tableOfContents", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["index", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["bibliography", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["tableOfAuthorities", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["sectionBreak", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["break", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["drawing", {
		insert: "partial",
		replace: "partial",
		mutate: "partial"
	}],
	["field", {
		insert: "raw-gated",
		replace: false,
		mutate: false
	}],
	["sdt", {
		insert: true,
		replace: true,
		mutate: true
	}]
]);
var INLINE_CAPABILITIES = new Map([
	["run", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["text", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["hyperlink", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["crossRef", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["tocEntry", {
		insert: true,
		replace: false,
		mutate: "partial"
	}],
	["indexEntry", {
		insert: true,
		replace: false,
		mutate: "partial"
	}],
	["citation", {
		insert: true,
		replace: false,
		mutate: "partial"
	}],
	["authorityEntry", {
		insert: true,
		replace: false,
		mutate: "partial"
	}],
	["sequenceField", {
		insert: "partial",
		replace: false,
		mutate: "partial"
	}],
	["tab", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["lineBreak", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["footnoteRef", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["endnoteRef", {
		insert: true,
		replace: false,
		mutate: false
	}],
	["image", {
		insert: true,
		replace: true,
		mutate: true
	}],
	["drawing", {
		insert: "partial",
		replace: "partial",
		mutate: "partial"
	}],
	["field", {
		insert: "raw-gated",
		replace: false,
		mutate: false
	}],
	["sdt", {
		insert: true,
		replace: true,
		mutate: true
	}]
]);
function assertCapability(kind, operation, level, options) {
	if (kind.startsWith("ext.")) return;
	const cap = (level === "content" ? CONTENT_CAPABILITIES : INLINE_CAPABILITIES).get(kind);
	if (!cap) throw new DocumentApiAdapterError("PRESERVE_ONLY_VIOLATION", `"${kind}" is a preserve-only ${level} node family. ${operation} is not supported.`);
	const allowed = cap[operation];
	if (allowed === true || allowed === "partial") return;
	if (allowed === "raw-gated") {
		if (!options?.rawMode) throw new DocumentApiAdapterError("RAW_MODE_REQUIRED", `${operation} of "${kind}" requires explicit raw mode opt-in.`);
		return;
	}
	throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `"${kind}" does not support the "${operation}" operation.`);
}
function resolveBlockId(node, seenIds, existingDocIds) {
	const id = node.id;
	if (id) {
		if (seenIds.has(id)) throw new DocumentApiAdapterError("DUPLICATE_ID", `Duplicate block ID within fragment: "${id}".`);
		if (existingDocIds.has(id)) throw new DocumentApiAdapterError("DUPLICATE_ID", `Block ID "${id}" already exists in the document.`);
		seenIds.add(id);
		return id;
	}
	const generated = v4_default();
	seenIds.add(generated);
	return generated;
}
function resolveKind(node) {
	return node.kind ?? node.type ?? "unknown";
}
function resolvePayload(node, kind) {
	return node[kind] ?? node;
}
function isRecord(value) {
	return value !== null && typeof value === "object" && !Array.isArray(value);
}
function materializeFragment(schema, fragment, existingDocIds = /* @__PURE__ */ new Set(), operation = "insert", options) {
	const nodes = Array.isArray(fragment) ? fragment : [fragment];
	const seenIds = /* @__PURE__ */ new Set();
	const pmNodes = nodes.map((node) => materializeNode(schema, node, seenIds, existingDocIds, operation, options));
	return Fragment.from(pmNodes);
}
function materializeNode(schema, node, seenIds, existingDocIds, operation, options) {
	const kind = resolveKind(node);
	assertCapability(kind, operation, "content", options);
	switch (kind) {
		case "paragraph": return materializeParagraph(schema, node, seenIds, existingDocIds, operation, options);
		case "heading": return materializeHeading(schema, node, seenIds, existingDocIds, operation, options);
		case "table": return materializeTable(schema, node, seenIds, existingDocIds, operation, options);
		case "image": return materializeImage(schema, node, seenIds, existingDocIds);
		case "list": return materializeList(schema, node, seenIds, existingDocIds, operation, options);
		case "sectionBreak": return materializeSectionBreak(schema, node, seenIds, existingDocIds);
		case "toc":
		case "tableOfContents": return materializeToc(schema, node, seenIds, existingDocIds);
		case "break": return materializeBreak(schema, node, seenIds, existingDocIds);
		case "drawing": return materializeDrawing(schema, node, seenIds, existingDocIds);
		case "index":
		case "bibliography":
		case "tableOfAuthorities": return materializeReferenceBlock(schema, node, kind, seenIds, existingDocIds);
		case "field": return materializeField(schema, node, seenIds, existingDocIds);
		case "sdt": return materializeSdt(schema, node, seenIds, existingDocIds, operation, options);
		default: return materializeFallback(schema, node, seenIds, existingDocIds);
	}
}
function materializeParagraph(schema, node, seenIds, existingDocIds, operation, options) {
	const payload = resolvePayload(node, resolveKind(node));
	const content = materializeInlineContent(schema, payload.inlines ?? payload.content, operation, options);
	const attrs = { sdBlockId: resolveBlockId(node, seenIds, existingDocIds) };
	const paragraphProperties = buildParagraphProperties(payload.styleRef ?? payload.style, payload.props);
	if (paragraphProperties) attrs.paragraphProperties = paragraphProperties;
	if (!paragraphProperties && payload.style) attrs.paragraphStyle = payload.style;
	return schema.nodes.paragraph.create(attrs, content);
}
function materializeHeading(schema, node, seenIds, existingDocIds, operation, options) {
	const payload = resolvePayload(node, "heading");
	const content = materializeInlineContent(schema, payload.inlines ?? payload.content, operation, options);
	const attrs = {
		sdBlockId: resolveBlockId(node, seenIds, existingDocIds),
		level: payload.level
	};
	const paragraphProperties = buildParagraphProperties(payload.styleRef ?? payload.style, payload.props);
	if (paragraphProperties) attrs.paragraphProperties = paragraphProperties;
	if (!paragraphProperties && payload.style) attrs.paragraphStyle = payload.style;
	return (schema.nodes.heading ?? schema.nodes.paragraph).create(attrs, content);
}
function materializeTable(schema, node, seenIds, existingDocIds, operation, options) {
	const payload = resolvePayload(node, "table");
	const rows = (payload.rows ?? []).map((row) => materializeTableRow(schema, row, seenIds, existingDocIds, operation, options));
	const attrs = {
		sdBlockId: resolveBlockId(node, seenIds, existingDocIds),
		paraId: v4_default()
	};
	const styleRef = payload.styleRef ?? payload.style;
	const tableProperties = isRecord(payload.tableProperties) ? { ...payload.tableProperties } : {};
	if (styleRef) {
		attrs.tableStyleId = styleRef;
		tableProperties.tableStyleId = styleRef;
	}
	const width = mapSDTableWidthToMeasurement(payload.props?.width);
	if (width) tableProperties.tableWidth = width;
	const layout = payload.props?.layout;
	if (layout === "fixed" || layout === "autofit") {
		attrs.tableLayout = layout;
		tableProperties.tableLayout = layout;
	}
	const justification = mapSDTableAlignmentToJustification(payload.props?.alignment);
	if (justification) {
		attrs.justification = justification;
		tableProperties.justification = justification;
	}
	if (payload.props?.borders && isRecord(payload.props.borders)) {
		attrs.borders = payload.props.borders;
		tableProperties.borders = payload.props.borders;
	}
	if (Object.keys(tableProperties).length > 0) attrs.tableProperties = tableProperties;
	const grid = normalizeTableGridColumns(payload.columns);
	if (grid) {
		attrs.grid = grid;
		attrs.tableGrid = { colWidths: grid };
		attrs.tableGridModel = grid;
	}
	if (resolveNeedsTableStyleNormalization(node, payload)) attrs.needsTableStyleNormalization = true;
	return schema.nodes.table.create(attrs, rows);
}
function materializeTableRow(schema, row, seenIds, existingDocIds, operation, options) {
	const cells = (row.cells ?? []).map((cell) => materializeTableCell(schema, cell, seenIds, existingDocIds, operation, options));
	const attrs = { sdBlockId: v4_default() };
	if (row.props?.minHeight !== void 0) attrs.minHeight = row.props.minHeight;
	if (row.props?.cantSplit !== void 0) attrs.cantSplit = row.props.cantSplit;
	return schema.nodes.tableRow.create(attrs, cells);
}
function materializeTableCell(schema, cell, seenIds, existingDocIds, operation, options) {
	const children = (cell.content ?? [{ type: "paragraph" }]).map((child) => materializeNode(schema, child, seenIds, existingDocIds, operation, options));
	const attrs = { sdBlockId: v4_default() };
	if (cell.colSpan !== void 0) attrs.colspan = cell.colSpan;
	if (cell.rowSpan !== void 0) attrs.rowspan = cell.rowSpan;
	if (cell.props?.verticalAlign) attrs.verticalAlign = cell.props.verticalAlign;
	if (cell.props?.shading) attrs.shading = cell.props.shading;
	if (cell.props?.padding) attrs.padding = cell.props.padding;
	if (cell.props?.borders) attrs.borders = cell.props.borders;
	return schema.nodes.tableCell.create(attrs, children);
}
function normalizeTableGridColumns(columns) {
	if (!Array.isArray(columns) || columns.length === 0) return void 0;
	const normalized = columns.map((column) => {
		const raw = typeof column === "number" ? column : isRecord(column) && typeof column.width === "number" ? column.width : void 0;
		if (typeof raw !== "number" || !Number.isFinite(raw)) return null;
		return { col: Math.round(raw) };
	}).filter((item) => item !== null);
	return normalized.length > 0 ? normalized : void 0;
}
function mapSDTableWidthToMeasurement(width) {
	if (isRecord(width)) {
		if ("kind" in width && typeof width.kind === "string") switch (width.kind) {
			case "auto": return { type: "auto" };
			case "none": return { type: "nil" };
			case "percent":
				if (typeof width.value === "number" && Number.isFinite(width.value)) return {
					type: "pct",
					value: width.value
				};
				return;
			case "points":
				if (typeof width.value === "number" && Number.isFinite(width.value)) return {
					type: "dxa",
					value: Math.round(width.value * 20)
				};
				return;
			default: return;
		}
		if (typeof width.type === "string" && (typeof width.value === "number" || typeof width.width === "number" || width.type === "auto")) return { ...width };
	}
	if (typeof width === "number" && Number.isFinite(width)) return {
		type: "dxa",
		value: Math.round(width)
	};
}
function mapSDTableAlignmentToJustification(value) {
	if (typeof value !== "string") return void 0;
	switch (value) {
		case "left": return "left";
		case "center": return "center";
		case "right": return "right";
		case "inside": return "start";
		case "outside": return "end";
		default: return;
	}
}
function resolveNeedsTableStyleNormalization(node, payload) {
	if (payload.needsTableStyleNormalization === true) return true;
	if (!isRecord(node)) return false;
	const ext = node.ext;
	if (!isRecord(ext)) return false;
	if (ext.needsTableStyleNormalization === true) return true;
	const superdocExt = ext.superdoc;
	if (isRecord(superdocExt) && superdocExt.needsTableStyleNormalization === true) return true;
	return false;
}
function materializeImage(schema, node, seenIds, existingDocIds) {
	const payload = resolvePayload(node, "image");
	const attrs = { src: payload.src };
	if (payload.alt !== void 0) attrs.alt = payload.alt;
	if (payload.accessibility?.alt !== void 0) attrs.alt = payload.accessibility.alt;
	if (payload.geometry?.width !== void 0) attrs.width = payload.geometry.width;
	if (payload.geometry?.height !== void 0) attrs.height = payload.geometry.height;
	if (payload.width !== void 0 && !attrs.width) attrs.width = payload.width;
	if (payload.height !== void 0 && !attrs.height) attrs.height = payload.height;
	const imageNode = schema.nodes.image.create(attrs);
	return schema.nodes.paragraph.create({ sdBlockId: resolveBlockId(node, seenIds, existingDocIds) }, [imageNode]);
}
function materializeList(schema, node, seenIds, existingDocIds, operation, options) {
	const payload = resolvePayload(node, "list");
	const items = (payload.items ?? []).map((item) => materializeListItem(schema, item, payload, seenIds, existingDocIds, operation, options));
	const listType = payload.levels?.[0]?.kind === "ordered" || payload.ordered ? schema.nodes.orderedList : schema.nodes.bulletList;
	if (!listType) return materializeParagraph(schema, {
		type: "paragraph",
		content: []
	}, seenIds, existingDocIds, operation, options);
	const attrs = { sdBlockId: resolveBlockId(node, seenIds, existingDocIds) };
	if (payload.styleRef ?? payload.style) attrs.listStyleId = payload.styleRef ?? payload.style;
	return listType.create(attrs, items);
}
function materializeListItem(schema, item, _parentPayload, seenIds, existingDocIds, operation, options) {
	const itemContent = item.content ?? [];
	if (itemContent.length > 0 && (itemContent[0].kind || itemContent[0].type)) {
		const kind = resolveKind(itemContent[0]);
		if ([
			"paragraph",
			"heading",
			"table",
			"list",
			"image"
		].includes(kind)) {
			const children = itemContent.map((child) => materializeNode(schema, child, seenIds, existingDocIds, operation, options));
			const attrs$1 = { sdBlockId: v4_default() };
			if (item.level !== void 0) attrs$1.level = item.level;
			return schema.nodes.listItem.create(attrs$1, children);
		}
	}
	const content = materializeInlineContent(schema, itemContent, operation, options);
	const paragraph = schema.nodes.paragraph.create({ sdBlockId: v4_default() }, content);
	const attrs = { sdBlockId: v4_default() };
	if (item.level !== void 0) attrs.level = item.level;
	return schema.nodes.listItem.create(attrs, [paragraph]);
}
function materializeSectionBreak(schema, node, seenIds, existingDocIds) {
	const payload = resolvePayload(node, "sectionBreak");
	const attrs = { sdBlockId: resolveBlockId(node, seenIds, existingDocIds) };
	if (payload.breakType) attrs.breakType = payload.breakType;
	if (payload.targetSectionId) attrs.targetSectionId = payload.targetSectionId;
	const nodeType = schema.nodes.sectionBreak ?? schema.nodes.horizontalRule;
	if (!nodeType) return schema.nodes.paragraph.create({ sdBlockId: attrs.sdBlockId });
	return nodeType.create(attrs);
}
function materializeToc(schema, node, seenIds, existingDocIds) {
	const nodeType = schema.nodes.tableOfContents;
	const blockId = resolveBlockId(node, seenIds, existingDocIds);
	if (!nodeType) return schema.nodes.paragraph.create({ sdBlockId: blockId });
	return nodeType.create({ sdBlockId: blockId });
}
function materializeBreak(schema, node, seenIds, existingDocIds) {
	const payload = resolvePayload(node, "break");
	const blockId = resolveBlockId(node, seenIds, existingDocIds);
	const attrs = { sdBlockId: blockId };
	if (payload.type) attrs.breakType = payload.type;
	const nodeType = schema.nodes.pageBreak ?? schema.nodes.horizontalRule;
	if (!nodeType) return schema.nodes.paragraph.create({ sdBlockId: blockId });
	return nodeType.create(attrs);
}
function materializeDrawing(schema, node, seenIds, existingDocIds) {
	const payload = resolvePayload(node, "drawing");
	const blockId = resolveBlockId(node, seenIds, existingDocIds);
	const attrs = { sdBlockId: blockId };
	if (payload.source) attrs.source = payload.source;
	if (payload.layout) attrs.layout = payload.layout;
	if (payload.geometry) attrs.geometry = payload.geometry;
	const nodeType = schema.nodes.drawing;
	if (!nodeType) return schema.nodes.paragraph.create({ sdBlockId: blockId });
	return nodeType.create(attrs);
}
function materializeReferenceBlock(schema, node, kind, seenIds, existingDocIds) {
	const blockId = resolveBlockId(node, seenIds, existingDocIds);
	const nodeType = schema.nodes[kind];
	if (!nodeType) return schema.nodes.paragraph.create({ sdBlockId: blockId });
	return nodeType.create({ sdBlockId: blockId });
}
function materializeField(schema, node, seenIds, existingDocIds) {
	const payload = resolvePayload(node, "field");
	const blockId = resolveBlockId(node, seenIds, existingDocIds);
	const attrs = { sdBlockId: blockId };
	if (payload.fieldType) attrs.fieldType = payload.fieldType;
	if (payload.instruction) attrs.instruction = payload.instruction;
	if (payload.resultText) attrs.resultText = payload.resultText;
	const nodeType = schema.nodes.field;
	if (!nodeType) return schema.nodes.paragraph.create({ sdBlockId: blockId });
	return nodeType.create(attrs);
}
var SDT_LOCK_TO_LOCK_MODE = {
	none: "unlocked",
	sdt: "sdtLocked",
	content: "contentLocked",
	both: "sdtContentLocked"
};
function buildSdtAttrsFromPayload(payload) {
	const attrs = {};
	if (payload.tag) attrs.tag = payload.tag;
	if (payload.alias) attrs.alias = payload.alias;
	if (payload.type) attrs.controlType = payload.type;
	if (payload.appearance) attrs.appearance = payload.appearance;
	if (payload.placeholder) attrs.placeholder = payload.placeholder;
	if (payload.lock) {
		const lockMode = SDT_LOCK_TO_LOCK_MODE[payload.lock];
		if (lockMode) attrs.lockMode = lockMode;
	}
	return attrs;
}
function materializeSdt(schema, node, seenIds, existingDocIds, operation, options) {
	const payload = resolvePayload(node, "sdt");
	const children = (payload.content ?? []).map((child) => materializeNode(schema, child, seenIds, existingDocIds, operation, options));
	const nodeType = schema.nodes.structuredContentBlock ?? schema.nodes.sdt;
	if (!nodeType) return schema.nodes.paragraph.create({ sdBlockId: resolveBlockId(node, seenIds, existingDocIds) });
	const resolvedId = resolveBlockId(node, seenIds, existingDocIds);
	const attrs = {
		...buildSdtAttrsFromPayload(payload),
		id: resolvedId,
		sdBlockId: resolvedId
	};
	return nodeType.create(attrs, children.length > 0 ? children : void 0);
}
function materializeInlineSdt(schema, node, operation, options) {
	const payload = resolvePayload(node, "sdt");
	const nodeType = schema.nodes.structuredContent;
	if (!nodeType) return materializeInlineFallback(schema, node);
	const children = materializeInlineContent(schema, payload.inlines ?? payload.content, operation, options);
	const attrs = {
		...buildSdtAttrsFromPayload(payload),
		id: node.id ?? null
	};
	return nodeType.create(attrs, children);
}
function materializeFallback(schema, node, seenIds, existingDocIds) {
	return schema.nodes.paragraph.create({ sdBlockId: resolveBlockId(node, seenIds, existingDocIds) });
}
function materializeInlineContent(schema, content, operation, options) {
	if (!content || content.length === 0) return void 0;
	const result = [];
	for (const item of content) {
		const materialized = materializeInlineNode(schema, item, operation, options);
		if (Array.isArray(materialized)) result.push(...materialized);
		else result.push(materialized);
	}
	return result;
}
function materializeInlineNode(schema, node, operation, options) {
	const kind = resolveKind(node);
	assertCapability(kind, operation, "inline", options);
	switch (kind) {
		case "run": return materializeRun(schema, node);
		case "text": return materializeTextRun(schema, node);
		case "hyperlink": return materializeHyperlink(schema, node, operation, options);
		case "image": return materializeInlineImage(schema, node);
		case "drawing": return materializeInlineDrawing(schema, node);
		case "tab": return materializeTab(schema);
		case "lineBreak": return materializeLineBreak(schema);
		case "crossRef":
		case "tocEntry":
		case "indexEntry":
		case "citation":
		case "authorityEntry":
		case "sequenceField": return materializeInlineReference(schema, node, kind);
		case "field": return materializeInlineField(schema, node);
		case "footnoteRef":
		case "endnoteRef": return materializeNoteRef(schema, node, kind);
		case "sdt": return materializeInlineSdt(schema, node, operation, options);
		default: return materializeInlineFallback(schema, node);
	}
}
function materializeRun(schema, node) {
	const payload = resolvePayload(node, "run");
	const marks = buildMarksFromRunPayload(schema, payload);
	return toMaterializedInlines(buildTextWithTabs(schema, payload.text, marks.length > 0 ? marks : void 0));
}
function materializeTextRun(schema, node) {
	const marks = buildMarksFromLegacyRun(schema, node);
	return toMaterializedInlines(buildTextWithTabs(schema, node.text, marks.length > 0 ? marks : void 0));
}
function toMaterializedInlines(content) {
	if (content instanceof Fragment) {
		const out = [];
		content.forEach((child) => out.push(child));
		return out;
	}
	return content;
}
function materializeHyperlink(schema, node, operation, options) {
	const payload = resolvePayload(node, "hyperlink");
	const children = materializeInlineContent(schema, payload.inlines ?? payload.content ?? [], operation, options) ?? [];
	const linkMark = schema.marks.link;
	if (!linkMark) return children.length > 0 ? children : [schema.text(" ")];
	const attrs = {};
	if (payload.href) attrs.href = payload.href;
	if (payload.anchor) attrs.anchor = payload.anchor;
	if (payload.tooltip) attrs.tooltip = payload.tooltip;
	const mark = linkMark.create(attrs);
	return children.map((child) => child.mark(mark.addToSet(child.marks)));
}
function materializeInlineImage(schema, node) {
	const payload = resolvePayload(node, "image");
	const attrs = { src: payload.src };
	if (payload.alt !== void 0) attrs.alt = payload.alt;
	if (payload.accessibility?.alt !== void 0) attrs.alt = payload.accessibility.alt;
	if (payload.geometry?.width !== void 0) attrs.width = payload.geometry.width;
	if (payload.geometry?.height !== void 0) attrs.height = payload.geometry.height;
	if (payload.width !== void 0 && !attrs.width) attrs.width = payload.width;
	if (payload.height !== void 0 && !attrs.height) attrs.height = payload.height;
	return schema.nodes.image.create(attrs);
}
function materializeInlineDrawing(schema, node) {
	const payload = resolvePayload(node, "drawing");
	const nodeType = schema.nodes.drawing ?? schema.nodes.image;
	if (!nodeType) return schema.text("￼");
	const attrs = {};
	if (payload.source) attrs.source = payload.source;
	if (payload.layout) attrs.layout = payload.layout;
	if (payload.geometry) attrs.geometry = payload.geometry;
	return nodeType.create(attrs);
}
function materializeTab(schema) {
	const nodeType = schema.nodes.tab;
	if (!nodeType) return schema.text("	");
	return nodeType.create();
}
function materializeLineBreak(schema) {
	const nodeType = schema.nodes.lineBreak ?? schema.nodes.hardBreak;
	if (!nodeType) return schema.text("\n");
	return nodeType.create();
}
function materializeInlineReference(schema, node, kind) {
	const payload = resolvePayload(node, kind);
	const nodeType = schema.nodes[kind];
	if (!nodeType) return schema.text(payload.resolvedText ?? payload.displayText ?? payload.text ?? "");
	const attrs = {};
	if (payload.instruction) attrs.instruction = payload.instruction;
	if (payload.text) attrs.text = payload.text;
	if (payload.level !== void 0) attrs.level = payload.level;
	return nodeType.create(attrs);
}
function materializeInlineField(schema, node) {
	const payload = resolvePayload(node, "field");
	const nodeType = schema.nodes.field;
	if (!nodeType) return schema.text(payload.resultText ?? "");
	const attrs = {};
	if (payload.fieldType) attrs.fieldType = payload.fieldType;
	if (payload.instruction) attrs.instruction = payload.instruction;
	if (payload.resultText) attrs.resultText = payload.resultText;
	return nodeType.create(attrs);
}
function materializeNoteRef(schema, node, kind) {
	const payload = resolvePayload(node, kind);
	const nodeType = schema.nodes[kind];
	if (!nodeType) return schema.text("");
	const attrs = {};
	if (payload.noteId) attrs.noteId = payload.noteId;
	return nodeType.create(attrs);
}
function materializeInlineFallback(schema, node) {
	const payload = node[resolveKind(node)] ?? node;
	if (payload.text) return toMaterializedInlines(buildTextWithTabs(schema, payload.text, void 0));
	return schema.text("￼");
}
function buildParagraphProperties(styleRef, props) {
	if (!styleRef && !props) return void 0;
	const result = {};
	if (styleRef) result.styleId = styleRef;
	if (!props) return result;
	if (props.alignment) result.justification = props.alignment;
	if (props.indent) result.indent = props.indent;
	if (props.spacing) result.spacing = props.spacing;
	if (props.keepWithNext !== void 0) result.keepWithNext = props.keepWithNext;
	if (props.keepLines !== void 0) result.keepLines = props.keepLines;
	if (props.pageBreakBefore !== void 0) result.pageBreakBefore = props.pageBreakBefore;
	if (props.widowControl !== void 0) result.widowControl = props.widowControl;
	if (props.numbering) result.numbering = props.numbering;
	if (props.tabs) result.tabs = props.tabs;
	if (props.borders) result.borders = props.borders;
	if (props.shading) result.shading = props.shading;
	if (props.bidi !== void 0) result.rightToLeft = props.bidi;
	if (props.outlineLevel !== void 0) result.outlineLevel = props.outlineLevel;
	if (props.markRunProps) result.markRunProps = props.markRunProps;
	if (props.textDirection) result.textDirection = props.textDirection;
	if (props.eastAsianLineBreak) result.eastAsianLineBreak = props.eastAsianLineBreak;
	return Object.keys(result).length > 0 ? result : void 0;
}
function buildMarksFromRunPayload(schema, payload) {
	const marks = [];
	const props = payload.props;
	if (props?.bold && schema.marks.bold) marks.push(schema.marks.bold.create());
	if (props?.italic && schema.marks.italic) marks.push(schema.marks.italic.create());
	if (props?.strikethrough && schema.marks.strikethrough) marks.push(schema.marks.strikethrough.create());
	if (props?.underline && schema.marks.underline) marks.push(schema.marks.underline.create(typeof props.underline === "object" ? props.underline : void 0));
	if (props?.highlight && schema.marks.highlight) marks.push(schema.marks.highlight.create({ color: props.highlight }));
	const textStyleAttrs = buildTextStyleAttrs(payload);
	if (textStyleAttrs && schema.marks.textStyle) marks.push(schema.marks.textStyle.create(textStyleAttrs));
	return marks;
}
function buildTextStyleAttrs(payload) {
	const attrs = {};
	if (payload.styleRef) attrs.rStyle = payload.styleRef;
	const p = payload.props;
	if (p) {
		if (p.color) attrs.color = p.color;
		if (p.fontSize !== void 0) attrs.fontSize = p.fontSize;
		if (p.fontSizeCs !== void 0) attrs.fontSizeCs = p.fontSizeCs;
		if (p.fontFamily) attrs.fontFamily = p.fontFamily;
		if (p.fonts) attrs.fonts = p.fonts;
		if (p.caps) attrs.caps = true;
		if (p.smallCaps) attrs.smallCaps = true;
		if (p.vanish) attrs.vanish = true;
		if (p.characterSpacing !== void 0) attrs.characterSpacing = p.characterSpacing;
	}
	return Object.keys(attrs).length > 0 ? attrs : null;
}
function buildMarksFromLegacyRun(schema, run) {
	const marks = [];
	if (run.bold && schema.marks.bold) marks.push(schema.marks.bold.create());
	if (run.italic && schema.marks.italic) marks.push(schema.marks.italic.create());
	if (run.underline && schema.marks.underline) marks.push(schema.marks.underline.create());
	if (run.strikethrough && schema.marks.strikethrough) marks.push(schema.marks.strikethrough.create());
	const textStyleAttrs = {};
	if (run.color) textStyleAttrs.color = run.color;
	if (run.fontSize) textStyleAttrs.fontSize = `${run.fontSize}pt`;
	if (run.fontFamily) textStyleAttrs.fontFamily = run.fontFamily;
	if (Object.keys(textStyleAttrs).length > 0 && schema.marks.textStyle) marks.push(schema.marks.textStyle.create(textStyleAttrs));
	if (run.highlight && schema.marks.highlight) marks.push(schema.marks.highlight.create({ color: run.highlight }));
	return marks;
}
function findBlockByTarget(index, target, operationName) {
	const nodeId = target.kind === "block" ? target.nodeId : target.blockId;
	try {
		if (target.kind === "block") {
			const typed = findBlockById(index, target);
			if (typed) return typed;
			return findBlockByNodeIdOnly(index, nodeId);
		}
		return findBlockByNodeIdOnly(index, nodeId);
	} catch {
		throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Cannot resolve ${operationName} target for block "${nodeId}".`);
	}
}
function resolveInsertTarget(editor, target) {
	if (!target) return resolveDocumentEndTarget(editor);
	const candidate = findBlockByTarget(getBlockIndex(editor), target, "insert");
	return {
		insertPos: candidate.end,
		structuralEnd: false,
		effectiveTarget: target.kind === "block" ? {
			kind: "text",
			blockId: target.nodeId,
			range: {
				start: 0,
				end: 0
			}
		} : target,
		targetNode: candidate.node,
		targetNodePos: candidate.pos
	};
}
function resolveReplaceTarget(editor, target) {
	const candidate = findBlockByTarget(getBlockIndex(editor), target, "replace");
	return {
		from: candidate.pos,
		to: candidate.end,
		effectiveTarget: target.kind === "block" ? {
			kind: "text",
			blockId: target.nodeId,
			range: {
				start: 0,
				end: 0
			}
		} : target
	};
}
function resolveDocumentEndTarget(editor) {
	const fallback = resolveDefaultInsertTarget(editor);
	if (!fallback) return {
		insertPos: editor.state.doc.content.size,
		structuralEnd: true
	};
	if (fallback.kind === "structural-end") return {
		insertPos: fallback.insertPos,
		structuralEnd: true
	};
	const index = getBlockIndex(editor);
	let targetNode;
	let targetNodePos;
	try {
		const candidate = findBlockByNodeIdOnly(index, fallback.target.blockId);
		targetNode = candidate.node;
		targetNodePos = candidate.pos;
	} catch {}
	return {
		insertPos: fallback.range.to,
		structuralEnd: false,
		effectiveTarget: fallback.target,
		targetNode,
		targetNodePos
	};
}
function resolvePlacement(doc, targetPos, targetNode, placement) {
	const effectivePlacement = placement ?? "after";
	const nodeEnd = targetPos + targetNode.nodeSize;
	switch (effectivePlacement) {
		case "before": return targetPos;
		case "after": return nodeEnd;
		case "insideStart":
			if (!targetNode.isBlock || targetNode.isLeaf) throw new DocumentApiAdapterError("INVALID_PLACEMENT", `Placement "insideStart" is not valid for "${targetNode.type.name}" — target must be a container block.`);
			return targetPos + 1;
		case "insideEnd":
			if (!targetNode.isBlock || targetNode.isLeaf) throw new DocumentApiAdapterError("INVALID_PLACEMENT", `Placement "insideEnd" is not valid for "${targetNode.type.name}" — target must be a container block.`);
			return nodeEnd - 1;
	}
}
function fragmentContainsTable(fragment) {
	return (Array.isArray(fragment) ? fragment : [fragment]).some(nodeContainsTable);
}
function nodeContainsTable(node) {
	if ((node.kind ?? node.type) === "table") return true;
	return getChildContentNodes(node).some(nodeContainsTable);
}
function getChildContentNodes(node) {
	const children = [];
	if (node.kind === "list") for (const item of node.list.items) children.push(...item.content);
	else if (node.kind === "table") for (const row of node.table.rows) for (const cell of row.cells) children.push(...cell.content);
	else if (node.kind === "sdt" && node.sdt.content) children.push(...node.sdt.content);
	else if (node.kind === "customXml" && node.customXml.content) children.push(...node.customXml.content);
	return children;
}
function isInsideTable(doc, pos) {
	const $pos = doc.resolve(pos);
	for (let depth = $pos.depth; depth > 0; depth--) {
		const nodeType = $pos.node(depth).type.name;
		if (nodeType === "tableCell" || nodeType === "tableHeader") return true;
	}
	return false;
}
function enforceNestingPolicy(fragment, doc, insertPos, policy) {
	if ((policy?.tables ?? DEFAULT_NESTING_POLICY.tables) === "allow") return;
	if (fragmentContainsTable(fragment) && isInsideTable(doc, insertPos)) throw new DocumentApiAdapterError("INVALID_NESTING", "Cannot insert a table inside another table. Pass nestingPolicy: { tables: \"allow\" } to override.");
}
function executeStructuralInsert(editor, options) {
	const { content, placement, nestingPolicy, target, changeMode, dryRun } = options;
	const schema = editor.state.schema;
	const resolved = resolveInsertTarget(editor, target);
	let insertPos;
	if (resolved.targetNode && resolved.targetNodePos !== void 0) insertPos = resolvePlacement(editor.state.doc, resolved.targetNodePos, resolved.targetNode, placement);
	else insertPos = resolved.insertPos;
	validateSectionReferences(editor, content);
	const pmFragment = materializeFragment(schema, content, collectExistingBlockIds(editor.state.doc), "insert");
	enforceNestingPolicy(content, editor.state.doc, insertPos, nestingPolicy);
	const insertedBlockIds = collectBlockIds(pmFragment);
	if (dryRun) return {
		success: true,
		insertedBlockIds
	};
	const tr = editor.state.tr.insert(insertPos, pmFragment);
	applyChangeModeMeta(tr, changeMode);
	editor.dispatch(tr);
	clearIndexCache(editor);
	return {
		success: true,
		insertedBlockIds
	};
}
function executeStructuralReplace(editor, options) {
	const { content, nestingPolicy, target, changeMode, dryRun, resolvedRange } = options;
	const schema = editor.state.schema;
	const resolved = resolvedRange ? {
		from: resolvedRange.from,
		to: resolvedRange.to,
		effectiveTarget: target
	} : resolveReplaceTarget(editor, target);
	validateSectionReferences(editor, content);
	const pmFragment = materializeFragment(schema, content, collectExistingBlockIds(editor.state.doc), "replace");
	enforceNestingPolicy(content, editor.state.doc, resolved.from, nestingPolicy);
	const insertedBlockIds = collectBlockIds(pmFragment);
	if (dryRun) return {
		success: true,
		insertedBlockIds
	};
	const tr = editor.state.tr.replaceWith(resolved.from, resolved.to, pmFragment);
	applyChangeModeMeta(tr, changeMode);
	editor.dispatch(tr);
	clearIndexCache(editor);
	return {
		success: true,
		insertedBlockIds
	};
}
function validateSectionReferences(editor, fragment) {
	const sectionRefIds = collectSectionRefIds(Array.isArray(fragment) ? fragment : [fragment]);
	if (sectionRefIds.length === 0) return;
	const projections = resolveSectionProjections(editor);
	const validIds = new Set(projections.map((p) => p.sectionId));
	for (const refId of sectionRefIds) if (!validIds.has(refId)) throw new DocumentApiAdapterError("INVALID_CONTEXT", `sectionBreak.targetSectionId "${refId}" does not reference a valid section.`);
}
function collectSectionRefIds(nodes) {
	const refIds = [];
	const visit = (children) => {
		for (const node of children) {
			if (node.kind === "sectionBreak" && "sectionBreak" in node) {
				const payload = node.sectionBreak;
				if (payload.targetSectionId) refIds.push(payload.targetSectionId);
			}
			if (node.kind === "list") for (const item of node.list.items) visit(item.content);
			else if (node.kind === "table") for (const row of node.table.rows) for (const cell of row.cells) visit(cell.content);
			else if (node.kind === "sdt" && node.sdt.content) visit(node.sdt.content);
			else if (node.kind === "customXml" && node.customXml.content) visit(node.customXml.content);
		}
	};
	visit(nodes);
	return refIds;
}
function collectExistingBlockIds(doc) {
	const ids = /* @__PURE__ */ new Set();
	doc.descendants((node) => {
		const sdBlockId = node.attrs?.sdBlockId;
		if (typeof sdBlockId === "string" && sdBlockId) ids.add(sdBlockId);
		return true;
	});
	return ids;
}
function applyChangeModeMeta(tr, changeMode) {
	if (changeMode === "tracked") applyTrackedMutationMeta(tr);
	else applyDirectMutationMeta(tr);
}
function collectBlockIds(fragment) {
	const ids = [];
	for (let i = 0; i < fragment.childCount; i++) {
		const sdBlockId = fragment.child(i).attrs?.sdBlockId;
		if (typeof sdBlockId === "string") ids.push(sdBlockId);
	}
	return ids;
}
function getSchemaMarks(editor) {
	return editor.schema?.marks ?? editor.state.schema?.marks ?? {};
}
function getSchemaNodes(editor) {
	return editor.state.schema?.nodes ?? editor.schema?.nodes ?? {};
}
function getMarkAttrs(markType) {
	if (!markType || typeof markType !== "object") return void 0;
	const specAttrs = markType.spec?.attrs;
	if (specAttrs && typeof specAttrs === "object") return specAttrs;
	const attrs = markType.attrs;
	if (attrs && typeof attrs === "object") return attrs;
}
function getInlinePropertyCapabilityIssue(editor, keys, operationName = "format.apply") {
	const schemaMarks = getSchemaMarks(editor);
	const requiredTextStyleAttrs = /* @__PURE__ */ new Set();
	let requiresRunNode = false;
	for (const key$1 of keys) {
		const entry = INLINE_PROPERTY_BY_KEY[key$1];
		if (!entry) continue;
		if (entry.storage === "mark") {
			const carrier = entry.carrier;
			if (carrier.storage !== "mark") continue;
			if (!schemaMarks[carrier.markName]) return {
				code: "CAPABILITY_UNAVAILABLE",
				message: `${operationName} requires the "${carrier.markName}" mark.`,
				details: {
					reason: "missing_mark",
					markName: carrier.markName
				}
			};
			if (carrier.markName === "textStyle" && carrier.textStyleAttr) requiredTextStyleAttrs.add(carrier.textStyleAttr);
			continue;
		}
		requiresRunNode = true;
	}
	if (requiredTextStyleAttrs.size > 0) {
		const markAttrs = getMarkAttrs(schemaMarks.textStyle);
		for (const attr of requiredTextStyleAttrs) if (!markAttrs || !Object.prototype.hasOwnProperty.call(markAttrs, attr)) return {
			code: "CAPABILITY_UNAVAILABLE",
			message: `${operationName} requires the "${attr}" attribute on the textStyle mark.`,
			details: {
				reason: "missing_mark_attribute",
				markName: "textStyle",
				attribute: attr
			}
		};
	}
	if (requiresRunNode && !getSchemaNodes(editor).run) return {
		code: "CAPABILITY_UNAVAILABLE",
		message: `${operationName} requires a run node in the schema.`
	};
}
function getTrackedInlinePropertySupportIssue(keys, operationName = "format.apply") {
	const unsupportedTrackedKeys = keys.filter((key$1) => INLINE_PROPERTY_BY_KEY[key$1]?.tracked === false);
	if (unsupportedTrackedKeys.length === 0) return void 0;
	return {
		code: "CAPABILITY_UNAVAILABLE",
		message: `${operationName} tracked mode is not available for: ${unsupportedTrackedKeys.join(", ")}`,
		details: {
			keys: unsupportedTrackedKeys,
			changeMode: "tracked"
		}
	};
}
function resolveStoryFromInput(input, target, within) {
	if (within?.story !== void 0) throw new DocumentApiAdapterError("INVALID_INPUT", "The \"within\" context must not carry a story locator. Story targeting is specified via `input.in` or inherited from the target ref.", {
		source: "within",
		locator: within.story
	});
	const fromInput = input?.in;
	const fromTarget = target?.story;
	if (fromInput === void 0 && fromTarget === void 0) return;
	if (fromInput !== void 0 && fromTarget === void 0) return fromInput;
	if (fromInput === void 0 && fromTarget !== void 0) return fromTarget;
	const inputKey = storyLocatorToKey(fromInput);
	const targetKey = storyLocatorToKey(fromTarget);
	if (inputKey !== targetKey) throw new DocumentApiAdapterError("INVALID_INPUT", `Story mismatch: input.in targets "${inputKey}" but the target ref belongs to "${targetKey}". An operation cannot span multiple stories.`, {
		reason: "STORY_MISMATCH",
		inputStory: inputKey,
		targetStory: targetKey
	});
	return fromInput;
}
var BODY_LOCATOR = {
	kind: "story",
	storyType: "body"
};
function resolveStoryFromRef(ref) {
	if (!ref) return void 0;
	const decoded = decodeRef(ref);
	if (!decoded) return void 0;
	if (decoded.v !== 4) return BODY_LOCATOR;
	try {
		return parseStoryKey(decoded.storyKey);
	} catch (error) {
		throw new DocumentApiAdapterError("INVALID_TARGET", `Ref carries an invalid story key: ${error instanceof Error ? error.message : String(error)}`, {
			ref,
			storyKey: decoded.storyKey
		});
	}
}
function resolveMutationStory(context) {
	const storyFromRef = resolveStoryFromRef(context.ref);
	const effectiveTargetStory = context.target?.story ?? storyFromRef;
	return resolveStoryFromInput({ in: context.in }, effectiveTargetStory ? { story: effectiveTargetStory } : void 0);
}
function nodeEdgeAfterOffset(editor, nodeType, nodeId) {
	const index = getBlockIndex(editor);
	const key$1 = `${nodeType}:${nodeId}`;
	const block = index.byId.get(key$1);
	if (!block || !block.node.isTextblock) return 0;
	const contentStart = block.pos + 1;
	const contentEnd = block.end - 1;
	if (contentEnd <= contentStart) return 0;
	return editor.state.doc.textBetween(contentStart, contentEnd, "", "￼").length;
}
function editorHasDom(editor) {
	const opts = editor.options;
	return !!(opts?.document ?? opts?.mockDocument ?? (typeof document !== "undefined" ? document : null));
}
function isMismatchedTransactionError(error) {
	return (error instanceof Error ? error.message : String(error)).includes("Applying a mismatched transaction");
}
function insertContentAtWithRetry(editor, range, content) {
	try {
		return Boolean(editor.commands.insertContentAt(range, content));
	} catch (error) {
		if (!isMismatchedTransactionError(error)) throw error;
		return Boolean(editor.commands.insertContentAt(range, content));
	}
}
function isJsonObject(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}
function resolveWriteStoryRuntime(editor, locator) {
	return resolveStoryRuntime(editor, locator, { intent: "write" });
}
function disposeEphemeralWriteRuntime(runtime) {
	if (runtime.cacheable === false) runtime.dispose?.();
}
function resolveSelectionMutationStory(request) {
	return resolveMutationStory({
		in: request.in,
		target: request.target,
		ref: request.ref
	});
}
function ensureMarkdownImageIds(nodes) {
	const visit = (node) => {
		if (node.type === "image") {
			const attrs = isJsonObject(node.attrs) ? { ...node.attrs } : {};
			if (!(typeof attrs.sdImageId === "string" && attrs.sdImageId.length > 0)) attrs.sdImageId = v4_default();
			node.attrs = attrs;
		}
		if (!Array.isArray(node.content)) return;
		for (const child of node.content) if (isJsonObject(child)) visit(child);
	};
	for (const node of nodes) visit(node);
}
function ensureTableSeparators(jsonNodes) {
	for (let i = jsonNodes.length - 2; i >= 0; i--) if (jsonNodes[i].type === "table" && jsonNodes[i + 1].type === "table") jsonNodes.splice(i + 1, 0, { type: "paragraph" });
}
function targetBlockId(target) {
	return target.kind === "block" ? target.nodeId : target.blockId;
}
function toTextAddress(target) {
	if (target.kind === "text") return target;
	return {
		kind: "text",
		blockId: target.nodeId,
		range: {
			start: 0,
			end: 0
		}
	};
}
function mapPlanReceiptToTextReceipt(_receipt, resolution) {
	return {
		success: true,
		resolution
	};
}
const STUB_WHERE = {
	by: "select",
	select: {
		type: "text",
		pattern: "",
		mode: "exact"
	},
	require: "exactlyOne"
};
function toCompiledTarget(stepId, op, resolved) {
	return {
		kind: "range",
		stepId,
		op,
		blockId: resolved.effectiveTarget.blockId,
		from: resolved.effectiveTarget.range.start,
		to: resolved.effectiveTarget.range.end,
		absFrom: resolved.range.from,
		absTo: resolved.range.to,
		text: resolved.resolution.text,
		marks: []
	};
}
function executeDomainCommand(editor, handler, options) {
	return executeCompiledPlan(editor, {
		mutationSteps: [{
			step: {
				id: v4_default(),
				op: "domain.command",
				where: STUB_WHERE,
				args: {},
				_handler: handler
			},
			targets: []
		}],
		assertSteps: [],
		compiledRevision: getRevision(editor)
	}, {
		expectedRevision: options?.expectedRevision,
		changeMode: options?.changeMode
	});
}
function validateWriteRequest(request, resolved) {
	if (!request.text) return {
		code: "INVALID_TARGET",
		message: "Insert operations require non-empty text."
	};
	if (resolved.range.from !== resolved.range.to) return {
		code: "INVALID_TARGET",
		message: "Insert operations require a collapsed target range."
	};
	return null;
}
function writeWrapper(editor, request, options) {
	const runtime = resolveWriteStoryRuntime(editor, request.in);
	try {
		const storyEditor = runtime.editor;
		const resolved = resolveWriteTarget(storyEditor, request);
		if (!resolved) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Mutation target could not be resolved.", {});
		const validationFailure = validateWriteRequest(request, resolved);
		if (validationFailure) return {
			success: false,
			resolution: resolved.resolution,
			failure: validationFailure
		};
		const mode = options?.changeMode ?? "direct";
		if (mode === "tracked") ensureTrackedCapability(storyEditor, { operation: "write" });
		if (options?.dryRun) return {
			success: true,
			resolution: resolved.resolution
		};
		if (resolved.structuralEnd) {
			const insertPos = resolved.range.from;
			const text = request.text ?? "";
			const receipt$1 = executeDomainCommand(storyEditor, () => {
				insertParagraphAtEnd(storyEditor, insertPos, text, mode === "tracked" ? applyTrackedMutationMeta : applyDirectMutationMeta);
				return true;
			}, { expectedRevision: options?.expectedRevision });
			if (runtime.commit) runtime.commit(editor);
			return mapPlanReceiptToTextReceipt(receipt$1, resolved.resolution);
		}
		const stepId = v4_default();
		const receipt = executeCompiledPlan(storyEditor, {
			mutationSteps: [{
				step: {
					id: stepId,
					op: "text.insert",
					where: STUB_WHERE,
					args: {
						position: "before",
						content: { text: request.text ?? "" }
					}
				},
				targets: [toCompiledTarget(stepId, "text.insert", resolved)]
			}],
			assertSteps: [],
			compiledRevision: getRevision(storyEditor)
		}, {
			changeMode: mode,
			expectedRevision: options?.expectedRevision
		});
		if (runtime.commit) runtime.commit(editor);
		return mapPlanReceiptToTextReceipt(receipt, resolved.resolution);
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function ensureInlinePropertyCapabilities(editor, keys) {
	const issue = getInlinePropertyCapabilityIssue(editor, keys);
	if (!issue) return;
	throw new DocumentApiAdapterError(issue.code, issue.message, issue.details);
}
function ensureTrackedInlinePropertySupport(keys) {
	const issue = getTrackedInlinePropertySupportIssue(keys);
	if (!issue) return;
	throw new DocumentApiAdapterError(issue.code, issue.message, issue.details);
}
function buildSelectionWhere(request) {
	if (request.target) return {
		by: "target",
		target: request.target
	};
	if (request.ref) return {
		by: "ref",
		ref: request.ref
	};
	throw new DocumentApiAdapterError("INVALID_TARGET", "Selection mutation requires either target or ref.");
}
function buildSelectionStepDef(stepId, request, where) {
	switch (request.kind) {
		case "delete": return {
			id: stepId,
			op: "text.delete",
			where,
			args: { behavior: request.behavior }
		};
		case "replace": return {
			id: stepId,
			op: "text.rewrite",
			where,
			args: {
				replacement: { text: request.text },
				style: { inline: { mode: "preserve" } }
			}
		};
		case "insert": return {
			id: stepId,
			op: "text.insert",
			where,
			args: {
				position: "before",
				content: { text: request.text }
			}
		};
		case "format": return {
			id: stepId,
			op: "format.apply",
			where,
			args: { inline: request.inline }
		};
	}
}
function selectionMutationWrapper(editor, request, options) {
	const runtime = resolveWriteStoryRuntime(editor, resolveSelectionMutationStory(request));
	try {
		const storyEditor = runtime.editor;
		const mode = options?.changeMode ?? "direct";
		if (mode === "tracked") ensureTrackedCapability(storyEditor, { operation: request.kind });
		if (request.kind === "format") {
			const inlineKeys = Object.keys(request.inline);
			ensureInlinePropertyCapabilities(storyEditor, inlineKeys);
			if (mode === "tracked") ensureTrackedInlinePropertySupport(inlineKeys);
		}
		const stepId = v4_default();
		const step = buildSelectionStepDef(stepId, request, buildSelectionWhere(request));
		checkRevision(storyEditor, options?.expectedRevision);
		const compiled = compilePlan(storyEditor, [step], options?.dryRun ? { skipIdentityRepair: true } : void 0);
		if (request.kind === "insert" && request.target) {
			if (request.target.start.kind === "nodeEdge" || request.target.end.kind === "nodeEdge") throw new DocumentApiAdapterError("INVALID_TARGET", "Text inserts do not support nodeEdge targets. Use a text-offset target inside a textblock.");
		}
		if (request.kind === "insert") {
			const target = compiled.mutationSteps.find((s) => s.step.id === stepId)?.targets[0];
			if (target) {
				if (target.kind === "span") return {
					success: false,
					resolution: buildSelectionResolutionFromCompiled(compiled, stepId),
					failure: {
						code: "INVALID_TARGET",
						message: "Insert operations require a single-block target, not a multi-segment span."
					}
				};
				if (target.kind === "range") {
					if (!storyEditor.state.doc.resolve(target.absFrom).parent.isTextblock) return {
						success: false,
						resolution: buildSelectionResolutionFromCompiled(compiled, stepId),
						failure: {
							code: "INVALID_TARGET",
							message: "Text insert target must be inside a textblock."
						}
					};
				}
			}
		}
		if (options?.dryRun) {
			const resolution$1 = buildSelectionResolutionFromCompiled(compiled, stepId);
			if (request.kind === "insert" && !request.text) return {
				success: false,
				resolution: resolution$1,
				failure: {
					code: "NO_OP",
					message: "Insert text is empty."
				}
			};
			return {
				success: true,
				resolution: resolution$1
			};
		}
		const stepOutcome = executeCompiledPlan(storyEditor, compiled, {
			changeMode: mode,
			expectedRevision: options?.expectedRevision
		}).steps.find((s) => s.stepId === stepId);
		const resolution = buildSelectionResolutionFromOutcome(stepOutcome, compiled, stepId);
		if (!(stepOutcome?.effect === "changed")) return {
			success: false,
			resolution,
			failure: {
				code: "NO_OP",
				message: `${request.kind} produced no change.`
			}
		};
		if (runtime.commit) runtime.commit(editor);
		return {
			success: true,
			resolution
		};
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function blockIdFromPoint(point) {
	return point.kind === "text" ? point.blockId : point.node.nodeId;
}
function selectionTargetToResolution(selectionTarget, range, text) {
	const startPoint = selectionTarget.start;
	const endPoint = selectionTarget.end;
	const blockId = blockIdFromPoint(startPoint);
	const startOffset = startPoint.kind === "text" ? startPoint.offset : 0;
	const endOffset = endPoint.kind === "text" && endPoint.blockId === blockId ? endPoint.offset : startOffset;
	const isCrossBlock = startPoint.kind !== "text" || endPoint.kind !== "text" || blockIdFromPoint(startPoint) !== blockIdFromPoint(endPoint);
	return {
		target: {
			kind: "text",
			blockId,
			range: {
				start: startOffset,
				end: endOffset
			}
		},
		range,
		text,
		...isCrossBlock ? { selectionTarget } : void 0
	};
}
var EMPTY_RESOLUTION = {
	target: {
		kind: "text",
		blockId: "",
		range: {
			start: 0,
			end: 0
		}
	},
	range: {
		from: 0,
		to: 0
	},
	text: ""
};
function buildSelectionResolutionFromCompiled(compiled, stepId) {
	const target = compiled.mutationSteps.find((s) => s.step.id === stepId)?.targets[0];
	if (target?.kind === "selection") return selectionTargetToResolution(target.normalizedTarget, {
		from: target.absFrom,
		to: target.absTo
	}, target.text);
	if (target?.kind === "range") return {
		target: {
			kind: "text",
			blockId: target.blockId,
			range: {
				start: target.from,
				end: target.to
			}
		},
		range: {
			from: target.absFrom,
			to: target.absTo
		},
		text: target.text
	};
	if (target?.kind === "span") return spanTargetToResolution(target);
	return EMPTY_RESOLUTION;
}
function spanTargetToResolution(target) {
	const first = target.segments[0];
	const last = target.segments[target.segments.length - 1];
	if (!first || !last) return EMPTY_RESOLUTION;
	const selectionTarget = first.blockId !== last.blockId ? {
		kind: "selection",
		start: {
			kind: "text",
			blockId: first.blockId,
			offset: first.from
		},
		end: {
			kind: "text",
			blockId: last.blockId,
			offset: last.to
		}
	} : void 0;
	return {
		target: {
			kind: "text",
			blockId: first.blockId,
			range: {
				start: first.from,
				end: first.to
			}
		},
		range: {
			from: first.absFrom,
			to: last.absTo
		},
		text: target.text,
		...selectionTarget ? { selectionTarget } : void 0
	};
}
function buildSelectionResolutionFromOutcome(stepOutcome, compiled, stepId) {
	if (stepOutcome?.data) {
		const data = stepOutcome.data;
		if ("selectionResolutions" in data && Array.isArray(data.selectionResolutions) && data.selectionResolutions.length > 0) {
			const selRes = data.selectionResolutions[0];
			return selectionTargetToResolution(selRes.selectionTarget, selRes.range, selRes.text);
		}
	}
	return buildSelectionResolutionFromCompiled(compiled, stepId);
}
function insertStructuredWrapper(editor, input, options) {
	const runtime = resolveWriteStoryRuntime(editor, input.in);
	try {
		const storyEditor = runtime.editor;
		let result;
		if (isStructuralInsertInput(input) && input.target) result = executeStructuralInsertDirect(storyEditor, input, options);
		else result = textReceiptToSDReceipt(insertStructuredInner(storyEditor, input, options));
		if (result.success !== false && runtime.commit) runtime.commit(editor);
		return result;
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function insertStructuredInner(editor, input, options) {
	if (isStructuralInsertInput(input)) return executeStructuralInsertWrapper(editor, input, options);
	const contentType = input.type ?? "text";
	const { value, ref } = input;
	const rawTarget = input.target;
	const placement = input.placement;
	if ((options?.changeMode ?? "direct") === "tracked") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `Tracked mode is not supported for type: '${contentType}' insert operations.`);
	let resolvedRange;
	let effectiveTarget;
	if (ref !== void 0 && ref === "") throw new DocumentApiAdapterError("INVALID_TARGET", "ref must be a non-empty string.", { ref });
	if (rawTarget && typeof rawTarget === "object" && "kind" in rawTarget && rawTarget.kind === "block") {
		const blockTarget = rawTarget;
		let resolved;
		try {
			resolved = resolveInsertTarget(editor, blockTarget);
		} catch (err) {
			if (err instanceof DocumentApiAdapterError) throw err;
			throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Cannot resolve insert target for block "${blockTarget.nodeId}".`);
		}
		let insertPos;
		if (resolved.targetNode && resolved.targetNodePos !== void 0) insertPos = resolvePlacement(editor.state.doc, resolved.targetNodePos, resolved.targetNode, placement);
		else insertPos = resolved.insertPos;
		resolvedRange = {
			from: insertPos,
			to: insertPos
		};
		effectiveTarget = {
			kind: "text",
			blockId: blockTarget.nodeId,
			range: {
				start: 0,
				end: 0
			}
		};
	} else if (rawTarget) {
		const target = rawTarget;
		const resolved = resolveSelectionTarget(editor, target);
		resolvedRange = {
			from: resolved.absFrom,
			to: resolved.absTo
		};
		const startPoint = target.start;
		const blockId = startPoint.kind === "text" ? startPoint.blockId : startPoint.node.nodeId;
		let offset;
		if (startPoint.kind === "text") offset = startPoint.offset;
		else if (startPoint.edge === "after") offset = nodeEdgeAfterOffset(editor, startPoint.node.nodeType, startPoint.node.nodeId);
		else offset = 0;
		effectiveTarget = {
			kind: "text",
			blockId,
			range: {
				start: offset,
				end: offset
			}
		};
	} else if (ref) {
		checkRevision(editor, options?.expectedRevision);
		const dummyStepId = v4_default();
		const compiled = compilePlan(editor, [{
			id: dummyStepId,
			op: "text.insert",
			where: {
				by: "ref",
				ref
			},
			args: {
				position: "before",
				content: { text: "" }
			}
		}], options?.dryRun ? { skipIdentityRepair: true } : void 0);
		const compiledTarget = compiled.mutationSteps.find((s) => s.step.id === dummyStepId)?.targets[0];
		if (!compiledTarget) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Structured insert ref could not be resolved.", { ref });
		if (compiledTarget.kind === "span") throw new DocumentApiAdapterError("INVALID_TARGET", "Insert operations require a single-block ref. Multi-segment refs are not supported.", { ref });
		resolvedRange = {
			from: compiledTarget.absFrom,
			to: compiledTarget.absFrom
		};
		const refTarget = buildSelectionResolutionFromCompiled(compiled, dummyStepId).target;
		effectiveTarget = {
			kind: "text",
			blockId: refTarget.blockId,
			range: {
				start: refTarget.range.start,
				end: refTarget.range.start
			}
		};
	} else {
		const fallback = resolveDefaultInsertTarget(editor);
		if (!fallback) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "No default insertion point available.");
		if (fallback.kind === "structural-end") {
			const pos = fallback.insertPos;
			resolvedRange = {
				from: pos,
				to: pos
			};
			effectiveTarget = {
				kind: "text",
				blockId: "",
				range: {
					start: 0,
					end: 0
				}
			};
		} else {
			resolvedRange = fallback.range;
			effectiveTarget = fallback.target;
		}
	}
	const resolution = buildTextMutationResolution({
		requestedTarget: effectiveTarget,
		target: effectiveTarget,
		range: resolvedRange,
		text: readTextAtResolvedRange(editor, resolvedRange)
	});
	const { from, to } = resolvedRange;
	if (rawTarget && from !== to) return {
		success: false,
		resolution,
		failure: {
			code: "INVALID_TARGET",
			message: "Insert operations require a collapsed target range."
		}
	};
	if (options?.dryRun) {
		if (contentType === "markdown") {
			const { fragment } = markdownToPmFragment(value, editor, { dryRun: true });
			if (fragment.childCount === 0) return {
				success: false,
				resolution,
				failure: {
					code: "NO_OP",
					message: "Markdown produced no content to insert."
				}
			};
		} else if (contentType === "html") {
			if (!value || typeof value !== "string" || value.trim().length === 0) return {
				success: false,
				resolution,
				failure: {
					code: "NO_OP",
					message: "HTML content is empty."
				}
			};
			if (!editorHasDom(editor)) return {
				success: false,
				resolution,
				failure: {
					code: "UNSUPPORTED_ENVIRONMENT",
					message: "HTML insert requires a DOM environment. Provide { document } in editor options."
				}
			};
		}
		return {
			success: true,
			resolution
		};
	}
	let insertFailure;
	const { success: commandSucceeded } = compoundMutation({
		editor,
		source: "doc.insert:structured",
		affectedParts: ["word/numbering.xml"],
		execute() {
			return executeDomainCommand(editor, () => {
				if (contentType === "markdown") {
					const { fragment } = markdownToPmFragment(value, editor);
					if (fragment.childCount === 0) {
						insertFailure = {
							code: "NO_OP",
							message: "Markdown produced no content to insert."
						};
						return false;
					}
					const jsonNodes = [];
					fragment.forEach((node) => jsonNodes.push(node.toJSON()));
					ensureMarkdownImageIds(jsonNodes);
					ensureTableSeparators(jsonNodes);
					if (from === to) {
						const $pos = editor.state.doc.resolve(from);
						const parent = $pos.parent;
						if (parent.isTextblock && !parent.childCount) {
							const grandparent = $pos.node($pos.depth - 1);
							const idx = $pos.index($pos.depth - 1);
							const prevIsTable = idx > 0 && grandparent.child(idx - 1).type.name === "table";
							const nextIsTable = idx + 1 < grandparent.childCount && grandparent.child(idx + 1).type.name === "table";
							const atEnd = idx + 1 >= grandparent.childCount;
							if (jsonNodes[0]?.type === "table" && prevIsTable) jsonNodes.unshift({ type: "paragraph" });
							if (jsonNodes[jsonNodes.length - 1]?.type === "table" && (nextIsTable || atEnd)) jsonNodes.push({ type: "paragraph" });
						}
					}
					const ok = insertContentAtWithRetry(editor, {
						from,
						to
					}, jsonNodes);
					if (!ok) insertFailure = {
						code: "INVALID_TARGET",
						message: "Structured content could not be inserted at the target position."
					};
					return ok;
				} else if (contentType === "html") {
					if (!editorHasDom(editor)) {
						insertFailure = {
							code: "UNSUPPORTED_ENVIRONMENT",
							message: "HTML insert requires a DOM environment. Provide { document } in editor options."
						};
						return false;
					}
					try {
						const ok = insertContentAtWithRetry(editor, {
							from,
							to
						}, value);
						if (!ok) insertFailure = {
							code: "INVALID_TARGET",
							message: "HTML content could not be inserted at the target position."
						};
						return ok;
					} catch (err) {
						insertFailure = {
							code: "UNSUPPORTED_ENVIRONMENT",
							message: `HTML structured insert requires a DOM environment. ${err instanceof Error ? err.message : String(err)}`
						};
						return false;
					}
				}
				return false;
			}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect === "changed";
		}
	});
	if (commandSucceeded) Promise.resolve().then(() => editor.migrateListsToV2?.()).catch(() => {});
	if (!commandSucceeded) return {
		success: false,
		resolution,
		failure: insertFailure ?? {
			code: "INVALID_TARGET",
			message: "Structured insert failed."
		}
	};
	return {
		success: true,
		resolution
	};
}
function executeStructuralInsertWrapper(editor, input, options) {
	const { content, target, placement, nestingPolicy } = input;
	const mode = options?.changeMode ?? "direct";
	let resolved;
	try {
		resolved = resolveInsertTarget(editor, target);
	} catch (err) {
		if (err instanceof DocumentApiAdapterError) throw err;
		throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Cannot resolve insert target${target ? ` for block "${target.nodeId}"` : ""}.`);
	}
	const effectiveTarget = resolved.effectiveTarget ?? {
		kind: "text",
		blockId: "",
		range: {
			start: 0,
			end: 0
		}
	};
	let insertPos;
	if (resolved.targetNode && resolved.targetNodePos !== void 0) insertPos = resolvePlacement(editor.state.doc, resolved.targetNodePos, resolved.targetNode, placement);
	else insertPos = resolved.insertPos;
	const resolution = buildTextMutationResolution({
		target: effectiveTarget,
		range: {
			from: insertPos,
			to: insertPos
		},
		text: ""
	});
	try {
		if (options?.dryRun) {
			executeStructuralInsert(editor, {
				target,
				content,
				placement,
				nestingPolicy,
				changeMode: mode,
				dryRun: true
			});
			return {
				success: true,
				resolution
			};
		}
		if (!(executeDomainCommand(editor, () => {
			return executeStructuralInsert(editor, {
				target,
				content,
				placement,
				nestingPolicy,
				changeMode: mode
			}).success;
		}, {
			expectedRevision: options?.expectedRevision,
			changeMode: mode
		}).steps[0]?.effect === "changed")) return {
			success: false,
			resolution,
			failure: {
				code: "INVALID_TARGET",
				message: "Structural insert failed."
			}
		};
		return {
			success: true,
			resolution
		};
	} catch (err) {
		if (err instanceof DocumentApiAdapterError) throw err;
		return {
			success: false,
			resolution,
			failure: {
				code: "INVALID_TARGET",
				message: `Structural insert failed: ${err instanceof Error ? err.message : String(err)}`
			}
		};
	}
}
function executeStructuralInsertDirect(editor, input, options) {
	const { content, target, placement, nestingPolicy } = input;
	const mode = options?.changeMode ?? "direct";
	let resolved;
	try {
		resolved = resolveInsertTarget(editor, target);
	} catch (err) {
		if (err instanceof DocumentApiAdapterError) throw err;
		throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Cannot resolve insert target for block "${target.nodeId}".`);
	}
	let insertPos;
	if (resolved.targetNode && resolved.targetNodePos !== void 0) insertPos = resolvePlacement(editor.state.doc, resolved.targetNodePos, resolved.targetNode, placement);
	else insertPos = resolved.insertPos;
	const receiptParams = {
		target,
		range: {
			from: insertPos,
			to: insertPos
		}
	};
	try {
		if (options?.dryRun) {
			executeStructuralInsert(editor, {
				target,
				content,
				placement,
				nestingPolicy,
				changeMode: mode,
				dryRun: true
			});
			return buildStructuralReceipt(true, receiptParams);
		}
		if (executeDomainCommand(editor, () => {
			return executeStructuralInsert(editor, {
				target,
				content,
				placement,
				nestingPolicy,
				changeMode: mode
			}).success;
		}, {
			expectedRevision: options?.expectedRevision,
			changeMode: mode
		}).steps[0]?.effect !== "changed") return buildStructuralReceipt(false, receiptParams, {
			code: "INVALID_TARGET",
			message: "Structural insert failed."
		});
		return buildStructuralReceipt(true, receiptParams);
	} catch (err) {
		if (err instanceof DocumentApiAdapterError) throw err;
		return buildStructuralReceipt(false, receiptParams, {
			code: "INVALID_TARGET",
			message: `Structural insert failed: ${err instanceof Error ? err.message : String(err)}`
		});
	}
}
function replaceStructuredWrapper(editor, input, options) {
	if (!isStructuralReplaceInput(input)) throw new DocumentApiAdapterError("INVALID_INPUT", "replaceStructured requires structural content input with a \"content\" field.");
	const runtime = resolveWriteStoryRuntime(editor, resolveMutationStory({
		in: input.in,
		target: input.target,
		ref: input.ref
	}));
	try {
		const storyEditor = runtime.editor;
		const blockTarget = input.target && "kind" in input.target && input.target.kind === "block" ? input.target : void 0;
		const textReceipt = executeStructuralReplaceWrapper(storyEditor, input, options);
		if (textReceipt.success && runtime.commit) runtime.commit(editor);
		if (!blockTarget) return textReceiptToSDReceipt(textReceipt);
		const sdReceipt = textReceiptToSDReceipt(textReceipt);
		if (sdReceipt.resolution) sdReceipt.resolution.target = blockTarget;
		return sdReceipt;
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function resolveStructuralLocator(editor, input) {
	const { target, ref } = input;
	if (target !== void 0) {
		if (target.kind === "selection") {
			const sel = target;
			const resolved = resolveSelectionTarget(editor, sel);
			const index = getBlockIndex(editor);
			const expanded = expandToBlockBoundaries(index, resolved.absFrom, resolved.absTo, {
				startHint: resolveSelectionBoundaryHint(index, sel.start),
				endHint: resolveSelectionBoundaryHint(index, sel.end)
			});
			return {
				textTarget: {
					kind: "text",
					blockId: expanded.firstBlock.nodeId,
					range: {
						start: 0,
						end: 0
					}
				},
				resolvedRange: {
					from: expanded.blockFrom,
					to: expanded.blockTo
				},
				effectiveSelectionTarget: buildEffectiveSelectionTarget(expanded)
			};
		}
		return { textTarget: target };
	}
	if (ref !== void 0) {
		if (ref.startsWith("text:")) {
			const decoded = decodeRef(ref);
			if (decoded && decoded.v === 4 && decoded.scope === "node" && decoded.node?.nodeId) return {
				textTarget: {
					kind: "text",
					blockId: decoded.node.nodeId,
					range: {
						start: 0,
						end: 0
					}
				},
				isRefBased: true
			};
			return {
				...resolveTextRefLocator(editor, ref),
				isRefBased: true
			};
		}
		return {
			textTarget: {
				kind: "text",
				blockId: ref,
				range: {
					start: 0,
					end: 0
				}
			},
			isRefBased: true
		};
	}
	throw new DocumentApiAdapterError("INVALID_TARGET", "Structural replace requires either target or ref.");
}
function resolveTextRefLocator(editor, ref) {
	const decoded = decodeRef(ref);
	if (!decoded) throw new DocumentApiAdapterError("INVALID_TARGET", `Cannot decode text ref for structural replace: ${ref}`);
	const segments = decoded.segments;
	if (!Array.isArray(segments) || segments.length === 0) throw new DocumentApiAdapterError("INVALID_TARGET", "Text ref does not contain valid segments for structural replace.");
	const firstBlockId = segments[0].blockId;
	if (typeof firstBlockId !== "string" || firstBlockId.length === 0) throw new DocumentApiAdapterError("INVALID_TARGET", "Text ref does not contain a valid blockId for structural replace.");
	const textTarget = {
		kind: "text",
		blockId: firstBlockId,
		range: {
			start: 0,
			end: 0
		}
	};
	if (segments.length === 1) return { textTarget };
	const index = getBlockIndex(editor);
	let rangeFrom = Infinity;
	let rangeTo = -Infinity;
	let firstCandidate;
	let lastCandidate;
	for (const seg of segments) {
		if (typeof seg.blockId !== "string") continue;
		try {
			const block = findBlockByNodeIdOnly(index, seg.blockId);
			if (block.pos < rangeFrom) {
				rangeFrom = block.pos;
				firstCandidate = block;
			}
			if (block.end > rangeTo) {
				rangeTo = block.end;
				lastCandidate = block;
			}
		} catch {
			throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Cannot resolve text ref segment block "${seg.blockId}".`);
		}
	}
	const effectiveSelectionTarget = firstCandidate && lastCandidate && firstCandidate.nodeId !== lastCandidate.nodeId ? {
		kind: "selection",
		start: buildSelectionPoint(firstCandidate, "start"),
		end: buildSelectionPoint(lastCandidate, "end")
	} : void 0;
	return {
		textTarget,
		resolvedRange: {
			from: rangeFrom,
			to: rangeTo
		},
		effectiveSelectionTarget
	};
}
var CONTAINER_NODE_TYPES = new Set([
	"table",
	"tableRow",
	"tableCell"
]);
function resolveSelectionBoundaryHint(index, point) {
	if (point.kind !== "nodeEdge") return void 0;
	const key$1 = `${point.node.nodeType}:${point.node.nodeId}`;
	if (index.ambiguous.has(key$1)) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple blocks share key "${key$1}".`, {
		nodeType: point.node.nodeType,
		nodeId: point.node.nodeId
	});
	const candidate = index.byId.get(key$1);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Node "${point.node.nodeType}" with id "${point.node.nodeId}" not found.`, {
		nodeType: point.node.nodeType,
		nodeId: point.node.nodeId
	});
	return candidate;
}
function expandToBlockBoundaries(index, absFrom, absTo, hints) {
	let blockFrom = hints?.startHint?.pos ?? absFrom;
	let blockTo = hints?.endHint?.end ?? absTo;
	let firstBlock = hints?.startHint;
	let lastBlock = hints?.endHint;
	const lockStart = firstBlock !== void 0;
	const lockEnd = lastBlock !== void 0;
	for (const candidate of index.candidates) {
		if (CONTAINER_NODE_TYPES.has(candidate.nodeType)) continue;
		if (candidate.end <= absFrom || candidate.pos >= absTo) continue;
		if (!lockStart && candidate.pos <= blockFrom) {
			blockFrom = candidate.pos;
			firstBlock = candidate;
		}
		if (!lockEnd && candidate.end >= blockTo) {
			blockTo = candidate.end;
			lastBlock = candidate;
		}
	}
	if (!firstBlock || !lastBlock) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Cannot resolve block boundaries for the target range.");
	return {
		blockFrom,
		blockTo,
		firstBlock,
		lastBlock
	};
}
var VALID_EDGE_NODE_TYPES = new Set([
	"paragraph",
	"heading",
	"table",
	"tableOfContents",
	"sdt",
	"image"
]);
function buildSelectionPoint(candidate, edge) {
	if (isTextBlockCandidate(candidate)) return {
		kind: "text",
		blockId: candidate.nodeId,
		offset: edge === "start" ? 0 : candidate.node.textContent.length
	};
	if (!VALID_EDGE_NODE_TYPES.has(candidate.nodeType)) throw new DocumentApiAdapterError("INVALID_TARGET", `Block type "${candidate.nodeType}" is not valid as a selection edge anchor.`);
	return {
		kind: "nodeEdge",
		node: {
			kind: "block",
			nodeType: candidate.nodeType,
			nodeId: candidate.nodeId
		},
		edge: edge === "start" ? "before" : "after"
	};
}
function buildEffectiveSelectionTarget(expanded) {
	if (expanded.firstBlock.nodeId === expanded.lastBlock.nodeId) return void 0;
	return {
		kind: "selection",
		start: buildSelectionPoint(expanded.firstBlock, "start"),
		end: buildSelectionPoint(expanded.lastBlock, "end")
	};
}
function executeStructuralReplaceWrapper(editor, input, options) {
	const { content, nestingPolicy } = input;
	const mode = options?.changeMode ?? "direct";
	const { textTarget, resolvedRange: locatorRange, effectiveSelectionTarget, isRefBased } = resolveStructuralLocator(editor, input);
	let effectiveRange;
	if (locatorRange) effectiveRange = locatorRange;
	else {
		let resolvedBlock;
		try {
			resolvedBlock = resolveReplaceTarget(editor, textTarget);
		} catch (err) {
			if (err instanceof DocumentApiAdapterError) throw err;
			throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Cannot resolve replace target for block "${targetBlockId(textTarget)}".`);
		}
		effectiveRange = {
			from: resolvedBlock.from,
			to: resolvedBlock.to
		};
	}
	const coveredText = editor.state.doc.textBetween(effectiveRange.from, effectiveRange.to, "\n", "￼");
	const textAddr = toTextAddress(textTarget);
	let resolution;
	if (effectiveSelectionTarget) resolution = selectionTargetToResolution(effectiveSelectionTarget, effectiveRange, coveredText);
	else resolution = buildTextMutationResolution({
		target: textAddr,
		range: effectiveRange,
		text: coveredText
	});
	checkRevision(editor, options?.expectedRevision);
	try {
		if (options?.dryRun) {
			executeStructuralReplace(editor, {
				target: textTarget,
				content,
				nestingPolicy,
				changeMode: mode,
				dryRun: true,
				resolvedRange: locatorRange
			});
			return {
				success: true,
				resolution
			};
		}
		if (!(executeDomainCommand(editor, () => {
			return executeStructuralReplace(editor, {
				target: textTarget,
				content,
				nestingPolicy,
				changeMode: mode,
				resolvedRange: locatorRange
			}).success;
		}, {
			expectedRevision: options?.expectedRevision,
			changeMode: mode
		}).steps[0]?.effect === "changed")) return {
			success: false,
			resolution,
			failure: {
				code: "INVALID_TARGET",
				message: "Structural replace failed."
			}
		};
		return {
			success: true,
			resolution
		};
	} catch (err) {
		if (err instanceof DocumentApiAdapterError) throw err;
		const message = err instanceof Error ? err.message : String(err);
		return {
			success: false,
			resolution,
			failure: {
				code: "INVALID_TARGET",
				message: `Structural replace failed: ${message}`
			}
		};
	}
}
function applyTocPatchTyped(...args) {
	try {
		return applyTocPatch(...args);
	} catch (err) {
		if (err instanceof Error && err.message.startsWith("INVALID_INPUT:")) throw new DocumentApiValidationError("INVALID_INPUT", err.message.slice(15));
		throw err;
	}
}
function tocListWrapper(editor, query) {
	const doc = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllTocNodes(doc).map((resolved) => buildTocDiscoveryItem(resolved, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function tocGetWrapper(editor, input) {
	return extractTocInfo(resolveTocTarget(editor.state.doc, input.target).node);
}
var NO_ENTRIES_PLACEHOLDER = [{
	type: "paragraph",
	attrs: { paragraphProperties: {} },
	content: [{
		type: "text",
		text: "No table of contents entries found."
	}]
}];
function buildTocAddress(nodeId) {
	return {
		kind: "block",
		nodeType: "tableOfContents",
		nodeId
	};
}
function tocSuccess(nodeId) {
	return {
		success: true,
		toc: buildTocAddress(nodeId)
	};
}
function tocFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function toTocEditorCommand(command) {
	return command;
}
function runTocAction(editor, action, expectedRevision) {
	return executeDomainCommand(editor, () => {
		const result = action();
		if (result) clearIndexCache(editor);
		return result;
	}, { expectedRevision });
}
function runTocCommand(editor, command, args, expectedRevision) {
	const executeCommand = toTocEditorCommand(command);
	return runTocAction(editor, () => executeCommand(args), expectedRevision);
}
function normalizeTocContent(content, editor) {
	if (!Array.isArray(content)) return null;
	return content.map((entry) => entry && typeof entry === "object" && typeof entry.type === "string" ? editor.state.schema.nodeFromJSON(entry) : entry);
}
function dispatchEditorTransaction(editor, tr) {
	if (typeof editor.dispatch === "function") {
		editor.dispatch(tr);
		return;
	}
	if (typeof editor.view?.dispatch === "function") {
		editor.view.dispatch(tr);
		return;
	}
	throw new Error("No transaction dispatcher available.");
}
function receiptApplied(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function isTocContentUnchanged(existingNode, newContent) {
	if (existingNode.childCount !== newContent.length) return false;
	const existingEntries = [];
	let canSerialize = true;
	existingNode.forEach((child) => {
		if (!canSerialize) return;
		if (typeof child.toJSON !== "function") {
			canSerialize = false;
			return;
		}
		const json = child.toJSON();
		if (json.attrs) delete json.attrs.sdBlockId;
		existingEntries.push(json);
	});
	if (!canSerialize) return false;
	const normalized = newContent.map((entry) => {
		const clone = JSON.parse(JSON.stringify(entry));
		if (clone.attrs) delete clone.attrs.sdBlockId;
		return clone;
	});
	return JSON.stringify(existingEntries) === JSON.stringify(normalized);
}
function withRightAlign(config, rightAlignPageNumbers) {
	if (rightAlignPageNumbers === void 0) return config;
	return {
		...config,
		display: {
			...config.display,
			rightAlignPageNumbers
		}
	};
}
function stripTocPageNumberFromNode(node) {
	if (!node || typeof node !== "object") return {
		node,
		changed: false
	};
	const typedNode = node;
	let changed = false;
	let next = typedNode;
	if (Array.isArray(typedNode.marks)) {
		const filtered = typedNode.marks.filter((mark) => mark?.type !== "tocPageNumber");
		if (filtered.length !== typedNode.marks.length) {
			changed = true;
			if (filtered.length === 0) {
				const { marks: _removed, ...rest } = next;
				next = rest;
			} else next = {
				...next,
				marks: filtered
			};
		}
	}
	if (Array.isArray(typedNode.content)) {
		let childChanged = false;
		const nextChildren = typedNode.content.map((child) => {
			const result = stripTocPageNumberFromNode(child);
			if (result.changed) childChanged = true;
			return result.node;
		});
		if (childChanged) {
			changed = true;
			next = {
				...next,
				content: nextChildren
			};
		}
	}
	return {
		node: next,
		changed
	};
}
function sanitizeTocContentForSchema(content, editor) {
	if (editor.state.schema?.marks?.tocPageNumber) return content;
	return content.map((paragraph) => {
		const paragraphContent = paragraph.content;
		if (!Array.isArray(paragraphContent)) return paragraph;
		let changed = false;
		const sanitizedContent = paragraphContent.map((node) => {
			const result = stripTocPageNumberFromNode(node);
			if (result.changed) changed = true;
			return result.node;
		});
		return changed ? {
			...paragraph,
			content: sanitizedContent
		} : paragraph;
	});
}
function materializeTocContent(doc, config, editor, options = {}) {
	const sources = collectTocSources(doc, config);
	const entryParagraphs = buildTocEntryParagraphs(sources, config, options);
	return {
		content: sanitizeTocContentForSchema(entryParagraphs.length > 0 ? entryParagraphs : NO_ENTRIES_PLACEHOLDER, editor),
		sources
	};
}
var TOC_ENTRY_STYLE_RE = /^TOC[1-9]$/;
function findFirstTocEntryParagraph(node) {
	let entry;
	node.forEach((paragraph) => {
		if (entry || paragraph.type.name !== "paragraph") return;
		const styleId = paragraph.attrs?.paragraphProperties?.styleId;
		if (styleId && TOC_ENTRY_STYLE_RE.test(styleId)) entry = paragraph;
	});
	return entry;
}
function readExistingTocTabPos(node) {
	const pos = (((findFirstTocEntryParagraph(node) ?? node.firstChild ?? void 0)?.attrs)?.paragraphProperties?.tabStops)?.find((t) => t?.tab?.tabType === "right")?.tab?.pos;
	return typeof pos === "number" ? pos : void 0;
}
function readExistingTocTrailingParagraph(node) {
	const last = node.lastChild;
	if (!last || last.type.name !== "paragraph") return void 0;
	const styleId = last.attrs?.paragraphProperties?.styleId;
	if (styleId && TOC_ENTRY_STYLE_RE.test(styleId)) return void 0;
	let hasPrecedingEntry = false;
	node.forEach((child) => {
		if (hasPrecedingEntry || child === last) return;
		if (child.type.name !== "paragraph") return;
		const childStyleId = child.attrs?.paragraphProperties?.styleId;
		if (childStyleId && TOC_ENTRY_STYLE_RE.test(childStyleId)) hasPrecedingEntry = true;
	});
	if (!hasPrecedingEntry) return void 0;
	return typeof last.toJSON === "function" ? last.toJSON() : void 0;
}
function tocConfigureWrapper(editor, input, options) {
	rejectTrackedMode("toc.configure", options);
	const resolved = resolveTocTarget(editor.state.doc, input.target);
	const currentConfig = parseTocInstruction(resolved.node.attrs?.instruction ?? "");
	const patched = applyTocPatchTyped(currentConfig, input.patch);
	const instruction = serializeTocInstruction(patched);
	const rightAlignChanged = input.patch.rightAlignPageNumbers !== void 0 && input.patch.rightAlignPageNumbers !== resolved.node.attrs?.rightAlignPageNumbers;
	const effectiveRightAlign = input.patch.rightAlignPageNumbers ?? resolved.node.attrs?.rightAlignPageNumbers;
	const { content: rebuiltEntries, sources } = materializeTocContent(editor.state.doc, withRightAlign(patched, effectiveRightAlign), editor, {
		pageMap: getPageMap(editor) ?? void 0,
		tabPos: readExistingTocTabPos(resolved.node)
	});
	const trailing = readExistingTocTrailingParagraph(resolved.node);
	const nextContent = trailing ? [...rebuiltEntries, trailing] : rebuiltEntries;
	if (areTocConfigsEqual(currentConfig, patched) && !rightAlignChanged) return tocFailure("NO_OP", "Configuration patch produced no change.");
	if (options?.dryRun) return tocSuccess(resolved.nodeId);
	const shouldRefreshContent = !isTocContentUnchanged(resolved.node, nextContent);
	const command = editor.commands?.setTableOfContentsInstructionById;
	const commandNodeId = resolved.commandNodeId ?? resolved.nodeId;
	if (!receiptApplied(typeof command === "function" ? runTocCommand(editor, command, {
		sdBlockId: commandNodeId,
		instruction,
		...shouldRefreshContent ? { content: nextContent } : {},
		...rightAlignChanged ? { rightAlignPageNumbers: input.patch.rightAlignPageNumbers } : {}
	}, options?.expectedRevision) : runTocAction(editor, () => {
		try {
			const { tr } = editor.state;
			tr.setNodeMarkup(resolved.pos, void 0, {
				...resolved.node.attrs,
				instruction,
				...rightAlignChanged ? { rightAlignPageNumbers: input.patch.rightAlignPageNumbers } : {}
			});
			if (shouldRefreshContent) {
				const from = resolved.pos + 1;
				const to = resolved.pos + resolved.node.nodeSize - 1;
				tr.replaceWith(from, to, normalizeTocContent(nextContent, editor) ?? []);
			}
			dispatchEditorTransaction(editor, tr);
			return true;
		} catch {
			return false;
		}
	}, options?.expectedRevision))) return tocFailure("NO_OP", "Configuration change could not be applied.");
	syncTocBookmarks(editor, sources);
	return tocSuccess(resolvePostMutationTocId(editor.state.doc, commandNodeId));
}
function tocUpdateWrapper(editor, input, options) {
	rejectTrackedMode("toc.update", options);
	if ((input.mode ?? "all") === "pageNumbers") return tocUpdatePageNumbers(editor, input, options);
	return tocUpdateAll(editor, input, options);
}
function tocUpdateAll(editor, input, options) {
	const resolved = resolveTocTarget(editor.state.doc, input.target);
	const config = parseTocInstruction(resolved.node.attrs?.instruction ?? "");
	const rightAlign = resolved.node.attrs?.rightAlignPageNumbers;
	const { content: rebuiltEntries, sources } = materializeTocContent(editor.state.doc, withRightAlign(config, rightAlign), editor, {
		pageMap: getPageMap(editor) ?? void 0,
		tabPos: readExistingTocTabPos(resolved.node)
	});
	const trailing = readExistingTocTrailingParagraph(resolved.node);
	const content = trailing ? [...rebuiltEntries, trailing] : rebuiltEntries;
	if (isTocContentUnchanged(resolved.node, content)) return tocFailure("NO_OP", "TOC update produced no change.");
	if (options?.dryRun) return tocSuccess(resolved.nodeId);
	const command = editor.commands?.replaceTableOfContentsContentById;
	if (!receiptApplied(typeof command === "function" ? runTocCommand(editor, command, {
		sdBlockId: resolved.commandNodeId ?? resolved.nodeId,
		content
	}, options?.expectedRevision) : runTocAction(editor, () => {
		try {
			const { tr } = editor.state;
			const from = resolved.pos + 1;
			const to = resolved.pos + resolved.node.nodeSize - 1;
			tr.replaceWith(from, to, normalizeTocContent(content, editor) ?? []);
			dispatchEditorTransaction(editor, tr);
			return true;
		} catch {
			return false;
		}
	}, options?.expectedRevision))) return tocFailure("NO_OP", "TOC update produced no change.");
	syncTocBookmarks(editor, sources);
	return tocSuccess(resolved.nodeId);
}
function getPageMap(editor) {
	const storage = editor.storage;
	if (!storage) return null;
	const tocStorage = storage.tableOfContents;
	if (!tocStorage?.pageMap) return null;
	if (tocStorage.pageMapDoc !== void 0 && tocStorage.pageMapDoc !== editor.state.doc) return null;
	return tocStorage.pageMap;
}
function tocUpdatePageNumbers(editor, input, options) {
	const resolved = resolveTocTarget(editor.state.doc, input.target);
	const config = parseTocInstruction(resolved.node.attrs?.instruction ?? "");
	if (deriveIncludePageNumbers(config.display.omitPageNumberLevels, config.source.outlineLevels) === false) return tocFailure("NO_OP", "TOC configuration excludes page numbers. Nothing to update.");
	const pageMap = getPageMap(editor);
	if (!pageMap) return tocFailure("CAPABILITY_UNAVAILABLE", "Page number resolution requires a completed layout. Trigger a render cycle and retry, or use mode \"all\".");
	const { updatedContent, hasPageNumberMarks, anyChanged } = buildPageNumberUpdatedContent(resolved.node, pageMap);
	if (!hasPageNumberMarks) return tocFailure("PAGE_NUMBERS_NOT_MATERIALIZED", "TOC entries do not contain tagged page number runs. Run toc.update with mode \"all\" first.");
	if (!anyChanged) return tocFailure("NO_OP", "Page numbers are already up to date.");
	if (options?.dryRun) return tocSuccess(resolved.nodeId);
	const command = editor.commands?.replaceTableOfContentsContentById;
	return receiptApplied(typeof command === "function" ? runTocCommand(editor, command, {
		sdBlockId: resolved.commandNodeId ?? resolved.nodeId,
		content: updatedContent
	}, options?.expectedRevision) : runTocAction(editor, () => {
		try {
			const { tr } = editor.state;
			const from = resolved.pos + 1;
			const to = resolved.pos + resolved.node.nodeSize - 1;
			tr.replaceWith(from, to, normalizeTocContent(updatedContent, editor) ?? []);
			dispatchEditorTransaction(editor, tr);
			return true;
		} catch {
			return false;
		}
	}, options?.expectedRevision)) ? tocSuccess(resolved.nodeId) : tocFailure("NO_OP", "Page number update produced no change.");
}
function buildPageNumberUpdatedContent(tocNode, pageMap) {
	const updatedContent = [];
	let hasPageNumberMarks = false;
	let anyChanged = false;
	tocNode.forEach((child) => {
		if (child.type.name !== "paragraph") {
			updatedContent.push(child.toJSON());
			return;
		}
		const tocSourceId = child.attrs?.tocSourceId;
		const childJson = child.toJSON();
		let paragraphChanged = false;
		const visit = (node) => {
			if (node.marks?.some((m) => m.type === "tocPageNumber")) {
				hasPageNumberMarks = true;
				if (!tocSourceId) return node;
				const pageNumber = pageMap.get(tocSourceId);
				const newText = pageNumber !== void 0 ? String(pageNumber) : "??";
				if (node.text !== newText) {
					paragraphChanged = true;
					return {
						...node,
						text: newText
					};
				}
				return node;
			}
			const nested = node.content;
			if (!Array.isArray(nested) || nested.length === 0) return node;
			const visited = nested.map(visit);
			return visited.some((next, idx) => next !== nested[idx]) ? {
				...node,
				content: visited
			} : node;
		};
		const updatedContentArray = (childJson.content ?? []).map(visit);
		if (paragraphChanged) {
			anyChanged = true;
			updatedContent.push({
				...childJson,
				content: updatedContentArray
			});
		} else updatedContent.push(childJson);
	});
	return {
		updatedContent,
		hasPageNumberMarks,
		anyChanged
	};
}
function tocRemoveWrapper(editor, input, options) {
	rejectTrackedMode("toc.remove", options);
	const resolved = resolveTocTarget(editor.state.doc, input.target);
	if (options?.dryRun) return tocSuccess(resolved.nodeId);
	const command = editor.commands?.deleteTableOfContentsById;
	return receiptApplied(typeof command === "function" ? runTocCommand(editor, command, { sdBlockId: resolved.commandNodeId ?? resolved.nodeId }, options?.expectedRevision) : runTocAction(editor, () => {
		try {
			const { tr } = editor.state;
			tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
			dispatchEditorTransaction(editor, tr);
			return true;
		} catch {
			return false;
		}
	}, options?.expectedRevision)) ? tocSuccess(resolved.nodeId) : tocFailure("NO_OP", "TOC removal produced no change.");
}
function prepareTableOfContentsInsertion(editor, input, options) {
	rejectTrackedMode("create.tableOfContents", options);
	const at = input.at ?? { kind: "documentEnd" };
	let pos;
	if (at.kind === "documentStart") pos = 0;
	else if (at.kind === "documentEnd") pos = editor.state.doc.content.size;
	else pos = resolveCreateAnchor(editor, at.target, at.kind).pos;
	const config = input.config ? applyTocPatchTyped(DEFAULT_TOC_CONFIG, input.config) : DEFAULT_TOC_CONFIG;
	const instruction = serializeTocInstruction(config);
	const { content, sources } = materializeTocContent(editor.state.doc, withRightAlign(config, input.config?.rightAlignPageNumbers), editor, { pageMap: getPageMap(editor) ?? void 0 });
	const sdBlockId = v4_default();
	return {
		pos,
		instruction,
		sdBlockId,
		content,
		sources,
		...input.config?.rightAlignPageNumbers !== void 0 ? { rightAlignPageNumbers: input.config.rightAlignPageNumbers } : {}
	};
}
function createTableOfContentsWrapper(editor, input, options) {
	const prepared = prepareTableOfContentsInsertion(editor, input, options);
	if (options?.dryRun) return {
		success: true,
		toc: buildTocAddress("(dry-run)")
	};
	const command = editor.commands?.insertTableOfContentsAt;
	if (!receiptApplied(typeof command === "function" ? runTocCommand(editor, command, {
		pos: prepared.pos,
		instruction: prepared.instruction,
		sdBlockId: prepared.sdBlockId,
		content: prepared.content,
		...prepared.rightAlignPageNumbers !== void 0 ? { rightAlignPageNumbers: prepared.rightAlignPageNumbers } : {}
	}, options?.expectedRevision) : runTocAction(editor, () => {
		const tocType = editor.state.schema.nodes.tableOfContents;
		const paragraphType = editor.state.schema.nodes.paragraph;
		if (!tocType || !paragraphType) return false;
		const defaultContent = [paragraphType.create({}, editor.state.schema.text("Update table of contents to populate entries."))];
		const materializedContent = normalizeTocContent(prepared.content, editor) ?? defaultContent;
		const tocNode = tocType.create({
			instruction: prepared.instruction,
			sdBlockId: prepared.sdBlockId,
			...prepared.rightAlignPageNumbers !== void 0 ? { rightAlignPageNumbers: prepared.rightAlignPageNumbers } : {}
		}, materializedContent);
		try {
			const { tr } = editor.state;
			tr.insert(prepared.pos, tocNode);
			dispatchEditorTransaction(editor, tr);
			return true;
		} catch (error) {
			if (error instanceof RangeError) return false;
			throw error;
		}
	}, options?.expectedRevision))) return {
		success: false,
		failure: {
			code: "INVALID_INSERTION_CONTEXT",
			message: "Table of contents could not be inserted at the requested location."
		}
	};
	syncTocBookmarks(editor, prepared.sources);
	return {
		success: true,
		toc: buildTocAddress(resolvePostMutationTocId(editor.state.doc, prepared.sdBlockId))
	};
}
var canInsertTableOfContentsAt = (insertPos, editor) => {
	const tocType = editor.schema?.nodes?.tableOfContents;
	const doc = editor.state?.doc;
	if (!tocType || typeof doc?.resolve !== "function") return true;
	try {
		const $pos = doc.resolve(insertPos);
		if (typeof $pos.parent?.canReplaceWith !== "function") return true;
		return $pos.parent.canReplaceWith($pos.index(), $pos.index(), tocType);
	} catch {
		return false;
	}
};
var canInsertTableOfContentsAfter = (candidate, editor) => {
	return canInsertTableOfContentsAt(candidate.end ?? candidate.pos + candidate.node.nodeSize, editor);
};
var canInsertTableOfContentsBefore = (candidate, editor) => canInsertTableOfContentsAt(candidate.pos, editor);
var collectTopLevelCandidates = (candidates, doc) => {
	const topLevelPositions = /* @__PURE__ */ new Set();
	let pos = 1;
	for (let i = 0; i < doc.childCount; i++) {
		topLevelPositions.add(pos);
		pos += doc.child(i).nodeSize;
	}
	return candidates.filter((candidate) => topLevelPositions.has(candidate.pos)).sort((a, b) => a.pos - b.pos);
};
var isSelectionAtDocumentStart = (editor, firstTopLevel) => {
	return editor.state.selection.from <= firstTopLevel.pos + 1;
};
function resolveTableOfContentsCreateLocation(editor) {
	const pos = editor.state.selection.from;
	const index = getBlockIndex(editor);
	const doc = editor.state?.doc;
	const firstTopLevel = doc && typeof doc.childCount === "number" && typeof doc.child === "function" ? collectTopLevelCandidates(index.candidates, doc)[0] : null;
	if (firstTopLevel && isSelectionAtDocumentStart(editor, firstTopLevel)) {
		if (canInsertTableOfContentsBefore(firstTopLevel, editor)) return {
			kind: "before",
			target: toBlockAddress(firstTopLevel)
		};
	}
	const containing = index.candidates.filter((c) => pos >= c.pos && pos < (c.end ?? c.pos + c.node.nodeSize));
	const anchor = containing.length > 0 ? [...containing].sort((a, b) => a.node.nodeSize - b.node.nodeSize).find((candidate) => canInsertTableOfContentsAfter(candidate, editor)) : null;
	return anchor ? {
		kind: "after",
		target: toBlockAddress(anchor)
	} : { kind: "documentEnd" };
}
function insertTableOfContentsAtSelection(editor) {
	let prepared;
	try {
		prepared = prepareTableOfContentsInsertion(editor, { at: resolveTableOfContentsCreateLocation(editor) });
	} catch {
		return false;
	}
	if (!editor.commands.insertTableOfContentsAt({
		pos: prepared.pos,
		instruction: prepared.instruction,
		sdBlockId: prepared.sdBlockId,
		content: prepared.content,
		...prepared.rightAlignPageNumbers !== void 0 ? { rightAlignPageNumbers: prepared.rightAlignPageNumbers } : {}
	})) return false;
	syncTocBookmarks(editor, prepared.sources);
	return true;
}
var FORMATTING_MARK_NAMES = new Set([
	"textStyle",
	"bold",
	"italic",
	"underline",
	"strike",
	"subscript",
	"superscript",
	"highlight"
]);
const getLinkedStyle = (styleId, styles = []) => {
	const linkedStyle = styles.find((style) => style.id === styleId);
	const basedOn = linkedStyle?.definition?.attrs?.basedOn;
	return {
		linkedStyle,
		basedOnStyle: styles.find((style) => style.id === basedOn)
	};
};
const getQuickFormatList = (editor) => {
	if (!editor?.converter?.linkedStyles) return [];
	return editor.converter.linkedStyles.filter((style) => style.type === "paragraph" && style.definition?.attrs).sort((a, b) => {
		const nameA = a.definition.attrs?.name ?? "";
		const nameB = b.definition.attrs?.name ?? "";
		return nameA.localeCompare(nameB);
	});
};
const generateLinkedStyleString = (linkedStyle, basedOnStyle, node, parent, _includeSpacing = true) => {
	if (!linkedStyle?.definition?.styles) return "";
	const markValue = {};
	const linkedDefinitionStyles = { ...linkedStyle.definition.styles };
	const basedOnDefinitionStyles = { ...basedOnStyle?.definition?.styles };
	const resultStyles = { ...linkedDefinitionStyles };
	[
		"font-size",
		"font-family",
		"text-transform",
		"bold",
		"italic",
		"underline",
		"strike",
		"color",
		"highlight"
	].forEach((k) => {
		if (!linkedDefinitionStyles[k] && basedOnDefinitionStyles[k]) resultStyles[k] = basedOnDefinitionStyles[k];
	});
	Object.entries(resultStyles).forEach(([k, value]) => {
		const key$1 = kebabCase(k);
		const flattenedMarks = [];
		node?.marks?.forEach((n) => {
			if (n.type.name === "textStyle") {
				Object.entries(n.attrs).forEach(([styleKey, value$1]) => {
					const parsedKey = kebabCase(styleKey);
					if (!value$1) return;
					flattenedMarks.push({
						key: parsedKey,
						value: value$1
					});
				});
				return;
			}
			flattenedMarks.push({
				key: n.type.name,
				value: n.attrs[key$1]
			});
		});
		if (node?.marks?.some((m) => m.type?.name === "underline" && m.attrs?.underlineType === "none")) markValue["text-decoration"] = "none";
		if (!flattenedMarks.find((n) => n.key === key$1)) {
			if (key$1 === "bold" && node) {
				const boldValue = typeof value === "object" && value !== null ? value.value : value;
				const hasInlineBoldOff = node.marks?.some((m) => m.type?.name === "bold" && m.attrs?.value === "0");
				const hasInlineBoldOn = node.marks?.some((m) => m.type?.name === "bold" && m.attrs?.value !== "0");
				if (!hasInlineBoldOff && !hasInlineBoldOn && boldValue !== "0" && boldValue !== false) markValue["font-weight"] = "bold";
			} else if (key$1 === "italic" && node) {
				const italicValue = typeof value === "object" && value !== null ? value.value : value;
				const hasInlineItalicOff = node.marks?.some((m) => m.type?.name === "italic" && m.attrs?.value === "0");
				const hasInlineItalicOn = node.marks?.some((m) => m.type?.name === "italic" && m.attrs?.value !== "0");
				if (!hasInlineItalicOff && !hasInlineItalicOn && italicValue !== "0" && italicValue !== false) markValue["font-style"] = "italic";
			} else if (key$1 === "strike" && node) {
				const strikeValue = typeof value === "object" && value !== null ? value.value : value;
				const hasInlineStrikeOff = node.marks?.some((m) => m.type?.name === "strike" && m.attrs?.value === "0");
				const hasInlineStrikeOn = node.marks?.some((m) => m.type?.name === "strike" && (m.attrs?.value === void 0 || m.attrs?.value !== "0"));
				if (!hasInlineStrikeOff && !hasInlineStrikeOn && strikeValue !== "0" && strikeValue !== false) markValue["text-decoration"] = "line-through";
			} else if (key$1 === "text-transform" && node) markValue[key$1] = value;
			else if (key$1 === "font-size" && node) markValue[key$1] = value;
			else if (key$1 === "font-family" && node) markValue[key$1] = value;
			else if (key$1 === "color" && node) markValue[key$1] = value;
			else if (key$1 === "highlight" && node) {
				if (!node.marks?.some((m) => m.type?.name === "highlight")) {
					const color = typeof value === "string" ? value : value?.color;
					if (color) markValue["background-color"] = color;
				}
			} else if (key$1 === "underline" && node) {
				const styleVal = (value?.underline ?? value?.underlineType ?? value?.value ?? (typeof value === "string" ? value : "")).toString().toLowerCase();
				const hasInlineUnderlineOff = node.marks?.some((m) => m.type?.name === "underline" && m.attrs?.underlineType === "none");
				const hasInlineUnderlineOn = node.marks?.some((m) => m.type?.name === "underline" && m.attrs?.underlineType && m.attrs.underlineType !== "none");
				if (!hasInlineUnderlineOff && !hasInlineUnderlineOn) {
					if (styleVal && styleVal !== "none" && styleVal !== "0") getUnderlineCssString({
						type: styleVal,
						color: value && typeof value === "object" ? value.color || value.underlineColor || null : null
					}).split(";").forEach((decl) => {
						const d = decl.trim();
						if (!d) return;
						const idx = d.indexOf(":");
						if (idx === -1) return;
						const k$1 = d.slice(0, idx).trim();
						markValue[k$1] = d.slice(idx + 1).trim();
					});
				}
			} else if (typeof value === "string") markValue[key$1] = value;
		}
	});
	return Object.entries(markValue).map(([key$1, value]) => `${key$1}: ${value}`).join(";");
};
var getParagraphTextBounds = (doc, paragraphPos, paragraphNode) => {
	let minPos = null;
	let maxPos = null;
	const innerStart = paragraphPos + 1;
	const innerEnd = paragraphPos + paragraphNode.nodeSize - 1;
	doc.nodesBetween(innerStart, innerEnd, (node, pos) => {
		if (node.isText) {
			if (minPos === null || pos < minPos) minPos = pos;
			maxPos = pos + node.nodeSize;
		}
		return true;
	});
	if (minPos === null || maxPos === null) return null;
	return {
		from: minPos,
		to: maxPos
	};
};
var applyCharacterStyleMarkToRange = (tr, textStyleType, from, to, styleId) => {
	tr.removeMark(from, to, textStyleType);
	tr.addMark(from, to, textStyleType.create({ styleId }));
};
const applyLinkedStyleToTransaction = (tr, editor, style) => {
	if (!style) return false;
	let selection = tr.selection;
	const state = editor.state;
	const textStyleType = editor.schema.marks.textStyle;
	const focusState = CustomSelectionPluginKey.getState(state);
	if (selection.empty && focusState?.preservedSelection && !focusState?.preservedSelection.empty) {
		selection = focusState.preservedSelection;
		tr.setSelection(selection);
	} else if (selection.empty && editor.options.lastSelection) {
		selection = editor.options.lastSelection;
		tr.setSelection(selection);
	}
	const { from, to } = selection;
	const getUpdatedParagraphAttrs = (node) => {
		return {
			...node.attrs,
			paragraphProperties: {
				...node.attrs.paragraphProperties || {},
				styleId: style.id
			}
		};
	};
	const clearFormattingMarks = (rangeFrom, rangeTo) => {
		tr.doc.nodesBetween(rangeFrom, rangeTo, (node, pos) => {
			if (!node.isText || node.marks.length === 0) return true;
			const nodeEnd = pos + node.nodeSize;
			const clearFrom = Math.max(pos, rangeFrom);
			const clearTo = Math.min(nodeEnd, rangeTo);
			if (clearFrom >= clearTo) return true;
			node.marks.forEach((mark) => {
				if (FORMATTING_MARK_NAMES.has(mark.type.name)) tr.removeMark(clearFrom, clearTo, mark);
			});
			return true;
		});
	};
	const clearStoredFormattingMarks = () => {
		const sourceMarks = tr.storedMarks ?? state.storedMarks ?? (selection.empty ? selection.$from.marks() : []);
		if (!sourceMarks?.length) return;
		const nextStoredMarks = sourceMarks.filter((mark) => !FORMATTING_MARK_NAMES.has(mark.type.name));
		if (nextStoredMarks.length !== sourceMarks.length) tr.setStoredMarks(nextStoredMarks);
	};
	if (style.type === "character") {
		if (!textStyleType) return false;
		if (from === to) {
			const filtered = (tr.storedMarks ?? state.storedMarks ?? selection.$from.marks()).filter((mark) => mark.type !== textStyleType);
			tr.setStoredMarks([...filtered, textStyleType.create({ styleId: style.id })]);
			return true;
		}
		clearFormattingMarks(from, to);
		applyCharacterStyleMarkToRange(tr, textStyleType, from, to, style.id);
		clearStoredFormattingMarks();
		return true;
	}
	if (from === to) {
		let pos = from;
		let paragraphNode = tr.doc.nodeAt(from);
		if (paragraphNode?.type.name !== "paragraph") {
			const parentNode = findParentNode((node) => node.type.name === "paragraph")(selection);
			if (!parentNode) return false;
			pos = parentNode.pos;
			paragraphNode = parentNode.node;
		}
		clearFormattingMarks(pos + 1, pos + paragraphNode.nodeSize - 1);
		clearStoredFormattingMarks();
		tr.setNodeMarkup(pos, void 0, getUpdatedParagraphAttrs(paragraphNode));
		return true;
	}
	if (style.type === "paragraph" && textStyleType) {
		const linkedCharStyleId = style.definition?.attrs?.link;
		if (linkedCharStyleId) {
			const $fromPos = tr.doc.resolve(from);
			const $toPos = tr.doc.resolve(to);
			const startPara = findParentNodeClosestToPos($fromPos, (n) => n.type.name === "paragraph");
			const endPara = findParentNodeClosestToPos($toPos, (n) => n.type.name === "paragraph");
			if (startPara && endPara && startPara.pos === endPara.pos) {
				const bounds = getParagraphTextBounds(tr.doc, startPara.pos, startPara.node);
				const coversFullParagraphText = bounds && from <= bounds.from && to >= bounds.to;
				if (bounds && !coversFullParagraphText) {
					clearFormattingMarks(from, to);
					applyCharacterStyleMarkToRange(tr, textStyleType, from, to, linkedCharStyleId);
					clearStoredFormattingMarks();
					return true;
				}
			}
		}
	}
	const paragraphPositions = [];
	tr.doc.nodesBetween(from, to, (node, pos) => {
		if (node.type.name === "paragraph") paragraphPositions.push({
			node,
			pos
		});
		return true;
	});
	if (paragraphPositions.length === 0 && from !== to) {
		const seen = /* @__PURE__ */ new Set();
		const pushParagraph = (info) => {
			if (!info || seen.has(info.pos)) return;
			seen.add(info.pos);
			paragraphPositions.push({
				node: info.node,
				pos: info.pos
			});
		};
		pushParagraph(findParentNodeClosestToPos(tr.doc.resolve(from), (n) => n.type.name === "paragraph"));
		pushParagraph(findParentNodeClosestToPos(tr.doc.resolve(to), (n) => n.type.name === "paragraph"));
	}
	paragraphPositions.forEach(({ node, pos }) => {
		clearFormattingMarks(pos + 1, pos + node.nodeSize - 1);
		tr.setNodeMarkup(pos, void 0, getUpdatedParagraphAttrs(node));
	});
	clearStoredFormattingMarks();
	return true;
};
const stepInsertsTextIntoStyledParagraph = (tr, oldEditorState, step, stepIndex) => {
	if (!step.slice || step.slice.size === 0 || typeof step.from !== "number") return false;
	let insertsText = false;
	step.slice.content.descendants((node) => {
		if (node.type?.name === "text" && node.text?.length) {
			insertsText = true;
			return false;
		}
		return true;
	});
	if (!insertsText) return false;
	const docBeforeStep = tr.docs?.[stepIndex] || oldEditorState.doc;
	if (!docBeforeStep) return false;
	const resolvedPos = Math.min(step.from, docBeforeStep.content.size);
	const $pos = docBeforeStep.resolve(resolvedPos);
	for (let depth = $pos.depth; depth >= 0; depth--) {
		const node = $pos.node(depth);
		if (node?.type?.name === "paragraph") return Boolean(node.attrs?.paragraphProperties?.styleId);
	}
	return false;
};
const LinkedStylesPluginKey = new PluginKey("linkedStyles");
const createLinkedStylesPlugin = (editor) => {
	return new Plugin({
		key: LinkedStylesPluginKey,
		state: {
			init() {
				if (!editor.converter || editor.options.mode !== "docx") return {};
				if (editor.presentationEditor) return {
					styles: editor.converter?.linkedStyles || [],
					decorations: DecorationSet.empty
				};
				const styles = editor.converter?.linkedStyles || [];
				return {
					styles,
					decorations: generateDecorations(editor.state, styles)
				};
			},
			apply(tr, prev, oldEditorState, newEditorState) {
				if (!editor.converter || editor.options.mode !== "docx") return { ...prev };
				if (editor.presentationEditor) return {
					...prev,
					decorations: DecorationSet.empty
				};
				let decorations = prev.decorations || DecorationSet.empty;
				if (tr.docChanged) {
					let mightAffectStyles = false;
					const styleRelatedMarks = new Set([
						"textStyle",
						"bold",
						"italic",
						"underline",
						"strike"
					]);
					tr.steps.forEach((step, index) => {
						if (step.slice) step.slice.content.descendants((node, pos) => {
							if (node.type.name === "paragraph") {
								if (calculateResolvedParagraphProperties(editor, node, newEditorState.doc.resolve(pos)).styleId) mightAffectStyles = true;
								return false;
							}
							if (node.marks.length > 0) {
								if (node.marks.some((mark) => styleRelatedMarks.has(mark.type.name))) {
									mightAffectStyles = true;
									return false;
								}
							}
						});
						if (step.jsonID === "addMark" || step.jsonID === "removeMark") {
							if (step.mark && styleRelatedMarks.has(step.mark.type.name)) mightAffectStyles = true;
						}
						if (!mightAffectStyles && stepInsertsTextIntoStyledParagraph(tr, oldEditorState, step, index)) mightAffectStyles = true;
					});
					if (mightAffectStyles) {
						const styles = LinkedStylesPluginKey.getState(editor.state).styles;
						decorations = generateDecorations(newEditorState, styles);
					} else decorations = decorations.map(tr.mapping, tr.doc);
				}
				return {
					...prev,
					decorations
				};
			}
		},
		props: { decorations(state) {
			return LinkedStylesPluginKey.getState(state)?.decorations;
		} }
	});
};
var generateDecorations = (state, styles) => {
	const decorations = [];
	const doc = state?.doc;
	if (!doc || !state) return DecorationSet.empty;
	const getParagraphStyleId = (pos) => {
		const $pos = state.doc.resolve(pos);
		for (let d = $pos.depth; d >= 0; d--) {
			const n = $pos.node(d);
			if (n?.type?.name === "paragraph") return getResolvedParagraphProperties(n).styleId || null;
		}
		return null;
	};
	doc.descendants((node, pos) => {
		const { name } = node.type;
		if (name !== "text") return;
		const paragraphStyleId = getParagraphStyleId(pos);
		let runStyleId = null;
		let inlineTextStyleId = null;
		for (const mark of node.marks) if (mark.type.name === "run") {
			const rp = mark.attrs?.runProperties;
			if (rp && typeof rp === "object" && !Array.isArray(rp) && rp.styleId) runStyleId = rp.styleId;
			else if (Array.isArray(rp)) {
				const sid = rp.find((e) => e?.xmlName === "w:rStyle")?.attributes?.["w:val"];
				if (sid) runStyleId = sid;
			}
		} else if (mark.type.name === "textStyle" && mark.attrs?.styleId) inlineTextStyleId = mark.attrs.styleId;
		const buildStyleMap = (sid) => {
			if (!sid) return {};
			const { linkedStyle, basedOnStyle: basedOnStyle$1 } = getLinkedStyle(sid, styles);
			if (!linkedStyle) return {};
			return {
				...basedOnStyle$1?.definition?.styles || {},
				...linkedStyle.definition?.styles || {}
			};
		};
		const pMap = buildStyleMap(paragraphStyleId);
		let tMap;
		if (paragraphStyleId?.startsWith("TOC")) tMap = {};
		else tMap = buildStyleMap(inlineTextStyleId);
		const rMap = buildStyleMap(runStyleId);
		const finalStyles = {
			...pMap,
			...tMap,
			...rMap
		};
		if (Object.keys(finalStyles).length === 0) return;
		const mergedLinkedStyle = { definition: {
			styles: finalStyles,
			attrs: {}
		} };
		const basedOnStyle = null;
		const parent = state.doc.resolve(pos).parent;
		const styleString = generateLinkedStyleString(mergedLinkedStyle, basedOnStyle, node, parent);
		if (!styleString) return;
		const decoration = Decoration.inline(pos, pos + node.nodeSize, { style: styleString });
		decorations.push(decoration);
	});
	return DecorationSet.create(doc, decorations);
};
const LinkedStyles = Extension.create({
	name: "linkedStyles",
	priority: 1,
	addOptions() {
		return {};
	},
	addPmPlugins() {
		return [createLinkedStylesPlugin(this.editor)];
	},
	addCommands() {
		return {
			setLinkedStyle: (style) => (params) => {
				const { tr } = params;
				return applyLinkedStyleToTransaction(tr, this.editor, style);
			},
			toggleLinkedStyle: (style) => (params) => {
				const { tr } = params;
				let node = tr.doc.nodeAt(tr.selection.$from.pos);
				if (!node || node.type.name !== "paragraph") node = findParentNodeClosestToPos(tr.selection.$from, (n) => {
					return n.type.name === "paragraph";
				})?.node;
				if (!node) return false;
				if (getResolvedParagraphProperties(node).styleId === style.id) return applyLinkedStyleToTransaction(tr, this.editor, { id: null });
				return applyLinkedStyleToTransaction(tr, this.editor, style);
			},
			setStyleById: (styleId) => (params) => {
				const { state, tr } = params;
				const pluginState = LinkedStylesPluginKey.getState(state);
				if (!pluginState) return false;
				const style = pluginState.styles?.find((s) => s.id === styleId);
				if (!style) return false;
				return applyLinkedStyleToTransaction(tr, this.editor, style);
			}
		};
	},
	addHelpers() {
		return {
			getStyles: () => {
				return LinkedStylesPluginKey.getState(this.editor.state)?.styles || [];
			},
			getStyleById: (styleId) => {
				return this.editor.helpers[this.name].getStyles().find((s) => s.id === styleId);
			},
			getLinkedStyleString: (styleId) => {
				const style = this.editor.helpers.linkedStyles.getStyles().find((s) => s.id === styleId);
				if (!style) return "";
				return generateLinkedStyleString(style);
			}
		};
	}
});
const normalizeEmail = (value) => {
	return normalizeActorEmail(value);
};
const normalizeName = (value) => {
	return normalizeActorName(value);
};
var normalizeImportedAuthorName = (value) => {
	const normalized = normalizeName(value).replace(/\s+\(imported\)$/, "");
	return normalized === "undefined" || normalized === "null" ? "" : normalized;
};
const getCurrentUserIdentity = (editor) => {
	const user = editor?.options?.user ?? null;
	const id = normalizeActorId(user?.id);
	const email = normalizeEmail(user?.email);
	return {
		id,
		email,
		name: typeof user?.name === "string" ? user.name : "",
		hasId: id.length > 0,
		hasEmail: email.length > 0
	};
};
const getChangeAuthorIdentity = (changeOrAttrs) => {
	if (!changeOrAttrs) return {
		id: "",
		email: "",
		name: "",
		hasId: false,
		hasEmail: false
	};
	const attrs = changeOrAttrs.attrs ?? changeOrAttrs.mark?.attrs ?? changeOrAttrs;
	const id = normalizeActorId(attrs?.authorId);
	const email = normalizeEmail(attrs?.authorEmail);
	const name = typeof attrs?.author === "string" ? attrs.author : "";
	const importedAuthor = typeof attrs?.importedAuthor === "string" ? attrs.importedAuthor : "";
	const identity = {
		id,
		email,
		name,
		hasId: id.length > 0,
		hasEmail: email.length > 0
	};
	if (importedAuthor) identity.importedAuthor = importedAuthor;
	return identity;
};
var hasImportedAuthorConflict = ({ currentUser, change }) => {
	const importedAuthorName = normalizeImportedAuthorName(change?.importedAuthor);
	const currentName = normalizeName(currentUser?.name);
	const changeName = normalizeName(change?.name);
	if (!importedAuthorName || !currentName || !changeName) return false;
	if (importedAuthorName === currentName) return false;
	if (changeName === currentName) return false;
	return true;
};
var hasImportedInsertionProvenance = (attrs) => {
	const sourceId = attrs?.sourceId;
	if (sourceId !== void 0 && sourceId !== null && String(sourceId).trim()) return true;
	if (normalizeImportedAuthorName(attrs?.importedAuthor)) return true;
	const sourceIds = attrs?.sourceIds;
	if (typeof sourceIds === "string") {
		const trimmed = sourceIds.trim();
		return Boolean(trimmed && trimmed !== "{}" && trimmed !== "null");
	}
	if (sourceIds && typeof sourceIds === "object" && !Array.isArray(sourceIds)) return Object.keys(sourceIds).length > 0;
	return false;
};
const classifyOwnership = ({ currentUser, change }) => {
	const cur = currentUser ?? {
		id: "",
		email: "",
		name: "",
		hasId: false,
		hasEmail: false
	};
	const auth = change ?? {
		id: "",
		email: "",
		name: "",
		hasId: false,
		hasEmail: false
	};
	if (hasImportedAuthorConflict({
		currentUser: cur,
		change: auth
	})) return "conflicting";
	if (cur.hasId && auth.hasId) return cur.id === auth.id ? "same-user" : "different-user";
	if (!cur.hasEmail) return "unknown-current-user";
	if (!auth.hasEmail) return "unknown-change-author";
	if (cur.email === auth.email) return "same-user";
	return "different-user";
};
const isSameUserHighConfidence = (classification) => classification === "same-user";
const matchesSameUserRefinement = ({ currentUser, change }) => {
	const cur = currentUser ?? {
		id: "",
		email: "",
		name: "",
		hasId: false,
		hasEmail: false
	};
	const auth = change ?? {
		id: "",
		email: "",
		name: "",
		hasId: false,
		hasEmail: false
	};
	if (isSameUserHighConfidence(classifyOwnership({
		currentUser: cur,
		change: auth
	}))) return true;
	if (!cur.hasId && !auth.hasId && !cur.hasEmail && !auth.hasEmail) {
		const changeName = normalizeName(auth.name) || normalizeImportedAuthorName(auth.importedAuthor);
		if (!changeName) return true;
		const currentName = normalizeName(cur.name);
		return Boolean(currentName && currentName === changeName);
	}
	return false;
};
const shouldCollapseNoEmailInsertion = ({ currentUser, insertionAttrs }) => {
	const authorId = normalizeActorId(insertionAttrs?.authorId);
	const currentId = normalizeActorId(currentUser?.id);
	if (authorId || currentId) return Boolean(authorId && currentId && authorId === currentId);
	if (normalizeEmail(insertionAttrs?.authorEmail)) return false;
	if (!hasImportedInsertionProvenance(insertionAttrs)) return false;
	const authorName = normalizeName(insertionAttrs?.author) || normalizeImportedAuthorName(insertionAttrs?.importedAuthor);
	if (!authorName) return true;
	const currentName = normalizeName(currentUser?.name);
	return Boolean(currentName && currentName === authorName);
};
var PERMISSION_MAP = {
	accept: {
		own: "RESOLVE_OWN",
		other: "RESOLVE_OTHER"
	},
	reject: {
		own: "REJECT_OWN",
		other: "REJECT_OTHER"
	}
};
var buildKey = (change) => {
	return `${change.mark?.attrs?.id ?? `${change.from}-${change.to}`}:${change.mark?.type?.name ?? "unknown"}`;
};
var mergeChange = (bucket, change) => {
	const key$1 = buildKey(change);
	const existing = bucket.get(key$1);
	if (existing) {
		existing.from = Math.min(existing.from, change.from);
		existing.to = Math.max(existing.to, change.to);
		existing.segments.push({
			from: change.from,
			to: change.to
		});
	} else bucket.set(key$1, {
		id: change.mark?.attrs?.id ?? null,
		type: change.mark?.type?.name ?? null,
		attrs: { ...change.mark?.attrs ?? {} },
		from: change.from,
		to: change.to,
		segments: [{
			from: change.from,
			to: change.to
		}]
	});
};
const collectTrackedChanges = ({ state, from, to }) => {
	if (!state) return [];
	const collapsed = from === to;
	const changes = getTrackChanges(state);
	if (!changes?.length) return [];
	const bucket = /* @__PURE__ */ new Map();
	changes.forEach((change) => {
		if (!(collapsed ? change.from <= from && change.to >= from : change.from < to && change.to > from)) return;
		mergeChange(bucket, change);
	});
	return Array.from(bucket.values());
};
var derivePermissionKey = ({ action, isOwn }) => {
	const mapping = PERMISSION_MAP[action];
	if (!mapping) return null;
	return isOwn ? mapping.own : mapping.other;
};
var resolveChanges = (editor) => {
	if (!editor) return {
		role: "editor",
		isInternal: false,
		currentUser: null,
		resolver: null
	};
	return {
		role: editor.options?.role ?? "editor",
		isInternal: Boolean(editor.options?.isInternal),
		currentUser: editor.options?.user ?? null,
		resolver: editor.options?.permissionResolver
	};
};
const isTrackedChangeActionAllowed = ({ editor, action, trackedChanges }) => {
	if (!trackedChanges?.length) return true;
	const { role, isInternal, resolver } = resolveChanges(editor);
	if (typeof resolver !== "function") return true;
	const currentIdentity = getCurrentUserIdentity(editor);
	return trackedChanges.every((change) => {
		const permission = derivePermissionKey({
			action,
			isOwn: isSameUserHighConfidence(classifyOwnership({
				currentUser: currentIdentity,
				change: getChangeAuthorIdentity(change.attrs ?? change)
			}))
		});
		if (!permission) return true;
		return resolver({
			permission,
			role,
			isInternal,
			trackedChange: {
				id: change.id,
				type: change.type,
				attrs: change.attrs,
				from: change.from,
				to: change.to,
				segments: change.segments,
				commentId: change.id
			},
			comment: change.comment ?? null
		}) !== false;
	});
};
const collectTrackedChangesForContext = ({ state, pos, trackedChangeId }) => {
	if (pos == null) return [];
	const changes = collectTrackedChanges({
		state,
		from: pos,
		to: pos
	});
	if (!trackedChangeId) return changes;
	return changes.filter((change) => change.id === trackedChangeId);
};
var resolveSurfaceFromDocumentId = (documentId) => {
	if (typeof documentId !== "string" || documentId.length === 0) return "body";
	if (documentId.startsWith("footnote:") || documentId.startsWith("fn:")) return "note";
	if (documentId.startsWith("endnote:") || documentId.startsWith("en:")) return "endnote";
	return "body";
};
var resolveSurface = (activeEditor) => {
	if (activeEditor?.options?.isHeaderOrFooter) {
		const headerFooterType = activeEditor.options?.headerFooterType;
		if (headerFooterType === "footer") return "footer";
		if (headerFooterType === "header") return "header";
	}
	return resolveSurfaceFromDocumentId(activeEditor?.options?.documentId);
};
var resolveSelectionEmpty = (editor) => {
	return (editor.state?.selection)?.empty ?? true;
};
var createEditorToolbarTarget = (editor) => {
	return {
		commands: editor.commands ?? {},
		doc: editor.doc
	};
};
var createPresentationToolbarTarget = (editor) => {
	return {
		commands: editor.commands ?? {},
		doc: editor.getActiveEditor()?.doc
	};
};
var resolvePresentationEditor = (superdoc) => {
	const activeEditor = superdoc.activeEditor ?? null;
	const directPresentationEditor = activeEditor?.presentationEditor ?? activeEditor?._presentationEditor ?? null;
	if (directPresentationEditor) return directPresentationEditor;
	const documentId = activeEditor?.options?.documentId;
	if (!documentId) return null;
	if (typeof superdoc.getPresentationEditorForDocument === "function") return superdoc.getPresentationEditorForDocument(documentId);
	return (superdoc.superdocStore?.documents ?? []).find((doc) => doc.getEditor?.()?.options?.documentId === documentId)?.getPresentationEditor?.() ?? null;
};
const resolveToolbarSources = (superdoc) => {
	const presentationEditor = resolvePresentationEditor(superdoc);
	if (presentationEditor) {
		const routedEditor = presentationEditor.getActiveEditor();
		return {
			activeEditor: routedEditor ?? null,
			presentationEditor,
			context: {
				target: createPresentationToolbarTarget(presentationEditor),
				surface: resolveSurface(routedEditor),
				isEditable: presentationEditor.isEditable,
				selectionEmpty: resolveSelectionEmpty(presentationEditor),
				editor: routedEditor ?? void 0,
				presentationEditor
			}
		};
	}
	const activeEditor = superdoc.activeEditor;
	if (!activeEditor) return {
		activeEditor: null,
		presentationEditor: null,
		context: null
	};
	return {
		activeEditor,
		presentationEditor: null,
		context: {
			target: createEditorToolbarTarget(activeEditor),
			surface: "body",
			isEditable: activeEditor.isEditable,
			selectionEmpty: resolveSelectionEmpty(activeEditor),
			editor: activeEditor
		}
	};
};
var buildCommandStateMap = ({ commands = [], superdoc, context, toolbarRegistry }) => {
	const entries = commands.map((command) => {
		const entry = toolbarRegistry[command];
		if (!entry) return [command, {
			active: false,
			disabled: true
		}];
		try {
			return [command, entry.state({
				context,
				superdoc
			})];
		} catch {
			return [command, {
				active: false,
				disabled: true
			}];
		}
	});
	return Object.fromEntries(entries);
};
const createToolbarSnapshot = ({ superdoc, commands = [], toolbarRegistry }) => {
	const { context } = resolveToolbarSources(superdoc);
	return {
		context,
		commands: buildCommandStateMap({
			commands,
			superdoc,
			context,
			toolbarRegistry
		})
	};
};
const resolveStateEditor = (context) => {
	if (!context) return null;
	return context.editor ?? context.presentationEditor?.getActiveEditor() ?? null;
};
const getCurrentParagraphParent = (context) => {
	const stateEditor = resolveStateEditor(context);
	const selection = stateEditor?.state?.selection;
	if (!stateEditor || !selection) return null;
	return findParentNode((node) => node.type.name === "paragraph")(selection);
};
const getCurrentResolvedParagraphProperties = (context) => {
	const paragraphParent = getCurrentParagraphParent(context);
	const stateEditor = resolveStateEditor(context);
	if (!stateEditor || !paragraphParent) return null;
	return calculateResolvedParagraphProperties(stateEditor, paragraphParent.node, stateEditor.state.doc.resolve(paragraphParent.pos));
};
const isFieldAnnotationSelection = (context) => {
	const selection = resolveStateEditor(context)?.state?.selection;
	return selection instanceof NodeSelection && selection?.node?.type?.name === "fieldAnnotation";
};
var isContentLockedStructuredContentNode = (node) => {
	return isStructuredContentNodeType(node?.type?.name) && isContentLockedMode(node?.attrs?.lockMode);
};
var resolvedPositionHasContentLockedStructuredContent = ($pos) => {
	if (!$pos || typeof $pos.depth !== "number" || typeof $pos.node !== "function") return false;
	for (let depth = $pos.depth; depth > 0; depth -= 1) if (isContentLockedStructuredContentNode($pos.node(depth))) return true;
	return false;
};
const hasContentLockedStructuredContentSelection = (context) => {
	const state = resolveStateEditor(context)?.state;
	const selection = state?.selection;
	const doc = state?.doc;
	if (!selection || !doc) return false;
	if (selection instanceof NodeSelection && isContentLockedStructuredContentNode(selection.node)) return true;
	if (resolvedPositionHasContentLockedStructuredContent(selection.$from) || resolvedPositionHasContentLockedStructuredContent(selection.$to)) return true;
	if (typeof doc.nodesBetween !== "function" || selection.from == null || selection.to == null) return false;
	let hasLockedNode = false;
	doc.nodesBetween(selection.from, selection.to, (node) => {
		if (isContentLockedStructuredContentNode(node)) {
			hasLockedNode = true;
			return false;
		}
		return !hasLockedNode;
	});
	return hasLockedNode;
};
var subscribeToSuperdocEvents = (superdoc, onChange) => {
	if (!superdoc?.on || !superdoc?.off) return null;
	superdoc.on("editorCreate", onChange);
	superdoc.on("document-mode-change", onChange);
	superdoc.on("formatting-marks-change", onChange);
	superdoc.on("zoomChange", onChange);
	return () => {
		superdoc.off?.("editorCreate", onChange);
		superdoc.off?.("document-mode-change", onChange);
		superdoc.off?.("formatting-marks-change", onChange);
		superdoc.off?.("zoomChange", onChange);
	};
};
var subscribeToEditorEvents = (editor, onChange) => {
	if (!editor?.on || !editor?.off) return null;
	editor.on("focus", onChange);
	editor.on("selectionUpdate", onChange);
	editor.on("transaction", onChange);
	return () => {
		editor.off?.("focus", onChange);
		editor.off?.("selectionUpdate", onChange);
		editor.off?.("transaction", onChange);
	};
};
var subscribeToPresentationEvents = (presentationEditor, onChange) => {
	if (!presentationEditor?.on || !presentationEditor?.off) return null;
	presentationEditor.on("headerFooterEditingContext", onChange);
	presentationEditor.on("headerFooterUpdate", onChange);
	presentationEditor.on("headerFooterTransaction", onChange);
	presentationEditor.on("activeSurfaceChange", onChange);
	presentationEditor.on("historyStateChange", onChange);
	return () => {
		presentationEditor.off?.("headerFooterEditingContext", onChange);
		presentationEditor.off?.("headerFooterUpdate", onChange);
		presentationEditor.off?.("headerFooterTransaction", onChange);
		presentationEditor.off?.("activeSurfaceChange", onChange);
		presentationEditor.off?.("historyStateChange", onChange);
	};
};
const subscribeToolbarEvents = (options, onChange) => {
	const { activeEditor: editor, presentationEditor } = resolveToolbarSources(options.superdoc);
	const unbindSuperdocEvents = subscribeToSuperdocEvents(options.superdoc, onChange);
	const unbindEditorEvents = subscribeToEditorEvents(editor, onChange);
	const unbindPresentationEvents = subscribeToPresentationEvents(presentationEditor, onChange);
	return () => {
		unbindEditorEvents?.();
		unbindPresentationEvents?.();
		unbindSuperdocEvents?.();
	};
};
const isCommandDisabled = (context) => {
	if (!context || !context.isEditable) return true;
	return (context.presentationEditor?.editor ?? context.editor)?.options?.documentMode === "viewing";
};
const isMutationCommandDisabled = (context) => {
	return isCommandDisabled(context) || hasContentLockedStructuredContentSelection(context);
};
const createDisabledStateDeriver = (options) => ({ context }) => {
	const disabled = isMutationCommandDisabled(context);
	if (options?.withValue) return {
		active: false,
		disabled,
		value: null
	};
	return {
		active: false,
		disabled
	};
};
const createDirectCommandExecute = (commandName) => ({ context, payload }) => {
	const editor = resolveStateEditor(context);
	const command = commandName ? editor?.commands[commandName] : null;
	if (typeof command !== "function") return false;
	const result = payload === void 0 ? command() : command(payload);
	return Boolean(result);
};
var readCoordinatorDepths = (context) => {
	const state = context?.presentationEditor?.getHistoryState?.();
	if (!state) return null;
	return {
		undoDepth: state.undoDepth,
		redoDepth: state.redoDepth
	};
};
const getCurrentUndoDepth = (context) => {
	const coordinatorDepths = readCoordinatorDepths(context);
	if (coordinatorDepths) return coordinatorDepths.undoDepth;
	const stateEditor = resolveStateEditor(context);
	if (!stateEditor?.state) return 0;
	try {
		if (stateEditor.options?.ydoc) return (yUndoPluginKey.getState(stateEditor.state)?.undoManager)?.undoStack?.length ?? 0;
		return undoDepth(stateEditor.state);
	} catch {
		return 0;
	}
};
const getCurrentRedoDepth = (context) => {
	const coordinatorDepths = readCoordinatorDepths(context);
	if (coordinatorDepths) return coordinatorDepths.redoDepth;
	const stateEditor = resolveStateEditor(context);
	if (!stateEditor?.state) return 0;
	try {
		if (stateEditor.options?.ydoc) return (yUndoPluginKey.getState(stateEditor.state)?.undoManager)?.redoStack?.length ?? 0;
		return redoDepth(stateEditor.state);
	} catch {
		return 0;
	}
};
const createDocumentOperationCapabilityStateDeriver = (operationId) => ({ context }) => {
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	const doc = context?.target?.doc;
	if (typeof doc?.capabilities !== "function") return {
		active: false,
		disabled: true
	};
	try {
		return {
			active: false,
			disabled: !Boolean(doc.capabilities().operations[operationId]?.available)
		};
	} catch {
		return {
			active: false,
			disabled: true
		};
	}
};
const createHistoryStateDeriver = (kind) => ({ context }) => {
	if (isCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	return {
		active: false,
		disabled: (kind === "undo" ? getCurrentUndoDepth(context) : getCurrentRedoDepth(context)) === 0
	};
};
const createRulerStateDeriver = () => ({ context, superdoc }) => {
	return {
		active: Boolean(superdoc?.config?.rulers),
		disabled: isCommandDisabled(context)
	};
};
const createFormattingMarksStateDeriver = () => ({ superdoc }) => {
	return {
		active: Boolean(superdoc?.config?.layoutEngineOptions?.showFormattingMarks),
		disabled: typeof superdoc?.toggleFormattingMarks !== "function"
	};
};
const createZoomStateDeriver = () => ({ context, superdoc }) => {
	return {
		active: false,
		disabled: !context,
		value: typeof superdoc?.getZoom === "function" ? superdoc.getZoom() : 100
	};
};
const createZoomFitWidthStateDeriver = () => ({ context, superdoc }) => {
	return {
		active: (typeof superdoc?.getZoomState === "function" ? superdoc.getZoomState()?.mode : void 0) === "fit-width",
		disabled: !context || typeof superdoc?.setZoomMode !== "function"
	};
};
const createDocumentModeStateDeriver = () => ({ context, superdoc }) => {
	return {
		active: false,
		disabled: !context,
		value: superdoc?.config?.documentMode ?? "editing"
	};
};
const createRulerExecute = () => ({ superdoc }) => {
	superdoc.toggleRuler?.();
	return true;
};
const createFormattingMarksExecute = () => ({ superdoc }) => {
	if (typeof superdoc?.toggleFormattingMarks !== "function") return false;
	superdoc.toggleFormattingMarks();
	return true;
};
const createZoomExecute = () => ({ superdoc, payload }) => {
	const normalizedPayload = Number.parseInt(String(payload), 10);
	if (!Number.isFinite(normalizedPayload) || normalizedPayload <= 0) return false;
	superdoc.setZoom?.(normalizedPayload);
	return true;
};
const createZoomFitWidthExecute = () => ({ superdoc }) => {
	if (typeof superdoc?.setZoomMode !== "function") return false;
	const mode = typeof superdoc.getZoomState === "function" ? superdoc.getZoomState()?.mode : void 0;
	superdoc.setZoomMode(mode === "fit-width" ? "manual" : "fit-width");
	return true;
};
const createDocumentModeExecute = () => ({ superdoc, payload }) => {
	const validModes = [
		"editing",
		"suggesting",
		"viewing"
	];
	const normalizedPayload = typeof payload === "string" ? payload.toLowerCase() : payload;
	if (typeof superdoc?.setDocumentMode !== "function" || typeof normalizedPayload !== "string" || !validModes.includes(normalizedPayload)) return false;
	superdoc.setDocumentMode(normalizedPayload);
	return true;
};
const isOffValue = (value) => {
	if (value == null) return false;
	const normalized = String(value).toLowerCase();
	return normalized === "0" || normalized === "false" || normalized === "off";
};
const negationChecks = {
	bold: (attrs = {}) => isOffValue(attrs.value),
	italic: (attrs = {}) => isOffValue(attrs.value),
	strike: (attrs = {}) => isOffValue(attrs.value),
	underline: (attrs = {}) => {
		const type = attrs.underlineType ?? attrs.value;
		if (type == null) return false;
		const normalized = String(type).toLowerCase();
		return normalized === "none" || isOffValue(normalized);
	},
	color: (attrs = {}) => {
		const value = attrs.color;
		if (value == null) return true;
		return String(value).toLowerCase() === "inherit";
	},
	highlight: (attrs = {}) => {
		const value = attrs.color;
		if (value == null) return true;
		const normalized = String(value).toLowerCase();
		return normalized === "transparent" || normalized === "none";
	}
};
const isNegatedMark = (name, attrs = {}) => {
	const checker = negationChecks[name];
	if (typeof checker !== "function") return false;
	return Boolean(checker(attrs));
};
var hasFormattingAttrs = (entry) => {
	return typeof entry.attrs === "object" && entry.attrs !== null;
};
var getFormattingAttr = (entries, name, attr) => {
	return entries.filter((entry) => entry.name === name && hasFormattingAttrs(entry)).map((entry) => entry.attrs[attr]).filter((value) => value != null);
};
const normalizeFontSizeValue = (value) => {
	if (typeof value === "number") return `${value}pt`;
	if (typeof value === "string") {
		const [numericValue, unit] = parseSizeUnit(value);
		if (!Number.isNaN(numericValue)) return `${numericValue}${unit || "pt"}`;
	}
	return value;
};
const normalizeFontFamilyValue = (value) => {
	if (typeof value !== "string") return value;
	return value;
};
const normalizeLinkHrefValue = (value) => {
	return typeof value === "string" && value.length > 0 ? value : null;
};
const normalizeColorValue = (value) => {
	if (typeof value === "string" && value.length > 0) return value.toLowerCase();
	return null;
};
const isFormattingActivatedFromLinkedStyle = (context, styleKey) => {
	const stateEditor = resolveStateEditor(context);
	if (!(stateEditor?.state?.selection)?.$from) return false;
	const styleId = getCurrentResolvedParagraphProperties(context)?.styleId;
	const linkedStyle = stateEditor?.converter?.linkedStyles?.find((style) => style.id === styleId);
	return Boolean(linkedStyle?.definition?.styles && styleKey in linkedStyle.definition.styles);
};
const hasNegatedFormattingMark = (formatting, markName) => {
	const rawActiveMark = formatting.find((mark) => mark.name === markName);
	if (!rawActiveMark || !hasFormattingAttrs(rawActiveMark)) return false;
	return isNegatedMark(rawActiveMark.name, rawActiveMark.attrs);
};
var isFormatCommandsStorage = (value) => {
	return typeof value === "object" && value !== null && "storedStyle" in value;
};
var hasStoredCopyFormat = (context) => {
	const formatCommands = resolveStateEditor(context)?.storage?.formatCommands;
	return isFormatCommandsStorage(formatCommands) && Boolean(formatCommands.storedStyle);
};
const createBoldStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	const isActiveFromMark = formatting.some((mark) => mark.name === "bold");
	const markNegated = hasNegatedFormattingMark(formatting, "bold");
	const activeFromLinkedStyle = !isActiveFromMark && !markNegated ? isFormattingActivatedFromLinkedStyle(context, "bold") : false;
	return {
		active: isActiveFromMark || activeFromLinkedStyle,
		disabled: false
	};
};
const createItalicStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	return {
		active: !hasNegatedFormattingMark(formatting, "italic") && formatting.some((mark) => mark.name === "italic"),
		disabled: false
	};
};
const createUnderlineStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	return {
		active: !hasNegatedFormattingMark(formatting, "underline") && formatting.some((mark) => mark.name === "underline"),
		disabled: false
	};
};
const createStrikethroughStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	return {
		active: !hasNegatedFormattingMark(formatting, "strike") && formatting.some((mark) => mark.name === "strike"),
		disabled: false
	};
};
const createCopyFormatStateDeriver = () => ({ context }) => {
	return {
		active: hasStoredCopyFormat(context),
		disabled: isMutationCommandDisabled(context)
	};
};
const createFontSizeStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const normalizedValues = getFormattingAttr(formatting, "fontSize", "fontSize").map((value$1) => normalizeFontSizeValue(value$1));
	const uniqueValues = [...new Set(normalizedValues)];
	const hasDirectValue = uniqueValues.length > 0;
	const canUseLinkedStyle = !hasDirectValue && isFormattingActivatedFromLinkedStyle(context, "font-size");
	const paragraphProps = canUseLinkedStyle ? getCurrentResolvedParagraphProperties(context) : null;
	const documentEditor = context?.presentationEditor?.editor ?? context?.editor ?? null;
	const linkedStyleValue = normalizeFontSizeValue((canUseLinkedStyle ? documentEditor?.converter?.linkedStyles?.find((style) => style.id === paragraphProps?.styleId) : null)?.definition?.styles?.["font-size"]) ?? null;
	const value = uniqueValues.length === 1 ? uniqueValues[0] : linkedStyleValue;
	return {
		active: hasDirectValue || linkedStyleValue != null,
		disabled: false,
		value
	};
};
const createFontFamilyStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const normalizedValues = getFormattingAttr(formatting, "fontFamily", "fontFamily").map((value$1) => normalizeFontFamilyValue(value$1));
	const uniqueValues = [...new Set(normalizedValues)];
	const canUseLinkedStyle = !(uniqueValues.length > 0) && isFormattingActivatedFromLinkedStyle(context, "font-family");
	const paragraphProps = canUseLinkedStyle ? getCurrentResolvedParagraphProperties(context) : null;
	const documentEditor = context?.presentationEditor?.editor ?? context?.editor ?? null;
	const linkedStyleValue = normalizeFontFamilyValue((canUseLinkedStyle ? documentEditor?.converter?.linkedStyles?.find((style) => style.id === paragraphProps?.styleId) : null)?.definition?.styles?.["font-family"]) ?? null;
	const value = uniqueValues.length === 1 ? uniqueValues[0] : linkedStyleValue;
	return {
		active: uniqueValues.length > 0 || linkedStyleValue != null,
		disabled: false,
		value
	};
};
const createTextColorStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const values = getFormattingAttr(formatting, "color", "color");
	const markNegated = hasNegatedFormattingMark(formatting, "color");
	const normalizedValues = values.map((value$1) => normalizeColorValue(value$1));
	const uniqueValues = [...new Set(normalizedValues)];
	const value = uniqueValues.length === 1 ? uniqueValues[0] : null;
	return {
		active: !markNegated && uniqueValues.length > 0,
		disabled: false,
		value
	};
};
const createHighlightColorStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const values = getFormattingAttr(formatting, "highlight", "color");
	const markNegated = hasNegatedFormattingMark(formatting, "highlight");
	const normalizedValues = values.map((value$1) => normalizeColorValue(value$1));
	const uniqueValues = [...new Set(normalizedValues)];
	const value = uniqueValues.length === 1 ? uniqueValues[0] : null;
	return {
		active: !markNegated && uniqueValues.length > 0,
		disabled: false,
		value
	};
};
const createLinkStateDeriver = () => ({ context }) => {
	const stateEditor = resolveStateEditor(context);
	const formatting = stateEditor ? getActiveFormatting(stateEditor) : [];
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const normalizedValues = getFormattingAttr(formatting, "link", "href").map((value$1) => normalizeLinkHrefValue(value$1));
	const uniqueValues = [...new Set(normalizedValues)];
	const value = uniqueValues.length === 1 ? uniqueValues[0] : null;
	return {
		active: uniqueValues.length > 0,
		disabled: false,
		value
	};
};
const createBoldExecute = () => ({ context, payload }) => {
	const editor = resolveStateEditor(context);
	if (isFieldAnnotationSelection(context)) {
		editor?.commands?.toggleFieldAnnotationsFormat?.("bold", true);
		return true;
	}
	if (!createDirectCommandExecute("toggleBold")({
		context,
		payload
	})) return false;
	editor?.commands?.toggleFieldAnnotationsFormat?.("bold", true);
	return true;
};
const createItalicExecute = () => ({ context, payload }) => {
	const editor = resolveStateEditor(context);
	if (isFieldAnnotationSelection(context)) {
		editor?.commands?.toggleFieldAnnotationsFormat?.("italic", true);
		return true;
	}
	if (!createDirectCommandExecute("toggleItalic")({
		context,
		payload
	})) return false;
	editor?.commands?.toggleFieldAnnotationsFormat?.("italic", true);
	return true;
};
const createUnderlineExecute = () => ({ context, payload }) => {
	const editor = resolveStateEditor(context);
	if (isFieldAnnotationSelection(context)) {
		editor?.commands?.toggleFieldAnnotationsFormat?.("underline", true);
		return true;
	}
	if (!createDirectCommandExecute("toggleUnderline")({
		context,
		payload
	})) return false;
	editor?.commands?.toggleFieldAnnotationsFormat?.("underline", true);
	return true;
};
const createFontSizeExecute = () => ({ context, payload }) => {
	if (payload === void 0) return false;
	const editor = resolveStateEditor(context);
	if (isFieldAnnotationSelection(context)) {
		editor?.commands?.setFieldAnnotationsFontSize?.(payload, true);
		return true;
	}
	if (!createDirectCommandExecute("setFontSize")({
		context,
		payload
	})) return false;
	editor?.commands?.setFieldAnnotationsFontSize?.(payload, true);
	return true;
};
const createFontFamilyExecute = () => ({ context, payload }) => {
	if (payload === void 0) return false;
	const editor = resolveStateEditor(context);
	if (isFieldAnnotationSelection(context)) {
		editor?.commands?.setFieldAnnotationsFontFamily?.(payload, true);
		return true;
	}
	if (!createDirectCommandExecute("setFontFamily")({
		context,
		payload
	})) return false;
	editor?.commands?.setFieldAnnotationsFontFamily?.(payload, true);
	return true;
};
const createTextColorExecute = () => ({ context, payload }) => {
	const editor = resolveStateEditor(context);
	if (typeof payload !== "string" || payload.length === 0) return false;
	const isNone = payload === "none";
	const inlineValue = isNone ? "inherit" : payload;
	const result = createDirectCommandExecute("setColor")({
		context,
		payload: inlineValue
	});
	editor?.commands?.setFieldAnnotationsTextColor?.(isNone ? null : payload, true);
	return result;
};
const createHighlightColorExecute = () => ({ context, payload }) => {
	const editor = resolveStateEditor(context);
	if (typeof payload !== "string" || payload.length === 0) return false;
	const isNone = payload === "none";
	const inlineValue = isNone ? "transparent" : payload;
	const result = createDirectCommandExecute("setHighlight")({
		context,
		payload: inlineValue
	});
	const argValue = isNone ? null : payload;
	editor?.commands?.setFieldAnnotationsTextHighlight?.(argValue, true);
	editor?.commands?.setCellBackground?.(argValue);
	return result;
};
var applyLinkPostExecute = (editor) => {
	const { view } = editor;
	let selection = view.state.selection;
	if (editor.options?.isHeaderOrFooter && editor.options?.lastSelection) selection = editor.options.lastSelection;
	const endPos = selection?.$to?.pos;
	if (typeof endPos !== "number") return;
	try {
		const newSelection = new TextSelection(view.state.doc.resolve(endPos));
		const tr = view.state.tr.setSelection(newSelection);
		const state = view.state.apply(tr);
		view.updateState(state);
		if (!editor.options?.isHeaderOrFooter) setTimeout(() => {
			view.focus();
		}, 100);
	} catch {
		return;
	}
};
const createLinkExecute = () => ({ context, payload }) => {
	const editor = resolveStateEditor(context);
	const result = createDirectCommandExecute("toggleLink")({
		context,
		payload
	});
	if (!result || !editor?.view) return result;
	applyLinkPostExecute(editor);
	return true;
};
const createImageExecute = () => ({ context }) => {
	const editor = resolveStateEditor(context);
	if (!editor?.view) return false;
	getFileOpener()().then(async (result) => {
		if (!result?.file) return;
		await processAndInsertImageFile({
			file: result.file,
			editor,
			view: editor.view,
			editorOptions: editor.options,
			getMaxContentSize: () => editor.getMaxContentSize()
		});
	}).catch((err) => {
		const originalError = err instanceof Error ? err : new Error(String(err));
		const error = /* @__PURE__ */ new Error(`[headless-toolbar] Image insertion failed: ${originalError.message}`);
		editor?.emit?.("exception", {
			error,
			editor
		});
		console.error(error, originalError);
	});
	return true;
};
var getCurrentParagraphJustification = (context) => {
	const paragraphProperties = getCurrentResolvedParagraphProperties(context);
	return mapStoredJustificationToDisplayAlignment(paragraphProperties?.justification ?? null, paragraphProperties?.rightToLeft === true);
};
const createParagraphDirectionStateDeriver = (direction) => ({ context }) => {
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const current = getCurrentResolvedParagraphProperties(context)?.rightToLeft ? "rtl" : "ltr";
	return {
		active: current === direction,
		disabled: false,
		value: current
	};
};
const createParagraphDirectionExecute = (direction) => ({ context }) => {
	const command = resolveStateEditor(context)?.commands.setParagraphDirection;
	if (typeof command !== "function") return false;
	return Boolean(command({
		direction,
		alignmentPolicy: "matchDirection"
	}));
};
const createTextAlignStateDeriver = () => ({ context }) => {
	if (isCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const value = getCurrentParagraphJustification(context) ?? null;
	return {
		active: value != null,
		disabled: false,
		value
	};
};
const createLineHeightStateDeriver = () => ({ context }) => {
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true,
		value: null
	};
	const line = getCurrentResolvedParagraphProperties(context)?.spacing?.line;
	const value = line != null ? twipsToLines(line) : null;
	return {
		active: value != null,
		disabled: false,
		value
	};
};
const createLinkedStyleStateDeriver = () => ({ context }) => {
	const isDisabled = isMutationCommandDisabled(context);
	const stateEditor = resolveStateEditor(context);
	if (isDisabled || !stateEditor) return {
		active: false,
		disabled: true,
		value: null
	};
	if (!getQuickFormatList(stateEditor).length) return {
		active: false,
		disabled: true,
		value: null
	};
	const value = getCurrentResolvedParagraphProperties(context)?.styleId ?? null;
	return {
		active: value != null,
		disabled: false,
		value
	};
};
const createListStateDeriver = (numberingType) => ({ context }) => {
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	const paragraphNode = getCurrentParagraphParent(context)?.node ?? null;
	const paragraphProperties = getCurrentResolvedParagraphProperties(context);
	const activeNumberingType = isList(paragraphNode) || Boolean(paragraphProperties?.numberingProperties && paragraphNode?.attrs?.listRendering) ? paragraphNode?.attrs?.listRendering?.numberingType : null;
	const isActive = numberingType === "bullet" ? activeNumberingType === "bullet" : activeNumberingType != null && activeNumberingType !== "bullet";
	if (numberingType === "bullet") return {
		active: isActive,
		disabled: false,
		value: isActive ? paragraphNode?.attrs?.listRendering?.markerText ?? null : null
	};
	const activeNumberingFmt = isActive ? paragraphNode?.attrs?.listRendering?.numberingType ?? null : null;
	const activeMarkerText = isActive ? paragraphNode?.attrs?.listRendering?.markerText ?? null : null;
	return {
		active: isActive,
		disabled: false,
		value: activeNumberingFmt && activeMarkerText ? numberingInfoToOrderedStyle(activeNumberingFmt, activeMarkerText) : null
	};
};
const createIndentIncreaseExecute = () => ({ context }) => {
	if (resolveStateEditor(context)?.commands?.increaseListIndent?.()) return true;
	return createDirectCommandExecute("increaseTextIndent")({ context });
};
var createListToggleExecute = (styleCommand, legacyCommand) => ({ context, payload }) => {
	const commands = resolveStateEditor(context)?.commands;
	if (typeof commands?.[styleCommand] === "function") {
		const result = payload === void 0 ? commands[styleCommand]() : commands[styleCommand](payload);
		return Boolean(result);
	}
	if (typeof commands?.[legacyCommand] === "function") return Boolean(commands[legacyCommand]());
	return false;
};
const createBulletListExecute = () => createListToggleExecute("toggleBulletListStyle", "toggleBulletList");
const createOrderedListExecute = () => createListToggleExecute("toggleOrderedListStyle", "toggleOrderedList");
const createIndentDecreaseExecute = () => ({ context }) => {
	if (resolveStateEditor(context)?.commands?.decreaseListIndent?.()) return true;
	return createDirectCommandExecute("decreaseTextIndent")({ context });
};
const createTableOfContentsInsertExecute = () => ({ context }) => {
	const editor = resolveStateEditor(context);
	if (!editor) return false;
	return insertTableOfContentsAtSelection(editor);
};
const createTableActionsStateDeriver = () => ({ context }) => {
	const editor = resolveStateEditor(context);
	const inTable = editor?.state?.selection?.$head ? isInTable(editor.state) : false;
	return {
		active: false,
		disabled: isMutationCommandDisabled(context) || !inTable
	};
};
var lookupCommentByCommentId = (superdoc, commentId) => {
	if (typeof superdoc?.getComment === "function") return superdoc.getComment(commentId) ?? null;
	const store = superdoc?.commentsStore;
	if (typeof store?.getComment === "function") return store.getComment(commentId) ?? null;
	return null;
};
var enrichTrackedChanges = (trackedChanges = [], superdoc) => {
	if (!trackedChanges.length) return trackedChanges;
	return trackedChanges.map((change) => {
		const commentId = change.id;
		if (!commentId) return change;
		const storeComment = lookupCommentByCommentId(superdoc, commentId);
		if (!storeComment) return change;
		const comment = typeof storeComment.getValues === "function" ? storeComment.getValues() : storeComment;
		return {
			...change,
			comment
		};
	});
};
const createTrackChangesSelectionActionStateDeriver = (action) => ({ context, superdoc }) => {
	if (isMutationCommandDisabled(context)) return {
		active: false,
		disabled: true
	};
	const editor = resolveStateEditor(context);
	const state = editor?.state;
	const selection = state?.selection;
	if (!editor || !state?.doc || !selection) return {
		active: false,
		disabled: true
	};
	const trackedChanges = enrichTrackedChanges(collectTrackedChanges({
		state,
		from: selection.from,
		to: selection.to
	}), superdoc);
	if (!trackedChanges.length) return {
		active: false,
		disabled: true
	};
	return {
		active: false,
		disabled: !isTrackedChangeActionAllowed({
			editor,
			action,
			trackedChanges
		})
	};
};
const createToolbarRegistry = () => {
	return {
		bold: {
			id: "bold",
			directCommandName: "toggleBold",
			state: createBoldStateDeriver(),
			execute: createBoldExecute()
		},
		italic: {
			id: "italic",
			directCommandName: "toggleItalic",
			state: createItalicStateDeriver(),
			execute: createItalicExecute()
		},
		underline: {
			id: "underline",
			directCommandName: "toggleUnderline",
			state: createUnderlineStateDeriver(),
			execute: createUnderlineExecute()
		},
		strikethrough: {
			id: "strikethrough",
			directCommandName: "toggleStrike",
			state: createStrikethroughStateDeriver()
		},
		"font-size": {
			id: "font-size",
			directCommandName: "setFontSize",
			state: createFontSizeStateDeriver(),
			execute: createFontSizeExecute()
		},
		"font-family": {
			id: "font-family",
			directCommandName: "setFontFamily",
			state: createFontFamilyStateDeriver(),
			execute: createFontFamilyExecute()
		},
		"text-color": {
			id: "text-color",
			directCommandName: "setColor",
			state: createTextColorStateDeriver(),
			execute: createTextColorExecute()
		},
		"highlight-color": {
			id: "highlight-color",
			directCommandName: "setHighlight",
			state: createHighlightColorStateDeriver(),
			execute: createHighlightColorExecute()
		},
		link: {
			id: "link",
			directCommandName: "toggleLink",
			state: createLinkStateDeriver(),
			execute: createLinkExecute()
		},
		"text-align": {
			id: "text-align",
			directCommandName: "setTextAlign",
			state: createTextAlignStateDeriver()
		},
		"line-height": {
			id: "line-height",
			directCommandName: "setLineHeight",
			state: createLineHeightStateDeriver()
		},
		"linked-style": {
			id: "linked-style",
			directCommandName: "setLinkedStyle",
			state: createLinkedStyleStateDeriver(),
			execute: createDirectCommandExecute("setLinkedStyle")
		},
		"bullet-list": {
			id: "bullet-list",
			directCommandName: "toggleBulletListStyle",
			state: createListStateDeriver("bullet"),
			execute: createBulletListExecute()
		},
		"numbered-list": {
			id: "numbered-list",
			directCommandName: "toggleOrderedListStyle",
			state: createListStateDeriver("ordered"),
			execute: createOrderedListExecute()
		},
		"indent-increase": {
			id: "indent-increase",
			state: createDisabledStateDeriver(),
			execute: createIndentIncreaseExecute()
		},
		"indent-decrease": {
			id: "indent-decrease",
			state: createDisabledStateDeriver(),
			execute: createIndentDecreaseExecute()
		},
		"direction-ltr": {
			id: "direction-ltr",
			directCommandName: "setParagraphDirection",
			state: createParagraphDirectionStateDeriver("ltr"),
			execute: createParagraphDirectionExecute("ltr")
		},
		"direction-rtl": {
			id: "direction-rtl",
			directCommandName: "setParagraphDirection",
			state: createParagraphDirectionStateDeriver("rtl"),
			execute: createParagraphDirectionExecute("rtl")
		},
		undo: {
			id: "undo",
			directCommandName: "undo",
			state: createHistoryStateDeriver("undo")
		},
		redo: {
			id: "redo",
			directCommandName: "redo",
			state: createHistoryStateDeriver("redo")
		},
		ruler: {
			id: "ruler",
			state: createRulerStateDeriver(),
			execute: createRulerExecute()
		},
		"formatting-marks": {
			id: "formatting-marks",
			state: createFormattingMarksStateDeriver(),
			execute: createFormattingMarksExecute()
		},
		zoom: {
			id: "zoom",
			state: createZoomStateDeriver(),
			execute: createZoomExecute()
		},
		"zoom-fit-width": {
			id: "zoom-fit-width",
			state: createZoomFitWidthStateDeriver(),
			execute: createZoomFitWidthExecute()
		},
		"document-mode": {
			id: "document-mode",
			state: createDocumentModeStateDeriver(),
			execute: createDocumentModeExecute()
		},
		"clear-formatting": {
			id: "clear-formatting",
			directCommandName: "clearFormat",
			state: createDisabledStateDeriver()
		},
		"copy-format": {
			id: "copy-format",
			directCommandName: "copyFormat",
			state: createCopyFormatStateDeriver()
		},
		"track-changes-accept-selection": {
			id: "track-changes-accept-selection",
			directCommandName: "acceptTrackedChangeFromToolbar",
			state: createTrackChangesSelectionActionStateDeriver("accept")
		},
		"track-changes-reject-selection": {
			id: "track-changes-reject-selection",
			directCommandName: "rejectTrackedChangeFromToolbar",
			state: createTrackChangesSelectionActionStateDeriver("reject")
		},
		image: {
			id: "image",
			state: createDisabledStateDeriver(),
			execute: createImageExecute()
		},
		"table-of-contents-insert": {
			id: "table-of-contents-insert",
			state: createDocumentOperationCapabilityStateDeriver("create.tableOfContents"),
			execute: createTableOfContentsInsertExecute()
		},
		"table-insert": {
			id: "table-insert",
			directCommandName: "insertTable",
			state: createDisabledStateDeriver(),
			execute: createDirectCommandExecute("insertTable")
		},
		"table-add-row-before": {
			id: "table-add-row-before",
			directCommandName: "addRowBefore",
			state: createTableActionsStateDeriver()
		},
		"table-add-row-after": {
			id: "table-add-row-after",
			directCommandName: "addRowAfter",
			state: createTableActionsStateDeriver()
		},
		"table-delete-row": {
			id: "table-delete-row",
			directCommandName: "deleteRow",
			state: createTableActionsStateDeriver()
		},
		"table-add-column-before": {
			id: "table-add-column-before",
			directCommandName: "addColumnBefore",
			state: createTableActionsStateDeriver()
		},
		"table-add-column-after": {
			id: "table-add-column-after",
			directCommandName: "addColumnAfter",
			state: createTableActionsStateDeriver()
		},
		"table-delete-column": {
			id: "table-delete-column",
			directCommandName: "deleteColumn",
			state: createTableActionsStateDeriver()
		},
		"table-delete": {
			id: "table-delete",
			directCommandName: "deleteTable",
			state: createTableActionsStateDeriver()
		},
		"table-merge-cells": {
			id: "table-merge-cells",
			directCommandName: "mergeCells",
			state: createTableActionsStateDeriver()
		},
		"table-split-cell": {
			id: "table-split-cell",
			directCommandName: "splitCell",
			state: createTableActionsStateDeriver()
		},
		"table-remove-borders": {
			id: "table-remove-borders",
			directCommandName: "deleteCellAndTableBorders",
			state: createTableActionsStateDeriver()
		},
		"table-fix": {
			id: "table-fix",
			directCommandName: "fixTables",
			state: createTableActionsStateDeriver()
		}
	};
};
var executeDirectCommand = (id, snapshot, toolbarRegistry, payload) => {
	const commandName = toolbarRegistry[id]?.directCommandName;
	const command = commandName ? snapshot.context?.target?.commands?.[commandName] : null;
	if (typeof command !== "function") return false;
	const result = payload === void 0 ? command() : command(payload);
	return typeof result === "boolean" ? result : Boolean(result);
};
var executeRegistryCommand = (id, superdoc, snapshot, toolbarRegistry, payload) => {
	const entry = toolbarRegistry[id];
	if (!entry) return false;
	if (typeof entry.execute === "function") return entry.execute({
		context: snapshot.context,
		superdoc,
		payload
	});
	return executeDirectCommand(id, snapshot, toolbarRegistry, payload);
};
var CONTENT_LOCK_EXECUTION_EXEMPT_IDS = new Set([
	"undo",
	"redo",
	"ruler",
	"formatting-marks",
	"zoom",
	"document-mode"
]);
var isToolbarCommandExecutionDisabled = (id, superdoc, snapshot, toolbarRegistry) => {
	const snapshotState = snapshot.commands[id];
	if (snapshotState) return snapshotState.disabled;
	if (CONTENT_LOCK_EXECUTION_EXEMPT_IDS.has(id) || !hasContentLockedStructuredContentSelection(snapshot.context)) return false;
	const entry = toolbarRegistry[id];
	if (!entry) return false;
	try {
		return entry.state({
			context: snapshot.context,
			superdoc
		}).disabled;
	} catch {
		return true;
	}
};
const createHeadlessToolbar = (options) => {
	const listeners = /* @__PURE__ */ new Set();
	const toolbarRegistry = createToolbarRegistry();
	const buildSnapshot = () => {
		return createToolbarSnapshot({
			...options,
			toolbarRegistry
		});
	};
	let snapshot = buildSnapshot();
	let destroyed = false;
	let unsubscribeEvents = null;
	const notifyListeners = () => {
		listeners.forEach((listener) => listener({ snapshot }));
	};
	const rebindEvents = () => {
		unsubscribeEvents?.();
		unsubscribeEvents = subscribeToolbarEvents(options, handleChange);
	};
	const rebuildSnapshot = () => {
		snapshot = buildSnapshot();
	};
	const refreshControllerState = () => {
		rebuildSnapshot();
		rebindEvents();
		notifyListeners();
	};
	const handleChange = () => {
		if (destroyed) return;
		refreshControllerState();
	};
	rebindEvents();
	return {
		getSnapshot() {
			return snapshot;
		},
		subscribe(listener) {
			if (destroyed) return () => {};
			listeners.add(listener);
			listener({ snapshot });
			return () => {
				listeners.delete(listener);
			};
		},
		execute(id, payload) {
			if (isToolbarCommandExecutionDisabled(id, options.superdoc, snapshot, toolbarRegistry)) return false;
			const result = executeRegistryCommand(id, options.superdoc, snapshot, toolbarRegistry, payload);
			if (result && !destroyed) refreshControllerState();
			return result;
		},
		destroy() {
			if (destroyed) return;
			destroyed = true;
			unsubscribeEvents?.();
			unsubscribeEvents = null;
			listeners.clear();
		}
	};
};
export { resolveCreateAnchor as $, CustomSelectionPluginKey as $t, replaceStructuredWrapper as A, captureRunsInRange as At, executeCompiledPlan as B, findAllTocNodes as Bt, tocListWrapper as C, resolveSelectionTarget as Ct, disposeEphemeralWriteRuntime as D, isInlineQuery as Dt, STUB_WHERE as E, collectUnknownNodeDiagnostics as Et, resolveStoryFromRef as F, encodeV4Ref as Ft, executeSpanTextRewrite as G, getNormalizedImageAttrs as Gt, executePlan as H, processAndInsertImageFile as Ht, getInlinePropertyCapabilityIssue as I, applyTcPatch as It, executeTextInsert as J, generateUniqueDocPrId as Jt, executeStyleApply as K, ImagePositionPlugin as Kt, getTrackedInlinePropertySupportIssue as L, areTcConfigsEqual as Lt, selectionMutationWrapper as M, isSimpleToggleOffValue as Mt, writeWrapper as N, registerStepExecutor as Nt, executeDomainCommand as O, shouldQueryBothKinds as Ot, resolveStoryFromInput as P, decodeRef as Pt, resolveBlockInsertionPos as Q, mapDisplayAlignmentToStoredJustification as Qt, executeStructuralInsert as R, parseTcInstruction as Rt, tocGetWrapper as S, resolveSelectionPointPosition as St, tocUpdateWrapper as T, executeTextSelector as Tt, executeSpanStyleApply as U, getFileOpener as Ut, executeCreateStep as V, parseTocInstruction as Vt, executeSpanTextDelete as W, getRotationMargins as Wt, runMutationsOnTransaction as X, isContentLockedMode as Xt, executeTextRewrite as Y, getAllowedImageDimensions as Yt, myersDiff as Z, isSdtLockedMode as Zt, insertTableOfContentsAtSelection as _, paragraphsSetShadingWrapper as _t, collectTrackedChangesForContext as a, releaseSelectionHandle as an, paragraphsClearShadingWrapper as at, prepareTableOfContentsInsertion as b, paragraphsSetTabStopWrapper as bt, getChangeAuthorIdentity as c, actorIdentitiesMatch as cn, paragraphsClearTabStopWrapper as ct, matchesSameUserRefinement as d, normalizeActorEmail as dn, paragraphsSetBorderWrapper as dt, captureSelectionHandle as en, paragraphsClearAlignmentWrapper as et, shouldCollapseNoEmailInsertion as f, normalizeActorName as fn, paragraphsSetDirectionWrapper as ft, getQuickFormatList as g, paragraphsSetOutlineLevelWrapper as gt, generateLinkedStyleString as h, paragraphsSetKeepOptionsWrapper as ht, collectTrackedChanges as i, prepareSelectionForTextInputHandoff as in, paragraphsClearIndentationWrapper as it, resolveWriteStoryRuntime as j, deriveToggleState as jt, insertStructuredWrapper as k, sortAddressesByPosition as kt, getCurrentUserIdentity as l, getActorIdentity as ln, paragraphsResetDirectFormattingWrapper as lt, LinkedStylesPluginKey as m, paragraphsSetIndentationWrapper as mt, createToolbarRegistry as n, createSelectionTrackingBookmark as nn, paragraphsClearBorderWrapper as nt, isTrackedChangeActionAllowed as o, resolveHandleToSelection as on, paragraphsClearSpacingWrapper as ot, LinkedStyles as p, parseSizeUnit as pn, paragraphsSetFlowOptionsWrapper as pt, executeTextDelete as q, ImageRegistrationPlugin as qt, resolveToolbarSources as r, getPreservedSelection as rn, paragraphsClearDirectionWrapper as rt, classifyOwnership as s, Extension as sn, paragraphsClearStyleWrapper as st, createHeadlessToolbar as t, createSelectionHandlePlugin as tn, paragraphsClearAllTabStopsWrapper as tt, isSameUserHighConfidence as u, getActorIdentityKey as un, paragraphsSetAlignmentWrapper as ut, resolveTableOfContentsCreateLocation as v, paragraphsSetSpacingWrapper as vt, tocRemoveWrapper as w, executeBlockSelector as wt, tocConfigureWrapper as x, compilePlan as xt, createTableOfContentsWrapper as y, paragraphsSetStyleWrapper as yt, executeStructuralReplace as z, serializeTcInstruction as zt };
